import AMAZON_BID_MAP from './amazon-bid-map.json';
import AMAZON_ADVERTISER_MAP from './amazon-advertiser-map.json';
import ALL_ADVERTISER_MAP from './all-advertiser-map.json';
import BANNER_CREATIVES_DIRECT_DEALS_MAP from './banner-creativeIds-direct-deals-map.json';
import LIVEINTENT_BRAND_MAP from './liveintent-brand-map.json';
import { initLiveIntent } from './liveintent';
import { initComscore } from './comscore';
import * as utils from './v2/utils';
import { getVastUrlForAmazonBid, blobToData } from './adsninja-bid-management';
import loadApstagExtensions from './amazon-apstag-extensions';
import ADX_EVENTS_MODIFIERS from './adx-event-modifiers';

window.pbjs     = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];

//
// Bidding Manager.
window.adsNinjaHeaderBiddingManager = {

    //  Constants.
    MODE_ADS_REGULAR: 1,
    MODE_ADS_NONE: 2,
    MODE_ADS_FAKE: 3,
    MAX_NUMBER_OF_NO_NEW_BID_AUCTIONS: 7,
    MAX_NUMBER_OF_REFLOATS: 2, 
    AD_CAPABILITY_FLOATING_TOP_MIDDLE: 'floatingTopMiddle',
    AD_CAPABILITY_VIDEO_VALSTREAM: 'videoValstream',
    AD_CAPABILITY_VIDEO_INSTREAM_VALSTREAM: 'videoInstreamValstream',
    AD_CAPABILITY_CAN_REMOVE_FLOATING_CLOSE_BUTTON: 'canRemoveFloatingCloseButton',
    PREBID_BID_MODE_VALSTREAM_INSTREAM: 'instream',
    PREBID_BID_MODE_VALSTREAM_OUTSTREAM: 'outstream',
    PREBID_BID_MODE_VALSTREAM_COMPANION: 'companion',
    PREBID_BID_MODE_VALSTREAM_ACCOMPANYING: 'accompanying',
    ID_USER_ACTIVITY_TYPE_LONGEST_STRETCH_OF_INACTIVITY: 1,
    ID_USER_ACTIVITY_TYPE_LAST_RECORDED_ACTIVITY: 2,
    ID_USER_ACTIVITY_TYPE_TOTAL_TIME_INACTIVE: 3,
    ID_USER_ACTIVITY_TYPE_TOTAL_TIME_TRACKING: 4,
    AMAZON_TTL: 120,
    BIDDING_LIBRARY_AMAZON: 'amazon',
    BIDDING_LIBRARY_PREBID: 'prebid',
    MAX_NUMBER_OF_NO_FILL_RETRIES: 3,
    PREBID_CREATIVE_IDS: [                  // TODO: Get these from AdsNinja.
        '138409893260',
        '138410473648',
        '138410473900',
        'prebid',
    ],
    AMAZON_CREATIVE_IDS: [
        '138412512682',
        '138424050572',
        '138424057469',
        '138424104372',
        '138424057442',
        '138424104612',
        '138434768315',
        '138434768321',
        '138434768483',
        '138434768489',
        '138434768498',
        '138434772542',
        '138476966472',
        '138477680287',
        '138477098303',
        '138434828292',
        '138434828271',
        '138434828283',
        '138434828124',
        '138434828298',
        '138434772533',
        '138435518341',
        '138434829945',
        '138434772539',
        'amazon',
    ],
    AMAZON_CONTENT_TAXONOMY: {
        "ScreenRant": "JLBCU7",
        "GameRant" : "680",
        "HotCars" : "1",
        "MakeUseOf" : "596",
        "AndroidPolice" : "596",
        "MovieWeb" : "JLBCU7",
        "Collider" : "JLBCU7",
        "TheSportster": "483",
        "TheThings" : "432",
        "TheTravel": "653",
        "TheGamer": "680",
        "TheTalko" : "432",
        "SimpleFlying" : "653",
        "XDA" : "596",
        "PocketNow" : "596",
        "TopSpeed" : "1",
        "DualShockers" : "680",
        "PocketLint" : "596",
        "BackYardBoss" : "274",
        "HardcoreGamer": "",
        "CarBuzz":"1q",        
        "HowToGeek": "596",
        "GiveMeSport" : "483",
        "FootballFanCast" : "483",
        "FootballLeagueWorld" : "483",
        "TheRichest": "432",
        "CBR": "239",
        "Moms": "186",
        "BabyGaga" : "186",
        "ThisIsFutbol" : "483",
        "FollowFollow" : "483",
        "TheCelticBlog" : "483",
        "VideoCelts" : "483",
        "TheGearLoop" : "596",
    },

    HOME_BACKFILL_LINE_ITEMS: [

        6701062456, //SR
        6703257803, // CBR
        6703264268, // GR
    ],

    USING_SOUND_COOKIE: false,

    adIdMap: {},
    auctions: {},
    amazonAdSlots: [],
    prebidAdUnits: [],
    triggerAuctionAdZones: {},
    autoRefreshAdZones: {},
    inBannerAdZones: {},
    refreshingAdZones: {},
    railAdZones: {},
    adZoneEventsLog: {},
    pixelRefreshers: {},
    bidPools: {},
    __adsData: {},
    __amazonBidSentToGAM:{},
    __prebidBidSentToGAM:{},
    __adZoneMapping: {},
    __initialized: false,
    __prebidTimeout: null,
    __amazonTimeout: null,
    __failsafeTimeout: null,
    __failsafeTimeoutCmp: null,
    __consentNeeded: false,
    __logData: {},
    __arePassiveEventListenersSupported: null,
    __previousDocumentHeight: 0,
    __bodyObserver: null,
    __firstAuctionCompleteEventListenersAndObserversRegistered: false,
    __modeAds: 1,
    __deviceType: null,
    __adCountData: null,
    __extendedSectionDataLog: [],
    __previousDocumentHeightRailAdZones: 0,
    __prebidServerAliasData: {},
    __adCapabilities: {},
    __videoList: [],
    sspsThatCouldHaveOwnCloseButton: {},
    __auctionDictionaryByAdElementId: {},
    logger: null,
    __floatingEventDictionary: {},
    __userActivityMonitor: null,
    __eventHelper: null,
    prebidAdUnitBidderConfigs: null,
    __eventTrackingDictionary: {},
    __refreshIntervals: {},
    __refreshTimeouts: {},
    __siteConfig: {},
    __autoScrollWaypoints: {},
    __numberOfConsecutiveNoNewBidAuctions: {},
    __videoAuctionsDisabled: {},
    __consentManager: null,
    __refloatCountByAd: {},
    __noFillCountByOrignalAd:{},
    adBehaviours: {},
    __bidPoolsEnabled: true,
    __namesForBidPoolsByZoneName: {},
    floatingDelegate: {},
    __hasLoadedInfiniteArticle: false,
    __primeGeos: {},
    __isPrebidDisabled: false,
    __isAdsDisabled: false,
    __connectionConfig: {},
    __adUnitSlotDetails: { amazon: {}, prebid: {}, },
    biddingProccessTrackingData: {},
    __requestsNotSentToGAMCounter: null,
    __videoCreativeBlacklist: [],
    __videoBidderBlacklist: [],
    __currentWaterfallBids: [],
    floatingInitializers: {},
    __boostingUrlData: {},
    __boostingModes:[],
    __refreshData: {},
    __usedVideoAdIds: {},
    __adRevenueReporter: null,
    __revenueRecorder: null,
    __pageGamId: null,
    __directDealsMapping: {},
    __prebid: null,
    __amazon: null,
    __version: 'v1',
    __adx_event_mutliplier: 0.5,
    __brandsServingVideosOutsideOfGAM: [
        'ScreenRant',
        'GameRant',
        'TheGamer',
        'CarBuzz',
        'TheThings',
        'FextraLife',
        'TheSportster',
        'CBR',
        'TheTravel',
        'HotCars',
        'MakeUseOf',
        'Collider',
        'AndroidPolice',
        'MovieWeb',
        'SimpleFlying',
        'XDA',
        'TopSpeed',
        'GiveMeSport',
        'FootballFanCast',
        'FootballLeagueWorld',
        'HowToGeek',
        'CBRForums',
        'XDAForums',
        'Polygon',
        'DualShockers',
        'PocketLint'
    ],
    __bannerEnabledEventTrackingBrand: [
        'SimpleFlying', 
        'TheGamer', 
        'HotCars', 
        'CBR', 
        'XDA', 
        'Collider', 
        'GameRant', 
        'GiveMeSport', 
        'CarBuzz',
        'TopSpeed',
        'MovieWeb',
        'TheThings',
        'TheTravel',
        'HowToGeek',
        'MakeUseOf',
        'AndroidPolice',
        'PocketLint',
        'DualShockers',
        'FextraLife',
        'Polygon',
        'FootballFanCast',
        'FootballLeagueWorld',
        'TheSportster',
        'ScreenRant'
    ],

    // put here prebid ssps that we do not want to use in bid pool mode.
    __onlyFromAuctionBidder: [

    ],

    addAndConfirmBidUsed: function(adElementId, adId){

        if(!this.__usedVideoAdIds.hasOwnProperty(adElementId)) {

            this.__usedVideoAdIds[adElementId] = [];
        }

        if(-1 === this.__usedVideoAdIds[adElementId].indexOf(adId)){

            this.__usedVideoAdIds[adElementId].push(adId);
        }
        else{
         
            this.logger.warn('UsedVideoAdIds: Trying to add already used ad ID to array.', {
                adElementId: adElementId,
                adId: adId,
            });
        }
    },

    confirmBidNotUsed: function(adElementId, adId){

        if(!this.__usedVideoAdIds.hasOwnProperty(adElementId)){

            this.__usedVideoAdIds[adElementId] = [];
        }

        if(-1 !== this.__usedVideoAdIds[adElementId].indexOf(adId)){
         
            this.logger.warn('UsedVideoAdIds: Ad ID already used.', {
                adElementId: adElementId,
                adId: adId,
            });
        }
    },
    

    containsSubstringFromArray: function(str, substrArray) {

        return substrArray.some(substring => str.includes(substring));
    },

    decideAdxCPM: function(ad, impressionCreativeId) {
        
        var us_ca = ['CA', 'US'];
        var us_uk = ['GB', 'US'];
        var adElementId = ad['adElementId'];
        var prebidCpm = 0;
        var amazonCpm = 0;
        var maxCpm = 0;
        var gamMultiplier = 0.50;

        if(ADX_EVENTS_MODIFIERS.hasOwnProperty(brandName)){

            gamMultiplier = ADX_EVENTS_MODIFIERS[brandName];
            this.__adx_event_mutliplier = gamMultiplier;
        }


        var directDealImpression = this.checkIftheImpressionIsADirectDeals(impressionCreativeId);
        

        if(directDealImpression !== null){
            
            return directDealImpression['cpm'];
        }

        if(this.__prebidBidSentToGAM.hasOwnProperty(adElementId) && this.__prebidBidSentToGAM[adElementId] !== null){

            prebidCpm = this.__prebidBidSentToGAM[adElementId]['cpm'];
        }

        if(this.__amazonBidSentToGAM.hasOwnProperty(adElementId) && this.__amazonBidSentToGAM[adElementId] !== null){

            amazonCpm = this.__amazonBidSentToGAM[adElementId]['cpm'];
        }

        maxCpm = Math.max(Number(amazonCpm), Number(prebidCpm)) + 0.01;

        if(ad.zoneName === 'sticky footer' && this.getBrandName() === 'HotCars' && us_ca.includes(this.getGeo())){


            return Math.max(Number(maxCpm), (2 + gamMultiplier));
            
        }

        if(ad.zoneName === 'sticky footer' && this.getBrandName() === 'TheTravel' && us_ca.includes(this.getGeo())){

            return Math.max(Number(maxCpm), (1 + gamMultiplier));
            
        }

        if((ad.zoneName.startsWith('character count repeatable') || ad.zoneName.startsWith('every entry repeatable') || ad.zoneName.startsWith('every image repeatable') || ad.zoneName === 'sticky footer') &&  this.__deviceType == 'mobile' && us_ca.includes(this.getGeo()) && this.getBrandName() === 'TheSportster'){
            
            return Math.max(Number(maxCpm), (0.50 + gamMultiplier));
        }

        if((ad.zoneName.startsWith('character count repeatable') || ad.zoneName.startsWith('every entry repeatable') || ad.zoneName.startsWith('every image repeatable') || ad.zoneName === 'sticky footer') && us_ca.includes(this.getGeo()) && this.getBrandName() === 'Polygon'){

            return Math.max(Number(maxCpm), (0.20 + gamMultiplier));
        }

        if((this.getBrandName() === 'CarBuzz' || this.getBrandName() == 'HotCars' || this.getBrandName() == 'TheSportster') && this.getGeo() == 'US'){

            return Math.max(Number(maxCpm), (1 + gamMultiplier));
        }

        if((ad.zoneName.startsWith('character count repeatable') || ad.zoneName.startsWith('every entry repeatable') || ad.zoneName.startsWith('every image repeatable') || ad.zoneName === 'sticky footer') &&  this.__deviceType == 'mobile' && us_ca.includes(this.getGeo())){
            
            return Math.max(Number(maxCpm), (0.3 + gamMultiplier));
        }

        if(us_uk.includes(this.getGeo()) && !['Polygon', 'FextraLife'].includes(this.getBrandName())){
            
            return Math.max(Number(maxCpm), (0.3 + gamMultiplier));
        }

        return Math.max(Number(maxCpm), (0.10 + gamMultiplier));
    },

    decidePrebidCPM: function(adElementId) {

        if(!this.__prebidBidSentToGAM.hasOwnProperty(adElementId)){

            this.logger.warn(`GAM slot load event advertiser id is detected as prebid But no prebid bid sent to GAM for element id: ${adElementId}.`);

            return 0.0;

        }

        return this.__prebidBidSentToGAM[adElementId]['cpm'];

    },

    decideAmazonCPM: function(adElementId) {

        if(!this.__amazonBidSentToGAM.hasOwnProperty(adElementId)){

            this.logger.warn(`GAM slot load event advertiser id is detected as amazon But no prebid bid sent to GAM for element id: ${adElementId}.`);

            return 0.0;

        }

        return this.__amazonBidSentToGAM[adElementId]['cpm'];
        
    },

    decideBidSource: function(advertiserId){

        var allAdvertisers        = ALL_ADVERTISER_MAP;
        
        var prebidCPM = allAdvertisers.prebid.find(item => item.id == advertiserId);

        if(prebidCPM){

            return {'source' : 'prebid', 'advertiser' : prebidCPM.name};
        }
        
        
        // Check in amazon array
        var amazonCPM = allAdvertisers.amazon.find(item => item.id == advertiserId);

        if(amazonCPM){

            return {'source' : 'amazon', 'advertiser' : amazonCPM.name};
        }
        
          // If not found in either, return gam
          return {'source' : 'gam', 'advertiser' : 'gam'};
    },

    checkIftheImpressionIsADirectDeals: function(creativeId){

        if(!creativeId || typeof this.__directDealsMapping !== 'object' || !this.__directDealsMapping.hasOwnProperty(creativeId)){

            return null;
        }

        return {
            id: creativeId,
            cpm: this.__directDealsMapping[creativeId],
        };
         
    },
        
    //
    // Create a bid pool if it doesn't exist.
    __createBidPool(bidPoolName){

        if(!this.areBidPoolsEnabled() || !bidPoolName || this.bidPools.hasOwnProperty(bidPoolName)){

            return;
        }

        var newBidPool = new AdsNinjaBidsPool(bidPoolName);
        newBidPool.setLogger(this.logger);

        this.bidPools[bidPoolName] = newBidPool;
    },

    //
    // Returns a bid pool name for an ad.
    __determineBidPoolNameForAd(ad, pageNumber){

        if(!this.areBidPoolsEnabled()){

            return null;
        }

        var zoneName    = ad.zone.name;
        var bidPoolName = null;

        if(Object.keys(this.__namesForBidPoolsByZoneName).length > 0 && this.__namesForBidPoolsByZoneName.hasOwnProperty(zoneName)){

            bidPoolName = this.__namesForBidPoolsByZoneName[zoneName];
        }
        else if(zoneName.startsWith('character count repeatable') || zoneName.startsWith('every entry repeatable') || zoneName.startsWith('every image repeatable')){
            bidPoolName = 'repeatable';
        }
        else{

            bidPoolName = zoneName + ((pageNumber !== null) ? '-PAGE' + pageNumber : '');
        }

        return bidPoolName;
    },

    __determineBidPoolNameForAdHTG(ad, pageNumber){
        if(!this.areBidPoolsEnabled()){
            return null;
        }
        var zoneName    = ad.zone.name;
        var divId       = ad.divId;
        var bidPoolName = null;
        if(Object.keys(this.__namesForBidPoolsByZoneName).length > 0 && this.__namesForBidPoolsByZoneName.hasOwnProperty(zoneName)){
            bidPoolName = this.__namesForBidPoolsByZoneName[zoneName];
        }
        else if(zoneName.startsWith('character count repeatable') || zoneName.startsWith('every entry repeatable') || zoneName.startsWith('every image repeatable')){
            if(zoneName.includes('#') && !divId.includes('COPY')){
                bidPoolName = zoneName + ((pageNumber !== null) ? '-PAGE' + pageNumber : '');
            }
            else if(divId.includes('REPEAT')){
                var zoneNumber = divId.split('REPEAT')[1].replace('REPEAT', '');
                bidPoolName = zoneName + ' #' + zoneNumber + ((pageNumber !== null) ? '-PAGE' + pageNumber : '');
            }
            else if(divId.includes('COPY')){
                var zoneNumber = divId.split('COPY')[1].replace('COPY', '');
                bidPoolName = zoneName + ' #' + zoneNumber + ((pageNumber !== null) ? '-PAGE' + pageNumber : '');
            }
            else{
                bidPoolName = zoneName + ((pageNumber !== null) ? '-PAGE' + pageNumber : '');
            }
        }
        else{
            bidPoolName = zoneName + ((pageNumber !== null) ? '-PAGE' + pageNumber : '');
        }
        return bidPoolName;
    },

    //
    // Add new prebid bid pools.
    addNewPrebidBidsToPools(bids){

        if(!this.areBidPoolsEnabled() || (!bids || Object.keys(bids).length === 0)){

            return;
        }

        for(var adElementId in bids){

            var ad = this.getAdsData(adElementId);
            var bidPoolName = ad.getBidPoolName();

            // Restrict repeated incontent bid TTL to 1 minute because paranoia
            if (["Collider", "MovieWeb", "CBR"].includes(this.getBrandName()) && bidPoolName === "repeatable") {
                bids[adElementId]["bids"].forEach(function(bid) { bid.ttl = Math.min(bid.ttl, 60); })
            }

            // Restrict repeated incontent bid TTL to 120 seconds because paranoia
            if (!["Collider", "MovieWeb", "CBR"].includes(this.getBrandName()) && bidPoolName === "repeatable") {
                bids[adElementId]["bids"].forEach(function(bid) { bid.ttl = Math.min(bid.ttl, 120); })
            }

            if(bidPoolName !== null) {

                if (!this.bidPools.hasOwnProperty(bidPoolName)) {

                    throw new Error(`There is no bid pool registered to save new bids with the ID: ${bidPoolName}.`);
                }

                var bidPool = this.bidPools[bidPoolName];

                // Add sizes if needed.
                if(ad.hasSupportForVideoOutstream() && ad.isRefreshModeRegular()){

                    for(var x in bids[adElementId].bids){

                        var bid = bids[adElementId].bids[x];
                    
                        if(bid.hasOwnProperty('width') && bid.hasOwnProperty('height')){

                            var width  = Number(bid.width);
                            var height = Number(bid.height);
                            var sizes  = [];
        
                            sizes.push([width, height]);
                            bidPool.addNewValidSizes(sizes);
                        }
                    }
                }   

                var bidsWithValidSizes = this.__extractBidsWithValidSizes(bids[adElementId].bids);
                
                var bidsAboveLocalFloors = this.__extractBidsAboveLocalFloors(bidsWithValidSizes);
                bidPool.addBidsPrebid(bidsAboveLocalFloors);
            }
        }
    },

    //
    // Add new amazon bid pools.
    addNewAmazonBidsToPools(bids){

        if(!this.areBidPoolsEnabled() || !bids || bids.length === 0){

            return [];
        }

        for(var x in bids){

            var adElementId = bids[x].slotID;
            var ad          = this.getAdsData(adElementId);
            var bidPoolName = ad.getBidPoolName();
            var cpmKey      = (bids[x].targeting.amznbid || "").replace(/.*_/, ""); // Strip extra bid identifiers.
            bids[x].cpm     = AMAZON_BID_MAP[cpmKey] || 0; // Add decoded cpm value to amazon bid.

            // Restrict repeated incontent bid TTL to 1 minute because paranoia
            if (["Collider", "MovieWeb", "CBR"].includes(this.getBrandName()) && bidPoolName === "repeatable") {
                bids[x].ttl = Math.min(bids[x].ttl, 60);
            }

            // Restrict repeated incontent bid TTL to 120 seconds because paranoia
            if (!["Collider", "MovieWeb", "CBR"].includes(this.getBrandName()) && bidPoolName === "repeatable") {
                bids[x].ttl = Math.min(bids[x].ttl, 120);
            }

            // ignore no bid bids from amazon
            if(!bids[x].hasOwnProperty('targeting') || !bids[x].targeting.amzniid){

                this.log(`Ignoring a new no bid amazon bid`, {
                    bid: bids[x],
                });

                continue;
            }
            
            if(bidPoolName !== null){

                if(!this.bidPools.hasOwnProperty(bidPoolName)){

                    throw new Error(`There is no bid pool registered to save new bids with the ID: ${bidPoolName}.`);
                }

                var bidPool = this.bidPools[bidPoolName];

                // TODO: Local floors.
                if(window.adsNinja 
                    && window.adsNinja.floorHelper 
                    && typeof window.adsNinja.floorHelper.isBidAboveLocalFloors === 'function' 
                    && !window.adsNinja.floorHelper.isBidAboveLocalFloors('amazon', bids[x])
                ){
                    // if(window.adsNinja && window.adsNinja.floorHelper && !window.adsNinja.floorHelper.isBidAboveFloors('amazon', bids[x])){ // TODO: All floors.
                    
                    continue;
                }

                // Add sizes if needed.
                if(ad.hasSupportForVideoOutstream() && ad.isRefreshModeRegular() && bids[x].hasOwnProperty('size') && bids[x].size && typeof bids[x].size === 'string'){

                    var size         = bids[x].size;
                    var myDimensions = size.split('x');

                    if(myDimensions.length === 2){

                        var width  = Number(myDimensions[0]);
                        var height = Number(myDimensions[1]);
                        var sizes  = [];

                        sizes.push([width, height]);
                        bidPool.addNewValidSizes(sizes);
                    }
                }

                bidPool.addBidsAmazon(bids[x]);
            }
        }

        return bids;
    },

    //
    // Extract bids with valid sizes to be added to the pool.
    __extractBidsWithValidSizes: function(bids){

        var bidsWithValidSizes = [];

        for(var x in bids){

            bidsWithValidSizes.push(bids[x]);
        }

        return bidsWithValidSizes;
    },

    //
    // Extract bids with cpm above minimum ssp specific local floors to be added to the pool.
    __extractBidsAboveLocalFloors: function(bids){

        if(!window.adsNinja 
            || !window.adsNinja.floorHelper 
            || typeof window.adsNinja.floorHelper.getBidsAboveLocalFloors !== 'function'
        ){

            return bids;
        }

        return window.adsNinja.floorHelper.getBidsAboveLocalFloors('prebid', bids);

        // TODO: All floors.
        // return window.adsNinja.floorHelper.getBidsAboveFloors('prebid', bids);

        var bidsWithValidCpms = [];
        var localFloorsCriterias = this.getAdBehaviourValue('localPrebidFloors'); //  TODO: Fix.
        
        for(var x in bids){

            var bid = bids[x];
            var bidderCode = bid.bidderCode;
            var cpm = bid.cpm;
            var width = bid.width;
            var height = bid.height;
            var mediaType = bid.mediaType;

            var validBid = true;


            for(var y in localFloorsCriterias){

                var criteria = localFloorsCriterias[y];

                var isBidderCriteriaPassed = (criteria.hasOwnProperty('bidderCode') && criteria.bidderCode !== bidderCode);

                if(isBidderCriteriaPassed){

                    continue;
                }else{

                    var isMediaTypeCriteriaPassed = (criteria.hasOwnProperty('mediaType') && criteria.mediaType !== mediaType);

                    if(isMediaTypeCriteriaPassed){

                        continue;
                    }
                    else{

                        var isSizeCriteriaPassed = ((criteria.hasOwnProperty('width') && criteria.width !== width) || (criteria.hasOwnProperty('height') && criteria.height !== height));
    
                        if(isSizeCriteriaPassed){
    
                            continue;
                        }else{
    
                            var isCpmCriteriaPassed = !criteria.hasOwnProperty('floor') || (criteria.hasOwnProperty('floor') && cpm >= criteria.floor)
                            // Disable adsNinja flooring when using external flooring solution. 
                            if (window.probidai && window.probidai.enabled && mediaType === 'banner') {
                              isCpmCriteriaPassed = true;
                            }
    
                            if(isCpmCriteriaPassed){
    
                                continue;
                            }else{
    
                                validBid = false;
    
                                this.logger.debug('Prebid bid ignored due to local floors.', {
                                    bid: bid,
                                });
    
                                break;
                            }
                                
                        }
    
                    }
                } 

            }

            if(validBid){

                bidsWithValidCpms.push(bid);
            }


        }

           
        return bidsWithValidCpms;
    },

    //
    // Deprecated, use "this.logger" instead.
    // @deprecated
    // Log a messge to the console.
    log: function(message, data = {}){

        this.logger.debug(message, data);
    },

    //
    // Determines if an auction exists.
    doesAuctionExist: function(id){

        return window.adsNinjaHeaderBiddingManager.auctions.hasOwnProperty(id);
    },

    //
    // Register an auction with lookup dictionary.
    __registerAuctionsInDictionary: function(auction, ads){

        if(!ads || typeof ads !== 'object' || Object.keys(ads).length === 0 || !auction || typeof auction !== 'object' || Object.keys(auction).length === 0){

            return;
        }

        for(var x in ads){

            if(!this.__auctionDictionaryByAdElementId.hasOwnProperty(ads[x].getAdElementId())){

                this.__auctionDictionaryByAdElementId[ads[x].getAdElementId()] = [];
            }
    
            this.__auctionDictionaryByAdElementId[ads[x].getAdElementId()].push(auction.getId());
        }
    },  

    //
    // Add an auction.
    __addAuction: function(id, auction){

        if(this.auctions.hasOwnProperty(id)){

            throw new Error(`There is already an auction registered with the ID: ${id}.`);
        }

        this.auctions[id] = auction;
    },

    //
    // Creates an auction.
    __createAuction: function(isPageLoad = null, id = null){

        var theId = null;

        if(typeof id == 'string'){

            theId = id;
        }
        else if(typeof isPageLoad == 'boolean'){

            theId = (isPageLoad) ? 'onPageLoad' : 'afterPageLoad_' + Date.now().toString();
        }
        else{

            theId = Date.now().toString();
        }

        this.log(`new auction created with id: ${theId}`);

        return new window.AdsNinjaAuction(theId);
    },

    //
    // Update the Prebid not bidding count.
    __updateNotBiddingCount: function(auctionId, adElementId){


        var refreshingAdZone = window.adsNinjaHeaderBiddingManager.refreshingAdZones[adElementId];
        var auction = this.auctions[auctionId];
        var newBidHasBeenReceived = auction.hasNewBids(adElementId);

        if (refreshingAdZone) {

            if (newBidHasBeenReceived) {

                refreshingAdZone.resetNotBiddingCount();

            } else {
                var notBiddingCount = refreshingAdZone.getNotBiddingCount() + 1;
                refreshingAdZone.setNotBiddingCount(notBiddingCount);
            }

            this.logger.debug(`new refresh logic, not bidding info`, {
                adElementId: adElementId,
                notBiddingCount: refreshingAdZone.getNotBiddingCount(),
            }, false);
        }
         
    },

    __isThereBidToBeUsed: function(adElementId){

        var ad = this.getAdsData(adElementId);
        var bidPoolName = ad.getBidPoolName();

        if(bidPoolName === null){

            return false;
        }

        var bidPool = this.bidPools[bidPoolName];

        var isTherePrebidBid   = bidPool.hasValidBids(this.BIDDING_LIBRARY_PREBID);
        var isThereAmazonBid   = bidPool.hasValidBids(this.BIDDING_LIBRARY_AMAZON);

        return isTherePrebidBid || isThereAmazonBid;
    },

    //
    // Callback
    // Called by bidding libraries when auction is complete. If all are complete it will send a request to ad server to retrieve the ad(s) for the page.
    bidsBack: function(auctionId){

        if(!this.doesAuctionExist(auctionId)){

            throw new Error(`There is no auction registered with the ID: ${auctionId}.`);
        }

        if(!window.adsNinjaHeaderBiddingManager.auctions[auctionId].areAmazonBidsBack() || !window.adsNinjaHeaderBiddingManager.auctions[auctionId].arePrebidBidsBack()){

            return;
        }

        window.adsNinjaHeaderBiddingManager.log(`Bids from Prebid and A9 are back for auction: ${auctionId}!`);

        if(!window.adsNinjaHeaderBiddingManager.auctions[auctionId].getShouldDelaySendingAdServerRequest()){

            this.sendAdServerRequest(auctionId);
        }
        else{

            const auction = this.auctions[auctionId];

            if(!auction){

                return;
            }

            const adElementIds = auction.getDivIdsOnlyBanner();

            if(!adElementIds || (Array.isArray(adElementIds) && adElementIds.length === 0)){

                return;
            }

            for(const adElementId of adElementIds){

                const refreshingAdZone = this.refreshingAdZones[adElementId];

                if(!refreshingAdZone){

                    continue;
                }
                
                this.refreshAdElement(adElementId, 'bidsBack');
            }
        }
    },

    //
    // Sends request to the ad server to receive the ad(s).
    sendAdServerRequest: function(auctionId){

        if(this.__isUsingFakeAds()){

            return;
        }

        if(!this.doesAuctionExist(auctionId)){

            throw new Error(`There is no auction registered with the ID: ${auctionId}.`);
        }

        var auction = this.auctions[auctionId];
        var displayPrebidAdUnits = auction.getDisplayPrebidAdUnits();
        auction.setBiddersForAdUnits(displayPrebidAdUnits);

        if(true === window.adsNinjaHeaderBiddingManager.auctions[auctionId].isAdServerRequestSent()){

            window.adsNinjaHeaderBiddingManager.log(`Ad server request already sent for auction: ${auctionId}.`);
            return;
        }

        window.adsNinjaHeaderBiddingManager.auctions[auctionId].setIsAdServerRequestSent(true);

        // Get div IDs for banner ads.
        var divIds = window.adsNinjaHeaderBiddingManager.auctions[auctionId].getDivIdsOnlyBanner();

        // TODO: Remove this if in the future to have a more generic version.
        if(typeof window.googletag !== 'undefined' && window.googletag.hasOwnProperty('cmd') && divIds && divIds.length > 0){

            this.sendGamAdServerRequest(auctionId, divIds);

            // Start refresh timers.
            this.__startRefreshTimers(divIds);
        }

        // If auction contains an instream video apply processing.
        this.registerAuctionVideoIfAvailable(auctionId);

        if('onPageLoad' === auction.getId()){
            
            this.logger.info(`Auction details: ${auction.getId()}.`, auction.getLogData(), false);
        }
    },

    //
    // Sends request to the GAM ad server to receive the ad(s).
    sendGamAdServerRequest: async function(auctionId, divIds){

        var slots         = window.googletag.pubads().getSlots();
        
        var auction = this.auctions[auctionId];
        
        
        var targetedSlots = [];

        for(var x in slots){

            var slot = slots[x];

            for(var y in divIds){

                var divId = divIds[y];

                if(divId === slot.getSlotElementId()){

                    var result = await this.addGAMAdServerTargeting(auctionId, slot);
                    var ad     = this.__adsData[divId];
                    
                    // Skip GAM refresh call for video direct deals served via Video Line items
                    if (result?.bidder === 'direct') {
                      this.renderDirectDeal(result);
                    } else {
                    
                
                    if(this.__bannerEnabledEventTrackingBrand.includes(this.getBrandName())){

                        //record request event for display ad. 
                        var recordingOptions = this.getRecordingOptions(ad);
                        this.__revenueRecorder.recordRequest(ad.getName(), auction.getBidders(divId), recordingOptions);
                    }
                    
                    // push the slot to be requested from GAM.
                    targetedSlots.push(slot);
                    }
                }
            }
        }

        if(!targetedSlots || 0 === targetedSlots.length){

            return false;
        }

        var self = this;

        //Optimera add page level targeting
        if(window.hasOwnProperty('oVs')){

            window.googletag.pubads().setTargeting('optimera', self.optimeraCombineScores());
        }

        window.googletag.cmd.push(function(){

            window.googletag.pubads().refresh(targetedSlots);

            if(typeof window.oPageUnload === 'function' && 'onPageLoad' !== auctionId){

                for(var z in targetedSlots){

                    window.oPageUnload(targetedSlots[z].getSlotElementId());
                }
            }
            else if(typeof window.oPageUnload === 'function' && 'onPageLoad' === auctionId){

                window.oPageUnload(1);
            }

            window.adsNinjaHeaderBiddingManager.log(`Ad server request sent for auction: ${auctionId}.`, {
                slotsForAuction: targetedSlots,
                divIds: divIds,
            });

            if (document.hidden && auctionId === 'onPageLoad') {
                window.adsNinjaHeaderBiddingManager.addBiddingProcessTracking('documentHiddenBeforeRefresh', 'start', null, auctionId);
            }
        });

        this.recordDisplayRequestsForAuction(auctionId);

        // if('TheGamer' === brandName && 'onPageLoad' === auctionId){

        //     window.adsNinjaHeaderBiddingManager.logger.log('Starting after page load auction.');
        //     window.adsNinja.dynamicallyInjectAllAdZones();
        // };

        return true;
    },

    getRecordingOptions: function(ad){

        var recordingOptions = {};

        var isVideo = ad.__hasAdDataVideoOptions();
        var zoneGroupName = ad.zoneGroupName;
        var zoneName      = ad.zoneName;
        
        var recordingOptions = {
              
            'specificFolder' : zoneGroupName.toLocaleLowerCase().replace(/\s+/g, '_'),

        };

        if(zoneName == 'sticky footer'){
            
            recordingOptions.specificFolder = 'sticky_footer';
        }

        if(isVideo){

            recordingOptions.specificFolder = 'video';
        }

        return recordingOptions;
        
    },

    recordDisplayRequestsForAuction: function(auctionId){

        var auction = this.auctions[auctionId];

        var displayPrebidAdUnits = auction.getDisplayPrebidAdUnits();
        // var videoAmazonAdSlot = auction.getVideoAmazonAdSlot();         // TODO: Amazon.

        // this.__revenueRecorder.addPrebidAdUnitsToTrack(videoPrebidAdUnits);
        // this.__revenueRecorder.addAmazonAdUnitsToTrack([videoAmazonAdSlot]);         // TODO: Amazon.

        auction.setBiddersForAdUnits(displayPrebidAdUnits);



    },

    //
    // Render Direct Deal Ad
    renderDirectDeal: function(result){
        window.adsNinja?.render?.({
            headerBiddingLibrary: 'direct',
            type: 'video',
            video: {
                adUnit: result.adUnit,
                vastUrl: result.vastUrl
            },
        });
    },

    //
    // Add Slot level Key values to be sent on the GAM request.
    addGAMAdServerTargeting: async function(auctionId, slot){

        var adElementId = slot.getSlotElementId();
        var ad = this.__adsData[adElementId];

        if(!this.areBidPoolsEnabled()){

            this.getPrebidBidForSlotForAuction(ad);
            this.getAmazonBidForSlotForAuction(ad);

            return;
        }

        var validPrebidAdRequestKeys = ['hb_format', 'hb_size', 'hb_pb', 'hb_adid', 'hb_bidder', 'hb_source', 'hb_deal', 'hb_deal_bidder', 'hb_deal_flag'];
        var amazonValidtargetingKeys = ['amznactt', 'amznbid', 'amzniid', 'amznp', 'amznsz'];

        this.resetPrebidTargetingForSlot(slot, validPrebidAdRequestKeys);
        this.resetAmazonTargetingForSlot(slot, amazonValidtargetingKeys);

        
        var prebidBid   = this.getPrebidBidForSlot(adElementId);
        var amazonBid   = this.getAmazonBidForSlot(adElementId);
        var gamBid;

        // Float outstream player makes additional request to GAM for direct deals.
        var adsData       = this.__adsData[adElementId];
        var adZoneElement = adsData.getAdZoneElement();
        var floatingMode  = adZoneElement.getAttribute('data-floating-mode');

        if('always' === floatingMode && adsData.isVideoRequestModeDisplay()){
          gamBid = await this.getGAMBidForSlot(adElementId, amazonBid, prebidBid);
        }

        var anyBid = gamBid || prebidBid || amazonBid;

        // update not bidding count
        this.__updateNotBiddingCount(auctionId, adElementId); // TODO: Here.

        // If the only prebid bid we received was a blacklisted one, we don't want to use it.
        if (prebidBid && prebidBid['valnetBlacklisted']) {
          prebidBid = null;
        }
        
        if(prebidBid !== null){

            var bidderCode = prebidBid.bidderCode;
            var prebidAdServerTargetings = prebidBid.adserverTargeting;

            for(var prebidkey in prebidAdServerTargetings){

                if(validPrebidAdRequestKeys.includes(prebidkey)){

                    var prebidBidderKey = prebidkey + '_' + bidderCode;
                    prebidBidderKey     = prebidBidderKey.substring(0, 20);

                    slot.setTargeting(prebidBidderKey, prebidAdServerTargetings[prebidkey]);
                    slot.setTargeting(prebidkey, prebidAdServerTargetings[prebidkey]);
                }
            }
        }

        // If the only amazon bid we received was a blacklisted one, we don't want to use it.
        if (amazonBid && amazonBid['valnetBlacklisted']) {
          amazonBid = null;
        }

        if(amazonBid !== null){

            var amazonAdServerTargetings = amazonBid.targeting;

            for(var amazonKey in amazonAdServerTargetings){

                slot.setTargeting(amazonKey, amazonAdServerTargetings[amazonKey]);
            }
        }

        // add zone name
        var slotZoneName = this.getZoneNameForSlot(adElementId);
        slot.setTargeting("zone", slotZoneName);

        var tid = ('TheGamer' === this.getBrandName()) ? adsData.getAuctionId() : adsData.getTid();
        if (tid) {
          slot.setTargeting("tid", tid);
        }

        return anyBid;
    },

    resetPrebidTargetingForSlot: function(slot, validPrebidAdRequestKeys){

        // Reset targeting keys if prebid bid is not available.
        var targetingKeys = slot.getTargetingKeys();

        for(var x in targetingKeys){

            var targetingKey = targetingKeys[x];

            for(var y in validPrebidAdRequestKeys){

                var validPrebidAdRequestKey = validPrebidAdRequestKeys[y];
                
                // TODO: If we were to save the keys set somewhere we could use that to reset them.
                if(targetingKey.startsWith(validPrebidAdRequestKey)){

                    slot.setTargeting(targetingKey, null);

                    break;
                }
            }
        }
    },

    resetAmazonTargetingForSlot: function(slot, amazonValidtargetingKeys){

        // Reset targeting keys if prebid bid is not available.
        

        for(var y in amazonValidtargetingKeys){

            var amazonValidtargetingKey = amazonValidtargetingKeys[y];
            
            // TODO: If we were to save the keys set somewhere we could use that to reset them.
            slot.setTargeting(amazonValidtargetingKey, null);
        }
    },

    //
    // Get prebid bid for a slot.
    getPrebidBidForSlot: function(adElementId){

        var ad = this.__adsData[adElementId];
        var bidPoolName = ad.getBidPoolName();

        if(bidPoolName !== null){

            return this.getPrebidBidForSlotFromPool(bidPoolName, adElementId);

        }else{

            return this.getPrebidBidForSlotForAuction(ad);

        }
    },

    //
    // Get amazon bid for a slot.
    getAmazonBidForSlot: function(adElementId){

        var ad = this.__adsData[adElementId];
        var bidPoolName = ad.getBidPoolName();

        if(bidPoolName !== null){

            return this.getAmazonBidForSlotFromPool(bidPoolName, adElementId);

        }else{

            return this.getAmazonBidForSlotForAuction(ad);

        }

    },

    // Get GAM bid for a slot.
    getGAMBidForSlot: async function(adElementId, amazonBid, prebidBid){
        var CIPHER = "ouhlicxnpe"; // Used for obfuscation of flooring bids
        var amazonCpm = amazonBid && amazonBid.cpm || 0;
        var prebidCpm = prebidBid && prebidBid.cpm || 0;
        var gamBid = null;

        var highestBid = Math.max(Number(amazonCpm), Number(prebidCpm));
        var roundedDynamicFloor = utils.roundTwoDecimal(highestBid);
        var bucketCPM = utils.convertCpmToBucket(roundedDynamicFloor, 50);
        var hashedCPM = utils.hashNumber(CIPHER, bucketCPM);

        var adsData  = this.__adsData[adElementId];
        var self = this;

        var videoConfig = {
          adUnit: adElementId,
          params: {
            iu: adsData.adUnitPath,
            output: 'vast',
            sz: '640x480',
            vpmute: 1,
            plcmt: 4,
            cust_params: {
              dynamic_floor: hashedCPM,
              hb_bidder: null,
              hb_pb: null,
              optimera: window.hasOwnProperty('oVs') && self.optimeraCombineScores().join(','),
              Site: self.getBrandName(),
              Source: self.getClientData()['source'],
              ContentType: self.getContentType(),
              Template: self.getTemplate(),
              NetworkCategory: self.getNetworkCategory(),
              SiteCategory: self.getSiteCategory(),
              PostID: self.getPostId(),
            //   arcspan_c: (window.hasOwnProperty('arcobj2') && window.arcobj2.hasOwnProperty('compcohorts')) ? window.arcobj2.compcohorts.join(',') : ""
            },
          }
        };

        if ('Military' === this.getBrandName()) {
          videoConfig.params.cust_params['arcspan_c'] = (window.hasOwnProperty('arcobj2') && window.arcobj2.hasOwnProperty('compcohorts')) ? window.arcobj2.compcohorts.join(',') : "";
        }

        var videoUrl;
        if(!this.__isPrebidDisabled){
            if(window.pbjs.adServers.hasOwnProperty('dfp')){
                videoUrl = window.pbjs.adServers.dfp.buildVideoUrl(videoConfig);
            }else{
                videoUrl = window.pbjs.adServers.gam.buildVideoUrl(videoConfig);
            }
        }else{
            videoUrl = this.__buildVideoUrl({ adUnitPath: adsData.adUnitPath });
        }

        var vastXml = await fetch(videoUrl).then(resp => resp.text());
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(vastXml, "text/xml");
        var hasAd = xmlDoc.getElementsByTagName('Ad');

        if (hasAd.length > 0) {
          gamBid = { cpm: bucketCPM, vastXml, ttl: 120, bidder: 'direct', adUnit: adElementId, vastUrl: videoUrl }
        }

        return gamBid;
    },

    // Get GAM bid.
    getFlooredGAMBid: function(adElementId, highestBid = { cpm: 0 }){
        var CIPHER = "ouhlicxnpe"; // Used for obfuscation of flooring bids
        var gamBid = null;

        var roundedDynamicFloor = utils.roundTwoDecimal(highestBid.cpm);
        var bucketCPM = utils.convertCpmToBucket(roundedDynamicFloor, 50);
        var hashedCPM = utils.hashNumber(CIPHER, bucketCPM);

        var adsData  = this.__adsData[adElementId];
        var mode = adsData?.getVideoContextName();

        var self = this;

        var videoConfig = {
          adUnit: adElementId,
          params: {
            iu: adsData.adUnitPath,
            output: 'vast',
            sz: '640x480',
            vpmute: 1,
            plcmt: 4,
            cust_params: {
              dynamic_floor: hashedCPM,
              hb_bidder: null,
              hb_pb: null,
              optimera: window.hasOwnProperty('oVs') && self.optimeraCombineScores().join(','),
              Site: self.getBrandName(),
              Source: self.getClientData()['source'],
              ContentType: self.getContentType(),
              Template: self.getTemplate(),
              NetworkCategory: self.getNetworkCategory(),
              SiteCategory: self.getSiteCategory(),
              PostID: self.getPostId(),
              mode,
            //   arcspan_c: (window.hasOwnProperty('arcobj2') && window.arcobj2.hasOwnProperty('compcohorts')) ? window.arcobj2.compcohorts.join(',') : ""
            },
          }
        };

        if ('Military' === this.getBrandName()) {
          videoConfig.params.cust_params['arcspan_c'] = (window.hasOwnProperty('arcobj2') && window.arcobj2.hasOwnProperty('compcohorts')) ? window.arcobj2.compcohorts.join(',') : "";
        }

        var videoUrl;
        if(!this.__isPrebidDisabled){
            if(window.pbjs.adServers.hasOwnProperty('dfp')){
                videoUrl = window.pbjs.adServers.dfp.buildVideoUrl(videoConfig);
            }else{
                videoUrl = window.pbjs.adServers.gam.buildVideoUrl(videoConfig);
            }
        }else{
            videoUrl = this.__buildVideoUrl({ adUnitPath: adsData.adUnitPath });
        }

        gamBid = { adId: window.crypto.randomUUID(), cpm: bucketCPM, ttl: 120, bidder: 'gam', adUnit: adElementId, vastUrl: videoUrl }
        self.adIdMap[`gam_${gamBid.adId}`] = gamBid;

        window.adsNinjaHeaderBiddingManager.log(`floored GAM bid details:`, {
            gamBid,
            highestBid,
            roundedDynamicFloor,
            bucketCPM,
            hashedCPM,
        });

        return gamBid;
    },

    //
    // Get ad zone name for a slot.
    getZoneNameForSlot: function(adElementId){

        var zoneName = this.__adsData[adElementId]['zoneName'];

        // remove possible hash - #
        zoneName = zoneName.replace("#", "");

        return zoneName;
    },

    getPrebidBidForSlotFromPool: function(bidPoolName, adElementId){

        var bidPool = this.bidPools[bidPoolName];
        var prebidBidFromPool = bidPool.getHighestUnusedBid(this.BIDDING_LIBRARY_PREBID, this.__videoCreativeBlacklist, this.__videoBidderBlacklist, this.__onlyFromAuctionBidder);
        var ad = this.__adsData[adElementId];

        if(prebidBidFromPool!== null){

            prebidBidFromPool['adUnitCodeGAMRequest'] = adElementId;
        }

        this.__prebidBidSentToGAM[adElementId] = prebidBidFromPool;

        window.adsNinjaHeaderBiddingManager.log(`prebidBid received from pool:`, {
            prebidBid: prebidBidFromPool,
            bidPool: bidPool,
            adElementId: adElementId
        });

        return prebidBidFromPool;
    },

    getPrebidBidForSlotForAuction: function(ad){

        var prebidBid = null;
        var auctionId = ad.getAuctionId();

        if(null == auctionId || auctionId == undefined){
            
            return;

        }

        if(ad.isRefreshModeRegular()){

            auctionId = this.__getLatestAuctionId(ad['adElementId']);
        }

        prebidBid = this.auctions[auctionId].getHighestUnusedBid(this.BIDDING_LIBRARY_PREBID, ad['adElementId']);

        this.__prebidBidSentToGAM[ad['adElementId']] = prebidBid;

        window.adsNinjaHeaderBiddingManager.log(`prebidBid received from auction:`, {
            prebidBid: prebidBid,
            adElementId: ad['adElementId']
        });

        return prebidBid;

    },

    getAmazonBidForSlotFromPool: function(bidPoolName, adElementId){

        var bidPool = this.bidPools[bidPoolName];
        var amazonBidFromPool = bidPool.getHighestUnusedBid(this.BIDDING_LIBRARY_AMAZON, this.__videoCreativeBlacklist, this.__videoBidderBlacklist);

        if(amazonBidFromPool !== null){
            window.adsNinjaHeaderBiddingManager.log(`amazonBid received from pool:`, {
                amazonBid: amazonBidFromPool,
                bidPool: bidPool,
                adElementId: adElementId
            });
        }

        this.__amazonBidSentToGAM[adElementId] = amazonBidFromPool;

        return amazonBidFromPool;
    },

    getAmazonBidForSlotForAuction: function(ad){

        var amazonBid = null;
        var auctionId = ad.getAuctionId();

        if(null == auctionId || auctionId == undefined){
            
            return;

        }

        if(ad.isRefreshModeRegular()){

            auctionId = this.__getLatestAuctionId(ad['adElementId']);
        }

        amazonBid = this.auctions[auctionId].getHighestUnusedBid(this.BIDDING_LIBRARY_AMAZON, ad['adElementId']);
        
        this.__amazonBidSentToGAM[ad['adElementId']] = amazonBid;


        window.adsNinjaHeaderBiddingManager.log(`amazonBid received from auction:`, {
            amazonBid: amazonBid,
            adElementId: ad['adElementId']
        });

        return amazonBid;

    },


    //
    // Begins auction process with bidders.
    requestHeaderBids: function(auctionId, context = 'banner'){

        if(this.__isUsingFakeAds()){

            return;
        }

        if(!this.doesAuctionExist(auctionId)){

            throw new Error(`There is no auction registered with the ID: ${auctionId}.`);
        }

        if(true === this.auctions[auctionId].areBidsRequested()){

            this.log(`Already requested bids for auction: ${auctionId}.`);
            return;
        }

        this.auctions[auctionId].setAreBidsRequested(true);

        this.log(`Requesting bids for auction: ${auctionId}!`);

        var self = this;

        self.addBiddingProcessTracking('bid_request', 'start', null, auctionId);

        // Sends bid requests to Amazon when wanted.
        if(this.auctions[auctionId].isAmazonAvailable()){
            // Decorate amazon slots with floors based on prebid floors config.
            this.auctions[auctionId].getAmazonAdSlots().forEach(function(slot) {

                if(window.adsNinja 
                    && window.adsNinja.floorHelper 
                    && typeof window.adsNinja.floorHelper.getFirstMatchingFloor === 'function'
                ){

                    var floor = window.adsNinja.floorHelper.getFirstMatchingFloor('bidstream', 'amazon', slot);

                    if(floor && floor.value > 0){
    
                        slot.floor = {
                            value: floor.value * 100, // Contains the value of the floor price where 100 = $1.00.
                            currency: 'USD',
                        }
                    }
                }

                return slot;
            });

            // By default, the library will check for the existence of a CMP and will query it with a timeout of 50ms.
            window.apstag.fetchBids({
                    slots: this.auctions[auctionId].getAmazonAdSlots(),
                    timeout: this.auctions[auctionId].getAmazonTimeout(),
                },
                function(bids){
                    var responseTimestamp = Date.now();
                    bids.forEach(function(bid) {
                        var cpmKey = bid.targeting.amznbid.replace(/.*_/, ""); // strip extra bid identifiers

                        bid.responseTimestamp = responseTimestamp;
                        bid.ttl               = self.AMAZON_TTL; // Decorate bid with TTL
                        bid.bidderCode        = AMAZON_ADVERTISER_MAP[bid.targeting.amznp];
                        bid.adId              = bid.targeting.amzniid;

                        // Don't record revenue for amazon debug ads
                        if (bid.bidderCode === 'Amazon Test') {
                          bid.cpm = 0;
                        } else {
                          bid.cpm = AMAZON_BID_MAP[cpmKey] || 0; // Add decoded cpm value to amazon bid
                        }

                        if (bid.mediaType === 'video') {
                            bid.vastUrl = getVastUrlForAmazonBid(bid);
                        }

                        self.adIdMap[`amazon_${bid.adId}`] = bid;
                    });

                    // Set apstag targeting on googletag, then trigger the first DFP request in googletag's disableInitialLoad integration.
                    window.googletag.cmd.push(function(){
                        window.adsNinjaHeaderBiddingManager.addBiddingProcessTracking('amazon_bid_response', 'end', null, auctionId);
                        if(!window.adsNinjaHeaderBiddingManager.areBidPoolsEnabled()){

                            window.apstag.setDisplayBids();
                        }
                        else if(window.adsNinjaHeaderBiddingManager.areBidPoolsEnabled() && context !== 'video'){

                            bids = window.adsNinjaHeaderBiddingManager.addNewAmazonBidsToPools(bids);
                        }

                        window.adsNinjaHeaderBiddingManager.log(`Amazon bids for auction: ${auctionId}.`, {
                            bids: bids,
                        });

                        window.adsNinjaHeaderBiddingManager.auctions[auctionId].setAreAmazonBidsBack(true);
                        window.adsNinjaHeaderBiddingManager.auctions[auctionId].setBidsAmazon(bids); // Bids already have properties set on them.
                        window.adsNinjaHeaderBiddingManager.bidsBack(auctionId);
                    });
                }
            );
        }
        else{

            this.auctions[auctionId].setAreAmazonBidsBack(true);
        }

        // Sends bid requests with Prebid when wanted.
        if(this.auctions[auctionId].isPrebidAvailable()){

            window.pbjs.que.push(function(){

                var prebidAdUnits = window.adsNinjaHeaderBiddingManager.auctions[auctionId].getPrebidAdUnits();
                window.adsNinjaHeaderBiddingManager.addValidSizesToPools(prebidAdUnits);

                window.pbjs.requestBids({
                    adUnits: prebidAdUnits,
                    auctionId,
                    timeout: window.adsNinjaHeaderBiddingManager.auctions[auctionId].getPrebidTimeout(),
                    bidsBackHandler: function(bids, timedOut, prebidAuctionId){
                        window.googletag.cmd.push(function(){
                            window.adsNinjaHeaderBiddingManager.addBiddingProcessTracking('prebid_bid_response', 'end', null, auctionId);

                            if(!window.adsNinjaHeaderBiddingManager.areBidPoolsEnabled()){

                                var displayAdUnitCodes = window.adsNinjaHeaderBiddingManager.auctions[auctionId].getPrebidAdUnitCodesNonVideo();

                                if(displayAdUnitCodes && displayAdUnitCodes.length > 0){

                                    window.pbjs.setTargetingForGPTAsync(displayAdUnitCodes);
                                }
                            }
                            else if(window.adsNinjaHeaderBiddingManager.areBidPoolsEnabled() && context !== 'video'){

                                window.adsNinjaHeaderBiddingManager.addNewPrebidBidsToPools(bids);
                            }

                            window.adsNinjaHeaderBiddingManager.log(`Prebid bids for auction: ${auctionId}.`, {
                                bids: bids,
                                timedOut: timedOut,
                                prebidAuctionId: prebidAuctionId,
                            });

                            // var videoAdUnit = window.adsNinjaHeaderBiddingManager.auctions[auctionId].getVideoPrebidAdUnit();
                            //
                            // Check if we have an instream video player ad.
                            // if(videoAdUnit){
                            //
                            //     window.adsNinjaHeaderBiddingManager.log('Managed video error, somehow using display focused Prebid!');
                            //
                            //     // if(false){
                            //     //
                            //     //
                            //     //     var videoUrl = window.pbjs.adServers.dfp.buildVideoUrl({
                            //     //         adUnit: videoAdUnit,
                            //     //         params: {
                            //     //             iu: '/39363775/MM_InstreamTEST',  // TODO: Get from somewhere.
                            //     //             output: 'vast'
                            //     //         }
                            //     //     });
                            //     //
                            //     //     window.adsNinjaHeaderBiddingManager.invokeInstreamVideoPlayer(videoAdUnit, videoUrl);
                            //     // }
                            // }

                            window.adsNinjaHeaderBiddingManager.auctions[auctionId].setArePrebidBidsBack(true);
                            window.adsNinjaHeaderBiddingManager.auctions[auctionId].setBidsPrebid(bids);

                            if(context === 'video'){

                                window.adsNinjaHeaderBiddingManager.log(`video auction: new bids back for auction:`, {
                                    auctionId : auctionId,
                                    bids: bids,
                                });
                            
                            }
                            window.adsNinjaHeaderBiddingManager.bidsBack(auctionId);
                        });
                    }
                });
            });
        }
        else{

            this.auctions[auctionId].setArePrebidBidsBack(true);
        }
        
        self.addBiddingProcessTracking('prebid_bid_response', 'start', null, auctionId);
        self.addBiddingProcessTracking('amazon_bid_response', 'start', null, auctionId);
        self.addBiddingProcessTracking('bid_request', 'end', null, auctionId);

    },
    // add valid sizes
    addValidSizesToPools: function(prebidAdUnits){


        for(var x in prebidAdUnits){

            var adUnitCode = prebidAdUnits[x]['code'];
            var ad = this.__adsData[adUnitCode];
            var bidPoolName = ad.getBidPoolName();
            var useBigSize = (!this.isMobile() && 'sidebar' !== ad.zoneGroupName && 'header' !== ad.zoneName);
            var isSmallFloating = (this.isMobile() && 'header' === ad.zoneName);

            if(bidPoolName !== null) {

                var bidPool = this.bidPools[bidPoolName];
                var sizes = prebidAdUnits[x]['sizes']

                bidPool.addNewValidSizes(sizes);

                // hardcoded sizes for inBanner video
                bidPool.addNewValidSizes([[0,0], [1,1]]);

                if(isSmallFloating){

                    bidPool.addNewValidSizes([[176, 99]]);
                }
                else if(useBigSize){

                    bidPool.addNewValidSizes([[544, 306]]);
                }
                else{

                    bidPool.addNewValidSizes([[304, 171]]);
                }
            }  
            
        }
        
    },

    //
    // Sets a failsafe timeout on page to send an ad server request.
    // The failsafe is to ensure we request ads from the ad server for the page in the event bidders don't return in time.
    startFailSafeTimeout: function(auctionId){

        if(!this.doesAuctionExist(auctionId)){

            throw new Error(`There is no auction registered with the ID: ${auctionId}.`);
        }

        if(!auctionId || !this.__failsafeTimeout || typeof this.__failsafeTimeout !== 'number'){

            window.adsNinjaHeaderBiddingManager.log('Unable to set a failsafe timout!', {
                auctionId: auctionId,
                failsafeTimeout: this.__failsafeTimeout,
                failsafeTimeoutCmp: this.__failsafeTimeoutCmp,
                consentNeeded: this.__consentNeeded,
            });
            return;
        }

        var adServerRequestFailsafeTimeout = this.auctions[auctionId].getAdServerRequestFailsafeTimeout() || this.__failsafeTimeout;

        // TODO: When consent is known timeout can be lowered.
        if(this.__consentNeeded && this.__failsafeTimeoutCmp && typeof this.__failsafeTimeoutCmp === 'number'){

            adServerRequestFailsafeTimeout = this.__failsafeTimeoutCmp;
        }

        window.setTimeout(function(){

            // TODO: For refreshes keep track of internal auction ID and here set auction to closed.
            // TODO: Handler bidsBack or the callback that invoked it will handle what happens auction IDs.
            window.adsNinjaHeaderBiddingManager.log(`Bidding failsafe timeout reached for auction: ${auctionId}!`, {
                prebidBiddersBack: window.adsNinjaHeaderBiddingManager.auctions[auctionId].arePrebidBidsBack(),
                isPrebidAvailable: window.adsNinjaHeaderBiddingManager.auctions[auctionId].isPrebidAvailable(),
                amazonBiddersBack: window.adsNinjaHeaderBiddingManager.auctions[auctionId].areAmazonBidsBack(),
                isAmazonAvailable: window.adsNinjaHeaderBiddingManager.auctions[auctionId].isAmazonAvailable(),
            });

            window.adsNinjaHeaderBiddingManager.sendAdServerRequest(auctionId);
        }, adServerRequestFailsafeTimeout);

        window.adsNinjaHeaderBiddingManager.log(`Failsafe timout set at ${adServerRequestFailsafeTimeout}ms for auction: ${auctionId}!`);
    },

    //
    // Determine ads meant for page load.
    __filterGamAdSlotsByPageLoadAndIsDefined: function(gamAdSlots, isPageLoad){

        gamAdSlots = Object.values(gamAdSlots);

        // Make sure we want an ad.
        return gamAdSlots.filter(function(gamAdSlot){

            return ((isPageLoad === gamAdSlot['onPageLoad'] || String(isPageLoad) === gamAdSlot['onPageLoad']) && !gamAdSlot.usesVideoPlayerValstream() && !gamAdSlot.isFrontendInjectableWithInjector());
        });
    },

    //
    // Determine ads meant for page load.
    __filterAdsDataByManagedVideo: function(isAutoplayAndIsOutstreamWithFloating = null){

        var ads = Object.values(this.__adsData);

        return ads.filter(function(ad){

            if(null === isAutoplayAndIsOutstreamWithFloating){

                return (ad.usesVideoPlayerValstream());
            }

            return (ad.usesVideoPlayerValstream() && ad.hasAutoplayAndIsOutstreamWithFloating() === isAutoplayAndIsOutstreamWithFloating);
        });
    },

    // //
    // // Filter bidder configs by media types.
    // __filterAdUnitBidderConfigsByMediaTypes(bidderConfigs, mediaTypes){
    //
    //     return bidderConfigs;
    //
    //     return bidderConfigs.filter(function(bidderConfig){
    //
    //         return (mediaTypes.hasOwnProperty(bidderConfig['mediaType']));
    //     });
    // },

    //
    // Sets the dimensions for an ad.
    __setAdDimensions: function(ad, newAdData){

        var width  = 'auto';
        var height = 'auto';

        if(ad['customDimensions'] !== null) {

            var dimensions = ad['customDimensions'].split('x');

            if(typeof dimensions[0] !== 'undefined' && dimensions[0] !== ''){

                if (dimensions[0].includes('%')) {

                    width = dimensions[0];
                }
                else{

                    width =`${dimensions[0]}px`;
                }
            }


            if(typeof dimensions[1] !== 'undefined' && dimensions[1] !== ''){

                if(dimensions[1].includes('%')){

                    height = dimensions[1];
                }
                else{

                    height =`${dimensions[1]}px`;
                }
            }
        }
        else if((ad['dimension'] !== null ) && 'no_size' !== ad['dimension']['dimension']){

            var dimensions = ad['dimension']['dimension'].split('x');
            width          = `${dimensions[0]}px`;
            height         = `${dimensions[1]}px`;
        }

        newAdData['width']  = width;
        newAdData['height'] = height;
    },

    //
    // Copies an existing entry from adsData and replaces the adElementId.
    copyAndAddNewAdDataFromExisting(oldAdElementId, newAdElementId){

        var adData               = this.getAdsData(oldAdElementId);
        var newAdData            = JSON.parse(JSON.stringify(adData));
        newAdData['adElementId'] = newAdElementId;
        newAdData                = new AdsNinjaAdUnit(newAdData);

        this.__addNewAdData(newAdData);

        // Update zone mapping.
        this.__createOrUpdateAdZoneMapping(newAdData['zoneGroupName'], newAdData['zoneName'], newAdData['adElementId']);

        window.adsNinja.zoneDelegate.map(newAdData, true);

        return newAdData;
    },

    //
    // Adds a new ad unit to the ad data array.
    __addNewAdData(newAdData){

        this.__adsData[newAdData['adElementId']] = newAdData;
        this.__prebidBidSentToGAM[newAdData['adElementId']] = null;
    },

    //
    // Creates and adds a new ad unit to the ad data array.
    __createAndAddNewAdData: function(ad, pageNumber = null){

        // TODO: Move to new class for this.
        var bidderTypes = ad['bidderTypes'];
        var useAmazon   = false;
        var usePrebid   = false;

        // Determine if zone is on page load.
        var onPageLoad    = (!ad['isDynamicallyInjected']);
        var foundZone     = false;
        var pageLoadZones = this.getAdBehaviourValue('pageLoadZones');

        if(pageLoadZones && Array.isArray(pageLoadZones) && pageLoadZones.length > 0){

            for(var x in pageLoadZones){

                if(pageLoadZones[x]['name'] === ad['zone']['name']){
    
                    foundZone = true;
    
                    break;
                }
            }
        }
        else{

            var onLoadAuctionZones = ['sticky footer',  'below first paragraph', 'first', 'Instream-Feature', 'above latest', 'sticky header', 'default'];

            for(var x in onLoadAuctionZones){

                if(onLoadAuctionZones[x].toLowerCase() === ad['zone']['name']){
    
                    foundZone = true;
    
                    break;
                }
            }
        }

        onPageLoad = ((onPageLoad && foundZone) || this.isFirstRepeatable(ad));

        var pos       = ad.positionsName;
        var sizeArray = ad.sizeArray;

        if(sizeArray){

            sizeArray = JSON.parse(sizeArray);
        }
        else{

            sizeArray = null;
        }

        if(pos !== "" ){

            var pos = JSON.parse(pos);
        }
        else{

            pos = null;
        }

        for(var y in bidderTypes){

            var bidderType = bidderTypes[y];

            if(bidderType.name === 'Amazon'){

                useAmazon = true;
            }
            else if(bidderType.name === 'Prebid'){

                usePrebid = true;
            }
        }

        var bidPoolName = this.__determineBidPoolNameForAd(ad, pageNumber);

        var newAdData = {
            zoneName: ad.zone.name,
            zoneGroupName: ad.zone.groupName,
            useAmazon: useAmazon,
            usePrebid: usePrebid,
            adElementId: ad.divId,
            onPageLoad: onPageLoad,
            dynamicInjectionRefresh: ad.refreshOptions,
            floating: ad.floatingOptions,
            adUnitPath: ad.slotName,
            pos: pos,
            sizeArray: sizeArray,
            originalAdData: ad,
            pageNumber: pageNumber,
            bidPoolName: bidPoolName,
        };

        this.__setAdDimensions(ad, newAdData);

        newAdData = new window.AdsNinjaAdUnit(newAdData);

        this.__createBidPool(newAdData.getBidPoolName());
        this.__addNewAdData(newAdData);

        this.setNoFillCount(newAdData['adElementId']);

        // Add zone mapping.
        this.__createOrUpdateAdZoneMapping(newAdData['zoneGroupName'], newAdData['zoneName'], newAdData['adElementId']);

        window.adsNinja.zoneDelegate.map(newAdData);

        return newAdData;
    },

    //
    // A hack to check if it is the first repeatable ad
    isFirstRepeatable: function(ad){
        
        if(ad['zone']['name'] === 'character count repeatable #1' || ad['divId'].endsWith('REPEAT1') ){

            return true;
        }

        return false;
    },

    //
    // Sets ad mode.
    setModeAds: function(mode){

        this.__modeAds = mode;
    },

    //
    // Returns device type.
    getDeviceType: function(){

        return this.__deviceType;
    },

    //
    // Returns true if device type is mobile.
    isMobile: function(){

        return ('mobile' === this.__deviceType);
    },

    //
    // Returns true if device type is desktop.
    isDesktop: function(){

        return ('desktop' === this.__deviceType);
    },

    //
    // Sets device type.
    setDeviceType: function(deviceType){

        this.__deviceType = deviceType;
    },

    //
    // Initializes manager.
    init: function(data){

        if(this.__initialized){

            this.log('Unable to init adsNinjaHeaderBiddingManager, it has already been initialized.');
            return;
        }

        this.setData(data);

        var prebidTimeout                  = data['prebidTimeout'];
        var amazonTimeout                  = data['amazonTimeout'];
        var failsafeTimeout                = data['failSafeTimeout'];
        var failsafeTimeoutCmp             = data['cmpTimeout'];
        var consentNeeded                  = data['consentNeeded'] || data['isEuTraffic'];
        var logData                        = data['logData'];
        var ads                            = data['adsData'];
        this.logger                        = new AdsNinjaLogger();
        // this.__userActivityMonitor         = new AdsNinjaUserActivityMonitor();
        this.__eventHelper                 = new AdsNinjaEventHelper();
        this.__consentManager              = new AdsNinjaConsentManager(this.logger);
        this.__logData                     = ('object' === typeof logData) ? logData : JSON.parse(logData);
        this.__previousDocumentHeight      = this.getDocumentHeight();
        this.__requestsNotSentToGAMCounter = new ANTelemetryRecorder('requestsNotSentToGAM');
        this.__revenueRecorder             = new ANTelemetryRevenueRecorder('revenue', 0.5, true, true, this.__brandsServingVideosOutsideOfGAM);
        var self                           = this;    
        this.floatingManager               = window.adsNinja.floatingManager;
        this.__prebid                      = new ANBiddingLibraryPrebid(this.logger);    
        this.__amazon                      = new ANBiddingLibraryAmazon(this.logger);
        this.auctionManager                = new ANAuctionManager(this.__eventHelper, this.logger);
        this.floatingDelegate              = new AdsNinjaFloatingDelegate(null, this.getAdBehaviourValue('refloatOutstream') || null, this.logger, this.__eventHelper, {
            handleAdCloseButtonClick: function(event, ad){

                self.handleAdCloseButtonClick(event, ad);
            },
        });

        this.addBiddingProcessTracking('dom_completed', 'start', null, 'onPageLoad', 0);
        this.addBiddingProcessTracking('dom_completed', 'end', null, 'onPageLoad', performance.now());

        this.logger.info(`Chosen ad setup: ${this.getAdSetupName()}.`, this.__logData);            
        this.initializeGPTRequestReceivedHandler();

        // Add crucible tracking for video outside GAM
        if(this.__brandsServingVideosOutsideOfGAM.indexOf(this.getBrandName()) !== -1){
            window._crucible = { config: {
                gamLineItemMap: {},
                organizationId: '34aff903-461e-4ee8-ab67-684924e1a1d0',
                noAdxFill: true,
                noBanner: true
            }, q: []};
            var crucibleTrackingScript = document.createElement('script');
            crucibleTrackingScript.src = "https://scribe.adforge.io/index.js";
            crucibleTrackingScript.async = true;
            crucibleTrackingScript.type = "text/javascript";
            document.head.appendChild(crucibleTrackingScript);
        }

        this.__prebidTimeout      = (!prebidTimeout || isNaN(prebidTimeout)) ? 3001 : prebidTimeout;
        this.__amazonTimeout      = (!amazonTimeout || isNaN(amazonTimeout)) ? 3001 : amazonTimeout;
        this.__failsafeTimeout    = (!failsafeTimeout || isNaN(failsafeTimeout)) ? 3501 : failsafeTimeout;
        this.__failsafeTimeoutCmp = (!failsafeTimeoutCmp || isNaN(failsafeTimeoutCmp)) ? 4001 : failsafeTimeoutCmp;
        this.__consentNeeded      = ('boolean' === typeof consentNeeded) ? consentNeeded : false;
        this.__primeGeos          = {
            AU: 'AU', 
            CA: 'CA', 
            GB: 'GB', 
            US: 'US',
        };

        this.__failsafeTimeout = this.getAdBehaviourValue('globalFailsafeTimeout', this.__failsafeTimeout);
        this.__amazonTimeout   = this.getAdBehaviourValue('amazonTimeout', this.__amazonTimeout);
        this.__prebidTimeout   = this.getAdBehaviourValue('prebidTimeout', this.__prebidTimeout);

        var geo = this.getGeo();

        if((geo && !this.__primeGeos.hasOwnProperty(geo))){

            this.__prebidTimeout   = 1000;
            this.__amazonTimeout   = 1000;
            this.__failsafeTimeout = 1500;
            this.MAX_NUMBER_OF_NO_NEW_BID_AUCTIONS = 1; // Less GAM request for non-prime
        }

        if (localStorage.getItem('muralWasPresent') === 'true' && localStorage.getItem('userHasMural') === null) {
            this.__logData['clientData']['isAdBlockConverted'] = '1';
        } else {
            this.__logData['clientData']['isAdBlockConverted'] = '0';
        }

        this.__injectAnchor();
        this.__addClassesToBody();

        this.__initialized = true;
    },

    //
    // Sets up an auction.
    setup: function(gamAdSlots, isPageLoad = false){

        // var timerId = window.adsNinja.benchmarker.startTimer('setup');

        if(!this.__initialized){

            throw new Error(`Unable to setup auction, adsNinjaHeaderBiddingManager has not been initialized yet.`);
        }

        var filteredGamAdSlots = this.__filterGamAdSlotsByPageLoadAndIsDefined(gamAdSlots, isPageLoad);

        // No need to check user activity for first display auction.

        var amazonTimeout                  = this.__amazonTimeout;
        var prebidTimeout                  = this.__prebidTimeout;
        var adServerRequestFailsafeTimeout = this.__failsafeTimeout;

        // Check if auction is page load.
        // if(isPageLoad && 'TheGamer' === this.getBrandName()){

        //     amazonTimeout                  = 1000;
        //     prebidTimeout                  = 1000;
        //     adServerRequestFailsafeTimeout = 1500;
        // }
        // else 
        // if(isPageLoad && ('TheThings' === this.getBrandName() || 'TopSpeed' === this.getBrandName())){

        //     amazonTimeout                  = 500;
        //     prebidTimeout                  = 500;
        //     adServerRequestFailsafeTimeout = 1000;
        // }

        var auction = this.__createAuction(isPageLoad);
        auction.setLogger(this.logger);
        auction.setAmazonTimeout(amazonTimeout);
        auction.setPrebidTimeout(prebidTimeout);
        auction.setAdServerRequestFailsafeTimeout(adServerRequestFailsafeTimeout);
        auction.setconsentNeeded(this.__consentNeeded);
        auction.setIsPageLoad(isPageLoad);
        auction.setGamAdSlots(filteredGamAdSlots || []);
        auction.setPrebidAdUnitBidderConfigs(this.prebidAdUnitBidderConfigs); // TODO: Filter out ones we need from ones we don't.
        auction.setBrand(this.getBrandName());

        auction                  = this.__setupAmazon(auction);
        auction                  = this.__setupPrebid(auction);
        var auctionId            = auction.getId();
        this.auctions[auctionId] = auction;

        // Register auction.
        this.__registerAuctionsInDictionary(auction, auction.getGamAdSlots());

        // window.adsNinja.benchmarker.stopTimer(timerId);

        return auction;
    },

    //
    // Sets up a video auction.
    setupAuctionVideo: function(gamAdSlot, prebidAdUnitBidderConfigs, placement, inflateBidPool = false, noBiddingAuction = false, completionCallback = null){

        // var timerId = window.adsNinja.benchmarker.startTimer('setupAuctionVideo');

        if(!this.__initialized){

            throw new Error(`Unable to setup auction, adsNinjaHeaderBiddingManager has not been initialized yet.`);
        }

        var auction = this.__createAuction(null, 'video-' + placement + '-' + Date.now().toString());
        auction.setLogger(this.logger);
        auction.setAmazonTimeout(this.__amazonTimeout);
        auction.setPrebidTimeout(this.__prebidTimeout);
        auction.setAdServerRequestFailsafeTimeout(this.__failsafeTimeout);
        auction.setconsentNeeded(this.__consentNeeded);
        auction.setIsPageLoad(false);
        auction.setGamAdSlots([gamAdSlot] || []);
        auction.setPrebidAdUnitBidderConfigs(prebidAdUnitBidderConfigs);
        auction.setCompletionCallbackForVideo(completionCallback);
        auction.setVideoPlacement(placement);
        auction.setBrand(this.getBrandName());
        auction.setInflateBidPool(inflateBidPool);
        auction.setNoBiddingAuction(noBiddingAuction);

        if(!noBiddingAuction){

            var adDimensions = gamAdSlot.getCurrentDimensions();
            auction          = this.__setupAmazon(auction, adDimensions);
            auction          = this.__setupPrebid(auction, adDimensions);

            // Seed telemetry revenue recorder with Prebid ad unit bids.
            var videoPrebidAdUnits = auction.getVideoPrebidAdUnits();
            // var videoAmazonAdSlot = auction.getVideoAmazonAdSlot();         // TODO: Amazon.

            // this.__revenueRecorder.addPrebidAdUnitsToTrack(videoPrebidAdUnits);
            // this.__revenueRecorder.addAmazonAdUnitsToTrack([videoAmazonAdSlot]);         // TODO: Amazon.

            auction.setBiddersForAdUnits(videoPrebidAdUnits);
        }

        var auctionId            = auction.getId();
        this.auctions[auctionId] = auction;

        // Register auction.
        this.__registerAuctionsInDictionary(auction, [gamAdSlot]);

        // window.adsNinja.benchmarker.stopTimer(timerId);

        return auction;
    },

    //
    // Sets up a repeatable auction.
    setupAuctionRepeatable: function(gamAdSlots, idAuction = null){

        if(!this.__initialized){

            throw new Error(`Unable to setup auction, adsNinjaHeaderBiddingManager has not been initialized yet.`);
        }

        var auction = this.__createAuction(false, idAuction);
        auction.setLogger(this.logger);
        auction.setAmazonTimeout(this.__amazonTimeout);
        auction.setPrebidTimeout(this.__prebidTimeout);
        auction.setAdServerRequestFailsafeTimeout(this.__failsafeTimeout);
        auction.setconsentNeeded(this.__consentNeeded);
        auction.setIsPageLoad(false);
        auction.setGamAdSlots(gamAdSlots);
        auction.setPrebidAdUnitBidderConfigs(this.prebidAdUnitBidderConfigs);
        auction.setShouldDelaySendingAdServerRequest(false);
        auction.setBrand(this.getBrandName());

        auction                  = this.__setupAmazon(auction);
        auction                  = this.__setupPrebid(auction);
        var auctionId            = auction.getId();
        this.auctions[auctionId] = auction;

        // Register auction.
        this.__registerAuctionsInDictionary(auction, gamAdSlots);

        return auction;
    },

    //
    // Sets up a refresh auction.
    setupRefreshAuction: function(gamAdSlot, prebidAdUnitBidderConfigs = null, amazonTimeout = null, prebidTimeout = null, idAuction = null, noBiddingAuction = false){

        // var timerId = window.adsNinja.benchmarker.startTimer('setupRefreshAuction');

        if(!this.__initialized){

            throw new Error(`Unable to setup auction, adsNinjaHeaderBiddingManager has not been initialized yet.`);
        }

        var auction = this.__createAuction(false, idAuction || gamAdSlot['adElementId']);
        auction.setLogger(this.logger);
        auction.setAmazonTimeout(amazonTimeout || this.__amazonTimeout);
        auction.setPrebidTimeout(prebidTimeout || this.__prebidTimeout);
        auction.setAdServerRequestFailsafeTimeout(this.__failsafeTimeout);
        auction.setconsentNeeded(this.__consentNeeded);
        auction.setIsPageLoad(false);
        auction.setGamAdSlots([gamAdSlot] || []);
        auction.setPrebidAdUnitBidderConfigs(prebidAdUnitBidderConfigs || this.prebidAdUnitBidderConfigs);
        auction.setShouldDelaySendingAdServerRequest(true);
        auction.setBrand(this.getBrandName());

        if(!noBiddingAuction){

            auction                  = this.__setupAmazon(auction);
            auction                  = this.__setupPrebid(auction);
        }
        
        var auctionId            = auction.getId();
        this.auctions[auctionId] = auction;

        // Register auction.
        this.__registerAuctionsInDictionary(auction, [gamAdSlot]);

        // window.adsNinja.benchmarker.stopTimer(timerId);

        return auction;
    },

    //
    // Sets up a seed bids auction.
    setupSeedBidsAuction: function(gamAdSlot, prebidAdUnitBidderConfigs, amazonTimeout = null, prebidTimeout = null, idAuction = null){

        if(!this.__initialized){

            throw new Error(`Unable to setup auction, adsNinjaHeaderBiddingManager has not been initialized yet.`);
        }

        var auction = this.__createAuction(false, idAuction || gamAdSlot['adElementId']);
        auction.setLogger(this.logger);
        auction.setAmazonTimeout(amazonTimeout || this.__amazonTimeout);
        auction.setPrebidTimeout(prebidTimeout || this.__prebidTimeout);
        auction.setAdServerRequestFailsafeTimeout(this.__failsafeTimeout);
        auction.setconsentNeeded(this.__consentNeeded);
        auction.setIsPageLoad(false);
        auction.setGamAdSlots([gamAdSlot] || []);
        auction.setPrebidAdUnitBidderConfigs(prebidAdUnitBidderConfigs);
        auction.setShouldDelaySendingAdServerRequest(true);
        auction.setInflateBidPool(true);
        auction.setBrand(this.getBrandName());
        auction.setIsAdServerRequestSent(true);

        auction                  = this.__setupAmazon(auction);
        auction                  = this.__setupPrebid(auction);
        var auctionId            = auction.getId();
        this.auctions[auctionId] = auction;

        // Register auction.
        this.__registerAuctionsInDictionary(auction, [gamAdSlot]);

        return auction;
    },

    //
    // Get seed bids and add them to the pool.
    getNewBidsToSeedPool: function(adElementId){

        this.logger.debug('Starting a seed bids auction!');

        var adUnit = this.getAdsData(adElementId); 
        
        if(!adUnit.isVideoRequestModeDisplay()){

            this.logger.debug('Video ad, not seeding bids.', adUnit);
            return;
        }

        var idAuction = adUnit.getAdElementId() + '_' + 'seed' + '_' + Date.now();
        var gamAdSlot = adUnit;
        
        var seedAuction = this.setupSeedBidsAuction(gamAdSlot, this.prebidAdUnitBidderConfigs, null, null, idAuction);

        this.requestHeaderBids(seedAuction.getId());

        this.logger.debug('Seed bids auction done!', seedAuction);

        if(adUnit){

            var adUnitName = adUnit.getName();

            this.__requestsNotSentToGAMCounter.increment(adUnitName, 'display', true);
        }
    },

    //
    // Sets up an asynchronous auction. Used by lazy loaded pages.
    setupAjaxAuction: function(gamAdSlots, prebidAdUnitBidderConfigs){ // TODO: Rename.

        if(!this.__initialized){

            throw new Error(`Unable to setup auction, adsNinjaHeaderBiddingManager has not been initialized yet.`);
        }

        // No need to check user activity as this auction happens as a result of user action.

        var auction = this.__createAuction();
        auction.setLogger(this.logger);
        auction.setAmazonTimeout(this.__amazonTimeout);
        auction.setPrebidTimeout(this.__prebidTimeout);
        auction.setAdServerRequestFailsafeTimeout(this.__failsafeTimeout);
        auction.setconsentNeeded(this.__consentNeeded);
        auction.setIsPageLoad(false);
        auction.setGamAdSlots(gamAdSlots || []);
        auction.setPrebidAdUnitBidderConfigs(prebidAdUnitBidderConfigs);
        auction.setBrand(this.getBrandName());

        auction                  = this.__setupAmazon(auction);
        auction                  = this.__setupPrebid(auction);
        var auctionId            = auction.getId();
        this.auctions[auctionId] = auction;

        // Register auction.
        this.__registerAuctionsInDictionary(auction, gamAdSlots);

        return auction;
    },

    //
    // Sets up Amazon bidding for a given auction, if needed.
    __setupAmazon: function(auction, adDimensions){

        if('v1' !== this.__version){

            return this.__amazon.setupAuction(auction, adDimensions);
        }

        var adWidth  = null;
        var adHeight = null;
        var adSize   = null;

        // TODO: What's the status of dynamic sizes?
        if(false && adDimensions && adDimensions.hasOwnProperty('width') && adDimensions.hasOwnProperty('height')){

            adWidth  = adDimensions.width;
            adHeight = adDimensions.height;
            adSize   = [adWidth, adHeight];
        }

        var gamAdSlots = auction.getGamAdSlots();

        if(!gamAdSlots || gamAdSlots.length === 0){

            this.log('Unable to setup Amazon: gamAdSlots is empty!', auction);
            return auction;
        }

        for(var x in gamAdSlots){

            // TODO: Here, check how many requests we've sent out.

            var gamAdSlot = gamAdSlots[x];

            // Make sure we want an amazon ad.
            if(true !== gamAdSlot['useAmazon'] && 'true' !== gamAdSlot['useAmazon']){

                continue;
            }

            // TODO: Is this needed?
            // var sizes = this.__formatSizeArrayForAmazonAdRequest(gamAdSlot['sizeArray']);
            var sizes = gamAdSlot['sizeArray'];

            if(!sizes || !Array.isArray(sizes) || sizes.length === 0){

                this.log('Unable to process GAM ad slot for amazon: sizes empty!', gamAdSlot);
                continue;
            }

            var videoSettings     = gamAdSlot.getVideoSettings();
            var amazonAdSlot      = {
                slotID: gamAdSlot['adElementId'],
                slotName: gamAdSlot['adUnitPath'],
                // adsNinja: {
                //     adElementId: gamAdSlot['adElementId'],
                //     adUnitPath:  gamAdSlot['adUnitPath'],
                // },
            };
            var adUnitSlotDetails = {
                adElementId: gamAdSlot['adElementId'],
                adUnitPath:  gamAdSlot['adUnitPath'],
            };

            // Determine ad unit types.
            if(videoSettings && gamAdSlot.isVideoRequestModeVideo()){

                // Overwrite the slotID to be "preroll".
                amazonAdSlot['slotID']    = (gamAdSlot.hasSupportForVideoInstream()) ? 'preroll' : 'outstream'; // TODO: Make configurable.
                amazonAdSlot['mediaType'] = 'video';
                amazonAdSlot['sizes']     = (adSize) ? [adSize] : [[640, 480]]; // TODO: Get current size?
                // TODO: This stays.

                if(window.adsNinja 
                    && window.adsNinja.floorHelper 
                    && typeof window.adsNinja.floorHelper.addAmazonAdElementIdOverride === 'function'
                ){

                    window.adsNinja.floorHelper.addAmazonAdElementIdOverride(gamAdSlot['adElementId'], amazonAdSlot['slotID']); // TODO: Look to remove.
                }

                delete amazonAdSlot['slotName'];
            }
            else if(videoSettings && gamAdSlot.isVideoRequestModeDisplay()){

                amazonAdSlot['mediaType'] = 'video';
                amazonAdSlot['video']     = { // TODO: This stays.
                    sizes: (adSize) ? [adSize] : [[300, 250]], // TODO: Get current size?
                };

                // TODO: This stays?
                var useBigSize = (!this.isMobile() && 'sidebar' !== gamAdSlot['zoneGroupName'] && 'header' !== gamAdSlot['zoneName']);
                var isSmallFloating = (this.isMobile() && 'header' === gamAdSlot['zoneName']);
                var width = 544;
                var height = 306;

                if(isSmallFloating){

                    width = 176;
                    height = 99;
                }
                else if(useBigSize){

                    width = 544;
                    height = 306;
                }
                else{

                    width = 304;
                    height = 171;
                }

                adUnitSlotDetails['video'] = {
                    width: width,
                    height: height,
                };

                delete amazonAdSlot['slotName'];
            }
            else{

                amazonAdSlot['sizes'] = sizes;
                
                // // Supports multi-format (dislpay and video).
                // // This is now the default.
                // // To revert to display only, use this: "amazonAdSlot['sizes'] = sizes;".
                // amazonAdSlot['mediaType']             = 'multi-format';
                // amazonAdSlot['multiFormatProperties'] = {
                //     display: {
                //         sizes: sizes,
                //     },
                //     video: {
                //         sizes: [[640, 480]],
                //     },
                // };
            }

            auction.addAmazonAdSlot(amazonAdSlot);
            // this.amazonAdSlots.push(amazonAdSlot);

            // Create mapping.
            adUnitSlotDetails['amazonAdSlot']                           = amazonAdSlot;
            this.__adUnitSlotDetails['amazon'][gamAdSlot['adUnitPath']] = adUnitSlotDetails;
        }

        if(auction.getAmazonAdSlots().length > 0){

            this.log(`Amazon data for auction: ${auction.getId()}.`, {
                amazonAdSlots: auction.getAmazonAdSlots(),
                amazonTimeout: auction.getAmazonTimeout(),
            });
        }
        else{

            this.log(`Not using Amazon for auction: ${auction.getId()}.`);
        }

        // Don't re-configure settings.
        if('onPageLoad' === auction.getId()){

            this.__initAmazon();
        }

        return auction;
    },

    //
    // Initialize Amazon.
    __initAmazon: function(){

        // Testing new APS library
        if (["SimpleFlying"].includes(this.getBrandName())) {
            loadApstagExtensions();
        }

        if(!window.adsNinjaAmazonInitData){

            return;
        }

        // Add more data.
        var signals = {
            ortb2: {
                site: {
                    cattax: 7,
                    cat: [this.getCat()],
                    name: this.getBrandName(),
                    ext: {
                        template: this.getTemplate(),
                        cat: this.getSiteCategory(),
                        postID: this.getPostId(),
                    },
                },
            },
        };

        window.adsNinjaAmazonInitData['signals'] = signals;

        if(!window.apstag || typeof window.apstag.init !== 'function'){

            this.logger.error('Cannot initialize Amazon. File apstag.js is not available.');

            return;
        }

        window.apstag.init(window.adsNinjaAmazonInitData);

        // Must enable Amazon Shopping Recommendations right after init.
        if (window.apstag && typeof window.apstag.customPlacements == 'function' && typeof window.adsNinjaAmazonResolve == 'function') {
          try {
            window.apstag.queue.push(function() {
              window.apstag.customPlacements().enable();
              window.adsNinjaAmazonResolve(true); // Allows promise-blocked apstag code to run.
            })
          } catch(e) {
            this.log(`Error initializing ASR: ${e}`);
          }
        }

        // BETA: Testing for protected audience.
        if('DualShockers' === this.getBrandName() && typeof aps == 'object' && aps && typeof aps.record == 'function'){

            aps.record("protectedAudience/allSlots/activate");
        }
    },

    //
    // Sets up Prebid bidding for a given auction, if needed.
    __setupPrebid: function(auction, adDimensions = null){

        if('v1' !== this.__version){
        
            return this.__prebid.setupAuction(auction, adDimensions);
        }

        if(this.__isPrebidDisabled){

            this.log('Prebid is disabled!', auction);

            return auction;
        }

        var definedSlots        = [];
        var gamAdSlots          = auction.getGamAdSlots();
        var adUnitBidderConfigs = auction.getPrebidAdUnitBidderConfigs();
        var prebidTimeout       = auction.getPrebidTimeout();
        var prebidServerTimeout = prebidTimeout - 300;
        var consentNeeded       = auction.getConsentNeeded();

        if(!gamAdSlots || gamAdSlots.length === 0 || !adUnitBidderConfigs || Object.keys(adUnitBidderConfigs).length === 0){

            this.log('Unable to setup Prebid: gamAdSlots or adUnitBidderConfigs is empty!', auction);
            return auction;
        }

        for(var x in gamAdSlots){

            var gamAdSlot = gamAdSlots[x];

            // Make sure we want an amazon ad.
            if(true !== gamAdSlot['usePrebid'] && 'true' !== gamAdSlot['usePrebid']){

                continue;
            }

            // Get sizes.
            var sizes = '';

            if(Array.isArray(gamAdSlot['sizeArray'])) {

                for (var z in gamAdSlot['sizeArray']) {

                    if (sizes) {

                        sizes += ',';
                    }

                    sizes += gamAdSlot['sizeArray'][z][0];
                    sizes += 'x';
                    sizes += gamAdSlot['sizeArray'][z][1];
                }
            }

            if(!sizes){

                this.log('Unable to process GAM ad slot for prebid: sizes empty!', gamAdSlot);
                continue;
            }

            // Get positions.
            var positions = '';

            if(!Array.isArray(gamAdSlot['pos'])){

                this.log('Unable to process GAM ad slot: value for key pos is not an array!', gamAdSlot);
                continue;
            }

            for(var w in gamAdSlot['pos']){

                if(positions){

                    positions += ',';
                }

                positions += gamAdSlot['pos'][w];
            }

            if(!positions){

                this.log('Unable to process GAM ad slot for Prebid: positions empty!', gamAdSlot);
                continue;
            }

            definedSlots.push({
                id: gamAdSlot['adElementId'],
                sizes: sizes,
                pos: positions,
                zoneName: gamAdSlot['zoneName'],
                adUnitPath: gamAdSlot['adUnitPath'],
                data: gamAdSlot,
            });
        }

        if(0 === definedSlots.length){

            this.log(`Not using Prebid for auction: ${auction.getId()}.`);
            return auction;
        }

        /*
         * For each bidder, we have to add the appropriate id to the adUnit
         * This is done by adding a "bid" into the bids array that holds 2 things
         * { bidder: 'biddername', params: { bidderparams }
         * from http://prebid.org/dev-docs/bidders.html
         */

        // window.pbjs.bidders = window.pbjs.bidders || []; 						// Each bidder's data
        var prebidBidders = [];

        /*
         * Below are the ids coming from the Mapping File.
         * Just copy column N for each bidder in the appropriate part. (don't forget the last line, the closing '];')
         * The excel sheet sets all the value into the bidderData array
         * and under each part, it's added to the pbjs object under the bidder name
         */

        if(typeof adUnitBidderConfigs !== 'undefined'){

            var urlParams  = new URLSearchParams(window.location.search);
            var ignoreBids = urlParams.get('pbjs_ignore_bids');
            ignoreBids     = (ignoreBids) ? ignoreBids.split(',') : ignoreBids;
            var keys       = Object.keys(adUnitBidderConfigs);

            keys.forEach(function(prebidBidder){

                if(ignoreBids && ignoreBids.includes(prebidBidder)){

                    window.adsNinjaHeaderBiddingManager.log(`Ignoring Prebid bidder: ${prebidBidder}.`);
                    return;
                }

                prebidBidders.push({name: prebidBidder, data: adUnitBidderConfigs[prebidBidder]});
            });
        }
        else{

            this.log(`No Prebid bidders available.`);
            return auction;
        }

        // TODO: Add exception handling or fallback for defined slots.

        for(var a in definedSlots){

            var prebidAdUnits = [];

            if(!definedSlots[a]['data'].usesVideoPlayerValstream()){

                prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders));
            }
            else{

                switch(definedSlots[a]['data'].getVideoContextName()){

                    case this.PREBID_BID_MODE_VALSTREAM_INSTREAM:

                        prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders, this.PREBID_BID_MODE_VALSTREAM_INSTREAM, adDimensions));
                        prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders, this.PREBID_BID_MODE_VALSTREAM_OUTSTREAM, adDimensions));
                        break;

                    case this.PREBID_BID_MODE_VALSTREAM_OUTSTREAM:

                        prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders, this.PREBID_BID_MODE_VALSTREAM_OUTSTREAM, adDimensions));
                        break;

                    case this.PREBID_BID_MODE_VALSTREAM_COMPANION:

                        prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders, this.PREBID_BID_MODE_VALSTREAM_COMPANION, adDimensions));
                        prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders, this.PREBID_BID_MODE_VALSTREAM_OUTSTREAM, adDimensions));
                        break;

                    case this.PREBID_BID_MODE_VALSTREAM_ACCOMPANYING:

                        prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders, this.PREBID_BID_MODE_VALSTREAM_COMPANION, adDimensions));
                        prebidAdUnits.push(this.__createAdUnitToAuctionPrebid(definedSlots[a], prebidBidders, this.PREBID_BID_MODE_VALSTREAM_OUTSTREAM, adDimensions));
                        break;
                }
            }

            for(var u in prebidAdUnits){

                // We only add this to the request if there is at least one bidder that will bid on this adUnit
                if(prebidAdUnits[u].bids.length > 0){

                    auction.addPrebidAdUnit(prebidAdUnits[u]);
                    // this.prebidAdUnits.push(prebidAdUnits[u]);
                }
            }
        }

        this.log(`Prebid data for auction: ${auction.getId()}.`, {
            definedSlots: definedSlots,
            adUnitBidderConfigs: adUnitBidderConfigs,
            prebidAdUnits: auction.getPrebidAdUnits(),
            prebidServerAliasData: this.__prebidServerAliasData,
        });

        // Don't re-configure settings.
        if('onPageLoad' !== auction.getId()){

            return auction;
        }

        var self = this;

        // Sending request
        window.pbjs.que.push(function(){ // Enqueue the command to prebid to execute when it's ready

            window.pbjs.enableAnalytics([
                {provider: 'adagio'}, //Enable Adagio Analytics adapter
                {
                    provider: 'atsAnalytics',
                    options: {
                        pid: '13704'
                    }
                }
            ]);

            var priceBuckets = [
                { max:  5, increment : 0.01, },
                { max: 10, increment : 0.05, },
                { max: 20, increment : 0.10, },
                { max: 50, increment : 0.25, },
            ];

            var customConfigObjectForVideo = {
                buckets: [
                    { max: 10, increment: 0.05, },
                    { max: 20, increment: 0.25, },
                    { max: 50, increment: 0.50, },
                ],
            };

            //Set up SNM Price buckets if SNM domain
            var validDomainsSNM = [
                'thesportster.com'
            ];

            for(var a in validDomainsSNM){

                if(-1 !== window.location.hostname.indexOf(validDomainsSNM[a])){

                    priceBuckets = [
                        { max: 50.99, increment: 0.01}
                    ];

                    break;
                }
            }

            // Custom bucket as defined
            var customConfigObject = {
                buckets: priceBuckets,
            };

            var ortbMobile = self.isMobile() ? 1 : 0;

            // Prebid configuration.
            var prebidConfig = {
                bidderTimeout: self.__prebidTimeout,                		// Timeout 2 sec to match A9
                //sendBidsControl: { bidLimit: 1 },				// Send top 1 bid received
                disableAjaxTimeout: true,
                targetingControls: {
                    alwaysIncludeDeals: true				// Even if a bid is not highest, if there's a deal, will send it.
                },
                mediaTypePriceGranularity: {
                    banner: customConfigObject,
                    'video-instream': customConfigObjectForVideo,
                    'video-outstream': customConfigObject,
                },		// Set price granularity object
                pageUrl: document.location.href,
                // sizeConfig: [{                       		// Supported sizes
                //     'mediaQuery': '(min-width: 0px)',
                //     'sizesSupported': [[320,50], [300,250], [300,600], [336,280], [728,90], [970,250], [640, 400]],
                //     'labels': ['any']
                // }],
                userSync: {                         		// Enable user sync in iframe (vs image)
                    filterSettings:{
                        iframe:{
                            bidders: '*',                   // Enables all iframe based userSyncs.
                            filter: 'include',
                        },
                        image: {
                            bidders: '*',                   // Enables all image based userSyncs.
                            filter: 'include',
                        },
                    },
                    iframeEnabled: true,
                    userIds: [{
                        name: 'criteo',
                    }, {
                        name: "id5Id",
                        params: {
                            partner: 518,
                        },
                        storage: {
                            type: "html5",            // Param "html5" is the required storage type.
                            name: "id5id",            // Param "id5id" is the required storage name.
                            expires: 90,              // Storage lasts for 90 days.
                            refreshInSeconds: 8*3600, // Refresh ID every 8 hours to ensure it's fresh.
                        },

                    },{
                        name: "identityLink",
                        params: {
                            pid: '13704',             // Set your real ATS Placement ID here
                            // notUse3P: true/false    // If you do not want to use 3P endpoint to retrieve the envelope. If you do not set this property to true, 3P endpoint will be fired. By default this property is undefined and 3P request will be fired.
                        },
                        storage: {
                            type: "cookie",
                            name: "idl_env",       // "idl_env" is the required storage name
                            expires: 15,            // Identity envelope can last for 15 days
                            refreshInSeconds: 1800,
                        }
                    },{
                        name: 'hadronId',
                        storage: {
                            name: 'hadronId',
                            type: 'html5'
                        },
                        params: {
                            partnerId: 269
                        }
                    }, {
                        name: "amxId",
                        storage: {
                            type: "html5",
                            name: "amxId",
                            expires: 1
                        }
                    }, {
                        name: "sharedId",
                        params: {
                            pixelUrl: "/cvx/client/sync/fpc" //the path your web server will forward to Epsilon
                        },
                        storage: {
                            type: "cookie",
                            name: "_pubcid",
                            expires: 365
                        }
                    }, {
                        name: "lotamePanoramaId",
                        params: {
                            clientId: "17231"
                        }
                    }, {
                        name: "pairId",
                        params: {
                            liveramp: {
                                storageKey: '_lr_pairId'
                            }
                        }
                    }, {
                        name: "unifiedId",
                        params: {
                            partner: "a9ik5j7",
                        },
                        storage: {
                            type: "cookie",
                            name: "pbjs-unifiedid",       // create a cookie with this name
                            expires: 60,                   // cookie can last for 60 days
                        },
                    }],
                    syncDelay: 5000,
                    syncEnabled: true,
                },
                // debug: true,
                // debugging: {
                //     enabled: true,
                //     bids: [{
                //         cpm: 9.9
                //     }]
                // },
                usePrebidCache: true,
                cache: {
                    url: 'https://prebid.adnxs.com/pbc/v1/cache', // TODO: Need different set of line items because of the creatives.
                    // url: 'https://pbs.adsninja.ca/cache',
                    ignoreBidderCacheKey: true, // TODO: Do we need this?
                },
                deviceAccess: true,
                yahoossp: { mode: 'all' },
                improvedigital: {
                    usePrebidSizes: true,
                },
                paapi: {
                    enabled: true,
                    bidders: ['openx', 'pubmatic', 'criteo', 'ix'],
                    defaultForSlots: 1
                },
                enableTIDs: true                
            }

            // Test prebid local cache
            const excludedDomains = ['military.com'];
            if (!excludedDomains.some(domain => window.location.hostname.includes(domain))) {
                prebidConfig.cache = { useLocal: true };
            }

            if (!prebidConfig.hasOwnProperty("ortb2")) {
                prebidConfig.ortb2 = {
                    site: {
                        mobile: ortbMobile
                    }
                };
            }

            if(self.getBrandName() === 'TheThings'){

                prebidConfig.sendBidsControl = { bidLimit : 1 }; // Send only top bid received

            }else{
                prebidConfig.enableSendAllBids = true; // Send all bids received

            }

            // Set UID2 if email is available
            if (typeof window.websiteUserEmail !== 'undefined' && window.websiteUserEmail !== '') {
                
                prebidConfig.userSync.userIds.push({
                    name: "uid2",
                    params : {
                        serverPublicKey: "UID2-X-P-MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAE3ezCBA1qMBPSgum+q7S1mt7q4D+XS0xuRNr5rwPdC1RmG1aYeknuRUayo8z3J6eF2xam7YuoNq9N02q9XiBvhg==",
                        subscriptionId: "SKZwkDyxLh",
                        email: window.websiteUserEmail
                    }
                });
            } 

            var floors = {};
            
            if(window.adsNinja 
                && window.adsNinja.floorHelper
                && typeof window.adsNinja.floorHelper.getBidstreamFloorsForPrebid === 'function'
            ){

                floors = window.adsNinja.floorHelper.getBidstreamFloorsForPrebid();

                if(floors 
                    && typeof floors === 'object' 
                    && Object.keys(floors).length > 0
                    && typeof window.adsNinja.floorHelper.getCustomKeySchemaForPrebid === 'function'
                    && typeof window.adsNinja.floorHelper.constructAdditionalSchemaFieldLookupsAttributeForPrebid === 'function'
                ){

                    prebidConfig.floors = {
                        data: {
                            currency: 'USD',
                            skipRate: 0,
                            schema: window.adsNinja.floorHelper.getCustomKeySchemaForPrebid(),
                            values: floors,
                        },
                        additionalSchemaFields : window.adsNinja.floorHelper.constructAdditionalSchemaFieldLookupsAttributeForPrebid(),
                    };
                }
            }

            prebidConfig.realTimeData = {
                auctionDelay: 100,
                dataProviders: [{
                    name: "hadron",
                    waitForIt: true,
                    params: {
                        segmentCache: false,
                        partnerId: 269
                    }
                },
                {
                    name: 'airgrid',
                    waitForIt: true,
                    params: {
                        apiKey: 'b151b0a8-b368-414e-b29c-9fa42b1f9b00',
                        accountId: '0Iu7Vb',
                        publisherId: 'v7hh13',
                        bidders: ['appnexus']
                    }
                }]
            };

            if(!window.adsNinjaHeaderBiddingManager.__consentContext && window.adsNinjaHeaderBiddingManager.__consentNeeded){

                // TODO: Remove.
                // For deployment compatability.
                prebidConfig.consentManagement = {
                    gdpr: {
                        cmpApi: 'iab',
                        timeout: 100,
                        defaultGdprScope: true
                    },
                    usp: {
                        cmpApi: 'iab',
                        timeout: 100
                    },
                };
            }
            else if('gdpr' === window.adsNinjaHeaderBiddingManager.__consentContext){

                prebidConfig.consentManagement = {
                    gdpr: {
                        cmpApi: 'iab',
                        timeout: 100,
                        defaultGdprScope: true,
                    },
                };
            }
            else if('gpp' === window.adsNinjaHeaderBiddingManager.__consentContext){

                prebidConfig.consentManagement = {
                    usp: {
                        cmpApi: 'iab',
                        timeout: 100,
                    },
                    gpp:{
                        cmpApi: 'iab',
                        timeout: 100,
                    },
                };
            }

            if(window.adsNinjaHeaderBiddingManager.__prebidServerAliasData && window.adsNinjaHeaderBiddingManager.__prebidServerAliasData.hasOwnProperty('aliases') && Object.keys(window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['aliases']).length > 0 && window.adsNinjaHeaderBiddingManager.__prebidServerAliasData.hasOwnProperty('bidders') && window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['bidders'].length > 0){

                prebidConfig.s2sConfig = [{
                    accountId: '1001',
                    enabled: true,
                    bidders: window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['bidders'],
                    timeout: prebidServerTimeout,
                    adapter: 'prebidServer',
                    endpoint: {
                        // Defines the auction endpoint or the cookie_sync endpoint for the Prebid Server cluster for non-consent requests or users who grant consent.
                        p1Consent: 'https://pbs.adsninja.ca/openrtb2/auction',
                        // Defines the auction endpoint or the cookie_sync endpoint for the Prebid Server cluster for users who do not grant consent.
                        // (This is useful for a server configured to not accept any cookies to ensure compliance regulations.)
                        noP1Consent: 'https://pbs.adsninja.ca/openrtb2/auction'
                    },
                    syncEndpoint: {
                        p1Consent: 'https://pbs.adsninja.ca/cookie_sync',
                        noP1Consent: 'https://pbs.adsninja.ca/cookie_sync'
                    },
                    extPrebid: {
                        cache: {
                            vastxml: { returnCreative: false }
                        },
                        targeting: {
                            pricegranularity: {"ranges": priceBuckets}
                        },
                        aliases: window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['aliases'],
                    }
    
                }];
            }

            prebidConfig.gvlMapping = {

                omnidex: 1463

            };

            window.pbjs.setConfig(prebidConfig);

            var prebidConfigBidderSettings = {};

            for(var b in prebidBidders){

                prebidConfigBidderSettings[prebidBidders[b].name] = {
                    storageAllowed: true,
                };
            }

            if(Object.keys(prebidConfigBidderSettings).length > 0){

                window.pbjs.bidderSettings = prebidConfigBidderSettings;
            }

            // Criteo settings
            if (typeof window.CriteoHashedEmail !== 'undefined' && window.CriteoHashedEmail !== '') {
                window.pbjs.setBidderConfig({
                    bidders: ['criteo'],
                    config: {
                        ortb2: {
                            user: {
                                ext: {
                                    data: {
                                        eids: [{
                                            source: window.location.hostname,
                                            uids: [{
                                                id: window.CriteoHashedEmail,
                                                atype: 3,
                                                ext: {
                                                    stype: "hemsha256"
                                                }
                                            }]
                                        }]
                                    }
                                }
                            }
                        }
                    }
                });
            }

            self.registerEventHandlerBidWonPrebid();
            self.registerEventHandlerBidResponsePrebid();
        });

        var brandName = self.getBrandName();
        var liveIntentBrandConfig = LIVEINTENT_BRAND_MAP[brandName];
        initLiveIntent(liveIntentBrandConfig);

        return auction;
    },

    //
    // Creates Prebid ad units.
    __createAdUnitToAuctionPrebid: function(slot, prebidBidders, valstreamMode = null, adDimensions = null){

        var adWidth  = null;
        var adHeight = null;
        var adSize   = null;

        if(adDimensions && adDimensions.hasOwnProperty('width') && adDimensions.hasOwnProperty('height')){

            adWidth  = adDimensions.width;
            adHeight = adDimensions.height;
            adSize   = [adWidth, adHeight];
        }

        // Needed values;
        slot.names           = slot.pos.split(',');				// Used to iterate through
        slot.device          = this.getDeviceType();			// To set the device only once.
        slot.arrSizes        = slot.sizes.split(',');			// Used to add to prebid
        slot.arrSizesIndexed = [];

        for(var a in slot.arrSizes){

            var index                   = slot.arrSizes[a];
            var innerArray              = index.split('x')
            var arry                    = [parseInt(innerArray[0]), parseInt(innerArray[1])];
            slot.arrSizes[a]            = arry;
            slot.arrSizesIndexed[index] = arry;
        }

        var gpid = slot.adUnitPath + "#" + slot.id;

        var adUnit = {									// Basic adunit definition
            code: slot.id,
            ortb2Imp: {
                ext: {
                    gpid: gpid,
                    tid: slot.data?.tid,
                    data: {
                        pbadslot: gpid
                    }
                }
            },
            mediaTypes: {},
            bids: [],
            sizes: [],
            pubstack: {
                adUnitName: slot.zoneName,
                adUnitPath: slot.adUnitPath,
            },
        };

        for(var b in prebidBidders){

            var bidder = prebidBidders[b];

            for(var c = 0; c < slot.names.length; c++){

                var bidInfo        = bidder.data.filter(function(e){ return e.pos === slot.names[c] }, slot);
                var bidderSlotBids = [];

                for(var i in bidInfo){

                    if(!slot.arrSizesIndexed[bidInfo[i].size]){

                        continue;
                    }

                    // TODO: Should we move this during generation?
                    if(!bidInfo[i].mediaType === 'display' && !bidInfo[i].mediaType === 'videoOutstream' && !bidInfo[i].mediaType === 'videoInstream'){

                        this.log(`Unknown media type for SSP config: ${bidInfo[i].mediaType}.`, {
                            bidInfo: bidInfo,
                        });
                        continue;
                    }

                    // Configure ad unit mediaTypes.
                    if((bidInfo[i].mediaType === 'display' || (bidInfo[i].mediaType === 'displayAndInBannerVideo' && !valstreamMode)) && typeof adUnit.mediaTypes.banner === 'undefined'){

                        adUnit.mediaTypes.banner = {
                            sizes: slot.arrSizes,
                        };
                    }

                    var mimeTypes = ['video/mp4', 'video/webm', 'video/ogg', 'application/javascript', 'video/x-matroska'];

                    if(this.isAppleOsFamily()){ // TODO: This stays.

                        mimeTypes = ['video/mp4', 'application/javascript'];
                    }

                    if(this.PREBID_BID_MODE_VALSTREAM_INSTREAM === valstreamMode && bidInfo[i].mediaType === 'videoInstream' && typeof adUnit.mediaTypes.video === 'undefined'){

                        var context    = 'instream';
                        var placement  = 1;
                        var plcmt      = 1;
                        var playerSize = (adSize) ? adSize : [640, 480]; // TODO: This stays.

                        adUnit.mediaTypes.video = {
                            api: [1, 2, 7],
                            linearity: 1,
                            context: context,
                            sizes: [playerSize],
                            playerSize: playerSize,
                            mimes: mimeTypes,
                            protocols: [2, 3, 5, 6, 7, 8],
                            playbackmethod: [2],
                            skip: 1,
                            skipmin: 5,
                            maxDuration: 30,
                            minDuration: 6,
                            placement: placement,
                            plcmt: plcmt,
                            pos: 1,
                            startdelay: 0,
                            skippable: true,
                            skipafter: 5,
                            maxduration: 30,
                            minduration: 6,
                            valnetDedicatedPlayer: true,
                        };
                    }

                    if(this.PREBID_BID_MODE_VALSTREAM_OUTSTREAM === valstreamMode && bidInfo[i].mediaType === 'videoOutstream' && typeof adUnit.mediaTypes.video === 'undefined'){

                        var context    = 'outstream';
                        var placement  = 5;
                        var plcmt      = 4;
                        var playerSize = (adSize) ? adSize : [640, 480]; // TODO: This stays.

                        adUnit.mediaTypes.video = {
                            api: [1, 2, 7],
                            linearity: 1,
                            context: context,
                            sizes: [playerSize],
                            playerSize: playerSize,
                            mimes: mimeTypes,
                            protocols: [2, 3, 5, 6, 7, 8],
                            playbackmethod: [2],
                            skip: 1,
                            skipmin: 5,
                            maxDuration: 15,
                            minDuration: 5,
                            placement: placement,
                            plcmt: plcmt,
                            pos: 1,
                            useCacheKey: true,
                            renderer: { render: '', url: ''},
                            startdelay: 0,
                            skippable: true,
                            skipafter: 5,
                            maxduration: 15,
                            minduration: 5,
                            valnetDedicatedPlayer: true,
                        };

                    }

                    if(this.PREBID_BID_MODE_VALSTREAM_COMPANION === valstreamMode && bidInfo[i].mediaType === 'videoInstream' && typeof adUnit.mediaTypes.video === 'undefined'){

                        var context    = 'outstream';
                        var placement  = 3;
                        var plcmt      = 2;
                        var playerSize = (adSize) ? adSize : [640, 480]; // TODO: This stays.

                        if(this.isAdFloating(slot.id)){ // TODO: This stays.

                            placement = 5;
                        }

                        adUnit.mediaTypes.video = {
                            api: [1, 2, 7],
                            linearity: 1,
                            context: context,
                            sizes: [playerSize],
                            playerSize: playerSize,
                            mimes: mimeTypes,
                            protocols: [2, 3, 5, 6, 7, 8],
                            playbackmethod: [6],
                            skip: 1,
                            skipmin: 5,
                            maxDuration: 30,
                            minDuration: 6,
                            placement: placement,
                            plcmt: plcmt,
                            pos: 1,
                            useCacheKey: true,
                            renderer: { render: '', url: ''},
                            startdelay: 0,
                            skippable: true,
                            skipafter: 5,
                            maxduration: 30,
                            minduration: 6,
                            valnetDedicatedPlayer: true,
                        };
                    }

                    if(!valstreamMode && (bidInfo[i].mediaType === 'videoOutstream' || bidInfo[i].mediaType === 'displayAndInBannerVideo') && typeof adUnit.mediaTypes.video === 'undefined'){

                        var useBigSize = (!this.isMobile() && 'sidebar' !== slot.data.zoneGroupName && 'header' !== slot.data.zoneName);
                        var isSmallFloating = (this.isMobile() && 'header' === slot.data.zoneName);
                        var playerArraySize = [544, 306];

                        if(isSmallFloating){

                            playerArraySize = [176, 99];
                        }
                        else if(useBigSize){

                            playerArraySize = [544, 306];
                        }
                        else{

                            playerArraySize = [304, 171];
                        }

                        slot.arrSizes.push(playerArraySize);

                        var placement  = 2;

                        if(this.isAdFloatingOrAlwaysFloating(slot.id)){ // TODO: This stays.

                            placement = 5;
                        }

                        var self = this; 

                        adUnit.mediaTypes.video = {
                            api: [1, 2, 7],
                            linearity: 1,
                            delivery: [2],
                            maxDuration: 15,
                            minDuration: 5,
                            context: 'outstream',
                            sizes: [playerArraySize],
                            playerSize: playerArraySize,
                            mimes: mimeTypes,
                            protocols: [2, 3, 5, 6, 7, 8],
                            playbackmethod: [6],
                            placement: placement,
                            skip: 1,
                            skipmin: 5,
                            startdelay: 0,
                            skippable: true,
                            skipafter: 5,
                            maxduration: 15,
                            minduration: 5,
                            plcmt: 4,
                            pos: 1,
                            useCacheKey: true,
                            valnetDedicatedPlayer: false,
                            renderer: { // TODO: This stays.
                                url: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
                                render: async function(bid){
                                    bid.status = 'rendered';
                                    bid.valnetUsed = true;
                                    var adElementId = bid['adUnitCodeGAMRequest'] || bid['adUnitCode'];
                                    var adElement = document.getElementById(adElementId);
                                    var ad = self.__adsData[adElementId];

                                    // Apply styles for sticky footer video
                                    if(ad && 'sticky footer' === ad.zoneName && ad.isFloatingModeAlways()){
                                        adElement.classList.add('sticky-footer-video');
                                        playerArraySize = [176, 99];
                                    }

                                    var vastUrl = bid['vastUrl'] || null;
                                    var vastXml = bid['vastXml'] || null;

                                    // Test prebid local cache
                                    const excludedDomains = ['military.com'];
                                    if (!excludedDomains.some(domain => window.location.hostname.includes(domain))) {
                                        ({ vastUrl, vastXml } = await self.__resolvePrebidVastCache(vastUrl, vastXml, adElementId, self.logger));
                                    }

                                    window.adsNinja.render({
                                        headerBiddingLibrary: 'prebid',
                                        type: 'video',
                                        video: {
                                            adElementId,
                                            vastUrl,
                                            vastXml,
                                            extraInfo: {
                                                adserverTargeting: bid['adserverTargeting'] || null,
                                                adUnitId: bid['adUnitId'] || null,
                                                auctionId: bid['auctionId'] || null,
                                                bidder: bid['bidder'] || null,
                                                creativeId: bid['creativeId'] || null,
                                                floorData: bid['floorData'] || null,
                                                height: bid['height'] || null,
                                                params: bid['params'] || null,
                                                requestId: bid['requestId'] || null,
                                                timeToRespond: bid['timeToRespond'] || null,
                                                transactionId: bid['transactionId'] || null,
                                                ttl: bid['ttl'] || null,
                                                valnetSentNumberOfTimes: bid['valnetSentNumberOfTimes'] || null,
                                                vastImpUrl: bid['vastImpUrl'] || null,
                                                width: bid['width'] || null,
                                            },
                                            width: playerArraySize[0],
                                            height: playerArraySize[1],
                                        },
                                    });
                                },
                            },
                        };

                    }

                    var bidInfoParams = JSON.parse(JSON.stringify(bidInfo[i].params));

                    if(bidder.name == 'ix' && (!bidInfoParams.size || !Array.isArray(bidInfoParams.size))){ // TODO: This stays.

                        bidInfoParams.size = (adSize) ? adSize : slot.arrSizesIndexed[bidInfo[i].size];
                    }

                    if(bidder.name == 'spotx'){ // TODO: This stays.
            
                        bidInfoParams.outstream_options.slot = adUnit.code; // TODO: This stays.
                    }

                    if(bidder.name == 'oneVideo' && bidInfo[i].mediaType !== 'videoInstream'){ // TODO: This stays.

                        bidInfoParams.site.page     = window.location.href; // TODO: This stays.
                        bidInfoParams.site.referrer = document.referrer;
                    }

                    if(!valstreamMode || ((this.PREBID_BID_MODE_VALSTREAM_INSTREAM === valstreamMode ||  this.PREBID_BID_MODE_VALSTREAM_COMPANION === valstreamMode) && bidInfo[i].mediaType === 'videoInstream') || (this.PREBID_BID_MODE_VALSTREAM_OUTSTREAM === valstreamMode && bidInfo[i].mediaType === 'videoOutstream')){

                        bidderSlotBids.push({bidder: bidder.name, params: bidInfoParams});
                    }
                }

                if(bidderSlotBids.length === 0){

                    continue;
                }

                // Deduplicate bids for slot.
                for(var constructedBidA = 0; constructedBidA < bidderSlotBids.length - 1; constructedBidA++){

                    var found = false;

                    for(var constructedBidB = constructedBidA + 1; constructedBidB < bidderSlotBids.length; constructedBidB++){

                        if(JSON.stringify(bidderSlotBids[constructedBidA].params) === JSON.stringify(bidderSlotBids[constructedBidB].params)){

                            found = true;

                            break;
                        }
                    }

                    if(!found){

                        adUnit.bids.push(bidderSlotBids[constructedBidA]);
                    }
                }

                adUnit.bids.push(bidderSlotBids[bidderSlotBids.length - 1]);
            }
        }

        adUnit.sizes = slot.arrSizes;

        if(adSize){

            adUnit.sizes.push(adSize);
        }

        return adUnit;
    },

    //
    // Dynamically inject ad zones.
    dynamicallyInjectAdZones: function(contentForAdZones){

        var dynamicallyInjectAdZoneElementIds = [];

        for(elementId in contentForAdZones){

            var element = document.getElementById(elementId);

            if(!element){

                this.log(`Unable to find element on page for dynamic injection with ID: ${elementId}.`);
                continue;
            }

            element.innerHTML = contentForAdZones[elementId];

            dynamicallyInjectAdZoneElementIds.push(elementId);

        }

        if(dynamicallyInjectAdZoneElementIds.length !== 0){

            this.log(`Dynamically injected ad zones.`, {
                elementIds: dynamicallyInjectAdZoneElementIds,
            });
            return true;
        }

        this.log(`No ad zones to dynamically inject.`, {
            contentForAdZones: contentForAdZones,
        });
        return false;
    },

    //
    // Sets up refresh ad zones.
    setupDynamicallyInjectionRefreshAdZones: function(gamAdSlots, data){

        var filteredGamAdSlots = this.__getGamAdSlotsForDynamicInjectionRefresh(gamAdSlots);

        if(!filteredGamAdSlots || 0 === filteredGamAdSlots.length || !data || Object.keys(data).length === 0){

            this.log('There are no ad zones to setup dynamic injection refresh for.');
            return;
        }

        for(var x in filteredGamAdSlots){

            var gamAdSlot = filteredGamAdSlots[x];

            // TODO: Everything below can be added to constructor.
            var adElementId = gamAdSlot['adElementId'];
            var adElement   = document.getElementById(adElementId);

            if(!adElement){

                this.log('Unable to setup dynamic injection refresh ad zone: adElement cannot be found.', {
                    gamAdSlot: gamAdSlot,
                });
                continue;
            }

            var adZoneContainerElement = document.getElementById(`ad-zone-container-${adElementId}`);

            if(!adZoneContainerElement){

                this.log('Unable to setup dynamic injection refresh ad zone: adZoneContainerElement cannot be found.', {
                    gamAdSlot: gamAdSlot,
                });
                continue;
            }

            var refreshContainerElement = adElement.closest('.dynamically-injected-refresh-ad-zone');

            if(!refreshContainerElement){

                this.log('Unable to setup dynamic injection refresh ad zone: refreshContainerElement cannot be found.', {
                    gamAdSlot: gamAdSlot,
                });
                continue;
            }

            if(refreshContainerElement.getAttribute('data-original-ad-element-id')){

                this.log('Already setup dynamic injection refresh ad zone.', {
                    gamAdSlot: gamAdSlot,
                });
                continue;
            }

            var refreshContainerElementId = refreshContainerElement.id;
            var pixelDistance             = gamAdSlot['dynamicInjectionRefresh']['pixelDistance'] || null;
            var minimumTimeBuffer         = gamAdSlot['dynamicInjectionRefresh']['minimumTimeBuffer'] || null;
            var timeBuffer                = gamAdSlot['dynamicInjectionRefresh']['timer'] || null;
            var prefetch                  = gamAdSlot['dynamicInjectionRefresh']['preFetch'] || false;
            var inview                    = gamAdSlot['dynamicInjectionRefresh']['inview'] || false;
            var pixelTrigger              = gamAdSlot['dynamicInjectionRefresh']['pixelTrigger'] || false;

            // Set data attributes.
            refreshContainerElement.setAttribute('data-original-ad-element-id', adElementId);
            refreshContainerElement.setAttribute('data-current-ad-element-id', adElementId);
            refreshContainerElement.setAttribute('data-refresh-count', 0);
            refreshContainerElement.setAttribute('data-not-bidding-count', 0);
            refreshContainerElement.setAttribute('data-floating-allowed', 'true');
            refreshContainerElement.setAttribute('data-refreshing-allowed', 'true');

            // Repeatable or every ads need to get data from original ad unit.
            
            var dataAdElementId = '';

            if(adElementId.includes('-COPY')){

                dataAdElementId = adElementId.split('-COPY')[0];
            }else{

                dataAdElementId = adElementId.split('-REPEAT')[0];
            }

            var refreshData = data[dataAdElementId] || data[adElementId];

            this.initAdZoneEventsLogEntryIfNeeded(adElementId);

            var refreshingAdZone = this.__createAdsNinjaRefreshingAdZone(adElementId, refreshContainerElementId, refreshData, prefetch, gamAdSlot['zoneName'], gamAdSlot['zoneGroupName'] || null, minimumTimeBuffer, timeBuffer, pixelDistance, pixelTrigger, inview, true);

            // if(!pixelTrigger && pixelDistance){

            //     this.pixelRefreshers[adElementId] = new window.AdsNinjaAdsPixelRefresher(adElementId, refreshContainerElementId, pixelDistance, this.getDocumentHeight());
            // }
        }
    },

    handleHomeBackFillCreativeRendered: function(adElementId){
        
        var refreshingAdZone                    = this.refreshingAdZones[adElementId];
        var ad                                  = this.__adsData[adElementId];
        var homeBackfillRefreshTime             = this.getAdBehaviourValue('homeBackfillRefreshTime') || 10000;

        this.initAdZoneEventsLogEntryIfNeeded(adElementId);
        this.handleAdZoneLoadedEvent(adElementId, true);
        this.handleAdZoneViewedEvent(adElementId, true);

        if(ad.__hasFloatingOptions()){

            this.adZoneEventsLog[adElementId]['forcedEvents'] = true;
        }

        if((refreshingAdZone.hasTimerRefresh() || refreshingAdZone.hasPixelRefresh())){

            this.log(`home backfill rendered. Force refreshing in ${homeBackfillRefreshTime} miliseconds.`, {
                adElementId: adElementId,
            });

            // Set required properties to pass checks and force immediate refresh.
            this.adZoneEventsLog[adElementId]['isMinimumTimerComplete'] = true;
            this.adZoneEventsLog[adElementId]['isTimerComplete']        = true;
            this.adZoneEventsLog[adElementId]['isPrefetchTimeComplete'] = true;
            var myThis                                                  = this;

            var failRefreshInterval = setInterval(function(){

                if(!window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'autoRefresh')){

                    myThis.logger.debug(`Not able to refresh. Timeout buffer changed to ${homeBackfillRefreshTime} miliseconds.`, {
                        adElementId: adElementId,
                    });
                }
                else{

                    clearInterval(failRefreshInterval);
                }

            }, homeBackfillRefreshTime);

            this.addRefreshInterval(adElementId, failRefreshInterval);
        }
    },

    //
    // Handles forcing ad zone events.
    handleAdZoneForceEvents: function(adElementId){

        var brandsWithNewForcedRefreshOnNonFill = [];
        var refreshingAdZone                    = this.refreshingAdZones[adElementId];
        var ad                                  = this.__adsData[adElementId];
        var requestDelayWhenNoAdFill            = this.getAdBehaviourValue('requestDelayNoAdFillDisplay');
        var hasRequestDelayWhenNoAdFill         = (!!requestDelayWhenNoAdFill);

        // TODO: Do we know this is here?
        // if('TheGamer' === this.getBrandName() && refreshingAdZone){

        //     requestDelayWhenNoAdFill *= Math.max(refreshingAdZone.getNotBiddingCount() , 1);
        // }

        this.initAdZoneEventsLogEntryIfNeeded(adElementId);
        this.handleAdZoneLoadedEvent(adElementId, true);
        this.handleAdZoneViewedEvent(adElementId, hasRequestDelayWhenNoAdFill);
        
        // This is to make sure that we pass the inView check for refresh. Floating units may not be detected as being inView without this.
        if(ad.__hasFloatingOptions()){

            this.adZoneEventsLog[adElementId]['forcedEvents'] = true;
        }

        if(brandsWithNewForcedRefreshOnNonFill.includes(this.getBrandName()) && hasRequestDelayWhenNoAdFill && (refreshingAdZone.hasTimerRefresh() || refreshingAdZone.hasPixelRefresh())){

            window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'force');
        }
        else if(hasRequestDelayWhenNoAdFill && (refreshingAdZone.hasTimerRefresh() || refreshingAdZone.hasPixelRefresh())){

            this.logger.debug(`No fill. Force refreshing in ${requestDelayWhenNoAdFill} milliseconds.`, {
                adElementId: adElementId,
            });

            // Set required properties to pass checks and force immediate refresh.
            this.adZoneEventsLog[adElementId]['isMinimumTimerComplete'] = true;
            this.adZoneEventsLog[adElementId]['isTimerComplete']        = true;
            this.adZoneEventsLog[adElementId]['isPrefetchTimeComplete'] = true;
            var myThis                                                  = this;

            // Try to refresh right away then do the interval on failure.
            var hasRefreshed = this.refreshAdElement(adElementId, 'noFill');

            if(false && !hasRefreshed){ // TODO: Restrict to brand.

                var failRefreshInterval = setInterval(function(){

                    if(!window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'autoRefresh')){

                        myThis.logger.debug(`Not able to refresh. Timeout buffer changed to ${requestDelayWhenNoAdFill} miliseconds.`, {
                            adElementId: adElementId,
                        });
                    }
                    else{

                        clearInterval(failRefreshInterval);
                    }

                }, requestDelayWhenNoAdFill);

                this.addRefreshInterval(adElementId, failRefreshInterval);
            }
        }
    },

    //
    // Handles GPT slot response.
    initializeGPTRequestReceivedHandler: function(){

        var self = this;

        window.googletag.cmd.push(function(){

            window.googletag.pubads().addEventListener('slotResponseReceived', function(event){

                var adElementId = event.slot.getSlotElementId();
                var ad          = null;

                if(adElementId && self.__adsData.hasOwnProperty(adElementId)){

                    ad = self.__adsData[adElementId];
                }

                if(ad && 'sticky footer' === ad.zoneName && ad.isFloatingModeAlways()){

                    // Reset high impact ad showing.
                    self.floatingDelegate.setHighImpactAdShowing(false);
                }
            });
        });

        if(this.areBidPoolsEnabled()){

            this.log('Using bid pools');
        }else{
            this.log('Not using bid pools');
        }

        window.googletag.cmd.push(function(){

            window.googletag.pubads().addEventListener("slotRenderEnded", function(event){

                var adElementId = event.slot.getSlotElementId();
                var ad = self.getAdsData(adElementId);
                if (!ad) {
                    return;
                }
                
                if(self.areBidPoolsEnabled()){

                    self.updateAmazonBid(event.slot);
                    self.updatePrebidBid(event.slot.getSlotElementId());
                }
                
                
                if(self.__bannerEnabledEventTrackingBrand.includes(self.getBrandName())){

                    // prepare impression event data.
                    if(!event.isEmpty){

                        
                        var impressionAdvertiserId = event.advertiserId;
                        var impressionCreativeId = event.creativeId;
                        var impressionAdvertiserSource = 'gam';
                        var impressionAdvertiserAdvertiser = 'gam';
                        var cpm = 0;

                        if(ad && ad !== null){

                            var recordingOptions = self.getRecordingOptions(ad);

                            if(impressionAdvertiserId !== null){

                                var impressionAdvertiserData = self.decideBidSource(impressionAdvertiserId);
                                impressionAdvertiserSource = impressionAdvertiserData['source'];
                                impressionAdvertiserAdvertiser = impressionAdvertiserData['advertiser'];
                            }

                            var bidLifeTime = null;

                            if(impressionAdvertiserAdvertiser === 'gam'){

                                cpm = self.decideAdxCPM(ad, impressionCreativeId);
                            }else if(impressionAdvertiserSource === 'prebid'){

                                cpm = self.decidePrebidCPM(adElementId);

                                var prebidBid = self.__prebidBidSentToGAM[adElementId];
                                if(prebidBid && prebidBid.responseTimestamp){
                                    bidLifeTime = (Date.now() - prebidBid.responseTimestamp) / 1000;
                                }
                                
                            }else if(impressionAdvertiserSource === 'amazon'){
                                cpm = self.decideAmazonCPM(adElementId);
                                
                            }

                            self.__revenueRecorder.recordImpression(ad.getName(), impressionAdvertiserSource, impressionAdvertiserAdvertiser, cpm, recordingOptions, bidLifeTime);
                        }
                    }

                    
                    if(self.__prebidBidSentToGAM.hasOwnProperty(adElementId)){

                        self.__prebidBidSentToGAM[adElementId] = null;
                    }

                    if(self.__amazonBidSentToGAM.hasOwnProperty(adElementId)){

                        self.__amazonBidSentToGAM[adElementId] = null;
                    }
                    
                }

               
                // Disabling Google AdX in Outstream for now.
                // Google won the outstream bid. 
                //if(!event.isEmpty && event.vast){

                //    self.renderGoogleOutstream(event);

                //}
            });
        });
    },
    // Disabling Google AdX in Outstream for now.
    //renderGoogleOutstream: function(event){

    //    var adElementId              = event.slot.getSlotElementId();
    //    var ad = this.__adsData[adElementId];

    //    var useBigSize = (!this.isMobile() && 'sidebar' !== ad.zoneGroupName && 'header' !== ad.zoneName);
    //    var isSmallFloating = (this.isMobile() && 'header' === ad.zoneName);
    //    var playerArraySize = [544, 306];

    //    if(isSmallFloating){

    //        playerArraySize = [176, 99];
    //    }
    //    else if(useBigSize){

    //        playerArraySize = [544, 306];
    //    }
    //    else{

    //        playerArraySize = [304, 171];
    //    }

    //    window.adsNinja.render({
    //        headerBiddingLibrary: 'google',
    //        type: 'video',
    //        video: {
    //            adUnit: adElementId,
    //            vastXml: event.vast,
    //            width: playerArraySize[0],
    //            height: playerArraySize[1],
    //        },
    //    });
    //
    //},
    //
    // Handles ad zone render ended event.
    handleAdZoneRenderEndedEvent: function(event){

        if(!event){

            this.log('Unable to handle ad zone render ended event: event is empty.');
            return;
        }

        var adElementId              = event.slot.getSlotElementId();
        var slotContainsAd           = !event.isEmpty;
        var adZoneContainerElementId = `ad-zone-container-${adElementId}`;
        var adZoneContainerElement   = document.getElementById(adZoneContainerElementId);

        this.addBiddingProcessTracking('ad_render', 'end', adElementId);
        this.logAdUnitEvent(adElementId, '3. GAM Slot Render Ended');

        if(!adZoneContainerElement){

            this.log('Unable to handle ad zone render ended event: container element does not exist!', {
                adElementId: adElementId,
                adZoneContainerElementId: adZoneContainerElementId,
            });
            return;
        }

        adZoneContainerElement.classList.remove('ad-loading');

        var refreshingAdZone                    = this.refreshingAdZones[adElementId] || null;
        var numberOfConsecutiveNoNewBidAuctions = (refreshingAdZone) ? refreshingAdZone.getNotBiddingCount() : this.numberOfConsecutiveNoNewBidAuctions[adElementId];
        numberOfConsecutiveNoNewBidAuctions     = numberOfConsecutiveNoNewBidAuctions || 0;
        var ad                                  = this.__adsData[adElementId];
        var bidPoolName                         = (ad) ? ad.getBidPoolName() : null;
        var bidPool                             = (bidPoolName) ? this.bidPools[bidPoolName] : null;

        this.logger.debug('GPT Event: slotRenderEnded.', {
            slotElementId: adElementId,
            slotAdUnitPath: event.slot.getAdUnitPath(),
            slotContainsAd: slotContainsAd,
            numberOfConsecutiveNoNewBidAuctions: numberOfConsecutiveNoNewBidAuctions,
            bidPool: {
                name: bidPoolName,
                size: (bidPool) ? bidPool.getSize() : null,
                prebidBids: (bidPool) ? bidPool.getPrebidSize() : null,
                amazonBids: (bidPool) ? bidPool.getAmazonSize() : null,
            }
        });

        // Check if slot has an ad.
        if(!slotContainsAd){

            this.handleNoFillOrError(adElementId);
            return;
        }
        else{            

            if(refreshingAdZone){

                // Reset not bidding count. A new ad is about to be rendered. 
                // This is the only time we'd know if GAM could have won the auction.
                refreshingAdZone.resetNotBiddingCount(adElementId);
            }

            var hideButton = (ad) ? ad.getAdZoneRootContainerElementHideButton() : null;
    
            if(hideButton){
    
                hideButton.style.visibility = 'unset';
            }

            // Unhide zone.
            var adZoneRootContainerElement = ad.getAdZoneRootContainerElement();

            if(adZoneRootContainerElement){

                adZoneRootContainerElement.classList.remove('an-hidden');
            }

            // Handle GAM won.
            // this.handleGAMWon(ad, event.creativeId); // To support Kargo direct deals serving from GAM.
        }

        var adHeight = event.size[1];

        // Set style to allow interscroller animation for ad when height is 600px.
        if(event.hasOwnProperty('size') && event.size && Array.isArray(event.size) && event.size.length === 2 && adHeight === 600){

            // Add class to div.
            adZoneContainerElement.classList.add('an-interscroller-anim-allowed');
        }
        //Handle Home Backfill creative loaded. 
        var homeBackFillLineItemId = this.getAdBehaviourValue('homeBackfillLineItemId');
        if(homeBackFillLineItemId === event.sourceAgnosticLineItemId.toString()) { 
            
            this.handleHomeBackFillCreativeRendered(adElementId);
            return;
        }
    },

    //
    // Handles ad zone loaded event.
    handleAdZoneLoadedEvent: function(adElementId, forceRefresh = false){

        this.initAdZoneEventsLogEntryIfNeeded(adElementId);

        if(this.adZoneEventsLog[adElementId]['isLoaded']){

            return;
        }

        this.logAdUnitEvent(adElementId, '4. GAM Slot On Load');

        this.adZoneEventsLog[adElementId]['isLoaded'] = true;

        // Set loaded on container.
        var adZoneContainerElementId = `ad-zone-container-${adElementId}`;
        var adZoneContainerElement   = document.getElementById(adZoneContainerElementId);

        if(adZoneContainerElement){

            adZoneContainerElement.classList.add('ad-loaded');
            adZoneContainerElement.classList.remove('ad-loading');

            var buttonElement = adZoneContainerElement.getElementsByClassName('close-ad-zone')[0];

            if(buttonElement){

                buttonElement.classList.add('an-close-btn-visible');
            }
        }
        else{

            this.log(`Unable to find ad zone container: ${adZoneContainerElementId}.`);

            // Modify in-content ads vertical position if needed.
            this.__handleFloatingTopMiddle(adElementId, false);
        }

        if(!forceRefresh){

            // Handle floating out of view ad.
            this.__handleFloatingOutOfView(adElementId);
        }

        // if(false){

        //     // TODO: Make condition for logs that are not needed all the time.
        //     this.log(`Ad Zone Event: loaded.`, {
        //         adElementId: adElementId,
        //     });
        // }

        // var adData        = window.adsNinjaHeaderBiddingManager.getAdsData(adElementId);
        // var adDimensions  = adData.getAdDimensions();
        // var adUnitHeight  = adDimensions.heightNumeric || null;
        // var adZoneElement = adZoneContainerElement.getElementsByClassName('ad-zone')[0];

        // if(!adZoneElement){

        //     this.log('Unable to scroll animation: element does not exist in container!', {
        //         adElementId: adElementId,
        //         adZoneContainerElementId: adZoneContainerElementId,
        //     });
        //     return;
        // }

        // if(adData.getUseAutoScroll() && adUnitHeight){

        //     adZoneElement.style.height = `${adUnitHeight}px`;

        //     // Add AutoScroll waypoints.
        //     this.__addAutoScrollWaypoints(adElementId, adUnitHeight);
        // }
        // else if(adData.getUseAutoScroll()){

        //     this.removeAutoScrollIfNotNeeded(adElementId);
        // }
    },

    //
    // Handles ad zone viewed event.
    handleAdZoneViewedEvent: function(adElementId, forceRefresh = false){

        var ad                  = this.__adsData[adElementId];
        var originalAdElementId = ad.getOriginalAdElementId();
        var self                = this;

        if(!forceRefresh){

            this.__noFillCountByOrignalAd[originalAdElementId] = 0;
        }

        this.initAdZoneEventsLogEntryIfNeeded(adElementId); 

        var refreshingAdZone = this.refreshingAdZones[adElementId] || null;

        if(!refreshingAdZone){

            this.logger.error('Cannot handle ad zone viewed event. No refreshing ad zone found.', {
                adElementId: adElementId,
            });

            return;
        }

        if(this.adZoneEventsLog[adElementId]['isViewed']){

            return;
        }

        this.log(`Ad Zone Event: viewed.`, {
            adElementId: adElementId,
            isRefresh: (refreshingAdZone && refreshingAdZone.isAllowedToPrefetch()) ? true : false,
            isRefreshable: (refreshingAdZone) ? true : false,
        });

        this.adZoneEventsLog[adElementId]['isViewed'] = true;

        if(this.floatingDelegate.isAdFloating(ad) && ad.isFloatUntilViewed()){

            var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);

            // Toggle floating when using float until viewed.
            this.floatingManager.requestToDefloat(
                adElementId, 
                floatingInfoForRequest.requestor,
                true
            );
        }

        this.__recalculateRailAdZones();

        if(refreshingAdZone.hasMaxNotBiddingLimitBeenReached() && !this.__isThereBidToBeUsed(adElementId)){

            this.logger.info(`new refresh logic, Attempting to refresh ad. Refreshing is disabled for element: ${adElementId} because we reached the max not bidding limit of ${refreshingAdZone.getMaxNotBidding()} times and no new bid found in the pool`, {
                adElementId: adElementId,
            });

            // Cancel all timeouts and intervals.
            this.__clearRefreshTimeouts(adElementId);
            this.__clearRefreshIntervals(adElementId);

            // Set refreshing to false.
            refreshingAdZone.setNoRefreshingAllowed(adElementId);

            return;
        }

        // Setup prefetch.
        if(refreshingAdZone.hasTimerRefresh() && refreshingAdZone.isTimerComplete() && !forceRefresh){

            this.setupNextAd(adElementId, refreshingAdZone, refreshingAdZone.isAllowedToPrefetch(), false, 'viewed');

            var latestAuction = this.__getLatestAuction(adElementId);

            var viewedDelayTimer1 = setTimeout(function(){

                if(latestAuction && latestAuction.areAllBidsBack()){

                    window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'viewed');
                }
    
                // For safety, if the bids are not back, we will refresh the ad after the failsafe timeout.
                var viewedDelayTimer2 = setTimeout(function(){ // TODO: Clear timeouts and intervals.
    
                    window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'viewedDelay');
                }, window.adsNinjaHeaderBiddingManager.__failsafeTimeout);
    
                window.adsNinjaHeaderBiddingManager.addRefreshTimeout(adElementId, viewedDelayTimer2);
            }, 1000);

            this.addRefreshTimeout(adElementId, viewedDelayTimer1);
        }
        else if(refreshingAdZone.hasTimerRefresh() && !forceRefresh){

            // TODO: Need to revisit, what happens if you have non-timer based refreshes. Probably should use minimum timer.
            var refreshTimeBuffer  = refreshingAdZone.getTimeBuffer();
            var maxPrefetchTimeout = Math.round(refreshTimeBuffer * (7/30));
            var minPrefetchTimeout = Math.round(refreshTimeBuffer * (2/30));
            var prefetchTimeout    = (refreshTimeBuffer * 1000) - (Math.floor(Math.random() * (maxPrefetchTimeout - minPrefetchTimeout) + minPrefetchTimeout) * 1000);
            prefetchTimeout        = (prefetchTimeout && prefetchTimeout > 0) ? prefetchTimeout : 0;
            refreshingAdZone.setPrefetchTimeBuffer(prefetchTimeout);

            setTimeout(function(){ // TODO: Clear timeouts and intervals.

                self.logger.info(`prefetch timeout finished for ad element: ${adElementId}`);
                self.adZoneEventsLog[adElementId]['isPrefetchTimeComplete'] = true;
                window.adsNinjaHeaderBiddingManager.setupNextAd(adElementId, refreshingAdZone, true, false, 'delayedSetupNext');
                window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'delayedSetupNext'); // TODO: Not giving enough time for auction to complete before refreshing.
            }, prefetchTimeout);

            this.setupNextAd(adElementId, refreshingAdZone, false, false, 'viewed');
        }
        else if(this.__primeGeos.hasOwnProperty(this.getGeo())){

            this.setupNextAd(adElementId, refreshingAdZone, true, false, 'viewed');
        }
    },

    //
    // Handles ad zone minimum timer complete event.
    handleAdZoneMinimumTimerCompleteEvent: function(adElementId, extraData = {}){

        this.initAdZoneEventsLogEntryIfNeeded(adElementId);

        this.adZoneEventsLog[adElementId]['isMinimumTimerComplete'] = true;

        this.log(`Ad Zone Event: minimumTimerComplete.`, Object.assign({
            adElementId: adElementId,
        }, extraData));

        this.refreshAdElement(adElementId, 'minimumTime');
    },

    //
    // Handles ad zone timer complete event.
    handleAdZoneTimerCompleteEvent: function(adElementId, extraData = {}){

        this.initAdZoneEventsLogEntryIfNeeded(adElementId);

        this.adZoneEventsLog[adElementId]['isTimerComplete'] = true;

        this.log(`Ad Zone Event: timerComplete.`, Object.assign({
            adElementId: adElementId,
        }, extraData));

        var refreshingAdZone = this.refreshingAdZones[adElementId];

        if(!refreshingAdZone || !refreshingAdZone.hasTimerRefresh() || refreshingAdZone.getHasTransitionStarted() || !refreshingAdZone.isAllowedToRefresh()){

            return;
        }

        if (refreshingAdZone.hasMaxNotBiddingLimitBeenReached() && !this.__isThereBidToBeUsed(adElementId)) {

            this.logger.info(`new refresh logic, Attempting to refresh ad. Refreshing is disabled because prebid did not bid ${refreshingAdZone.getMaxNotBidding()} times`, {
                adElementId: adElementId,
            });

            // Cancel all timeouts and intervals.
            this.__clearRefreshTimeouts(adElementId);
            this.__clearRefreshIntervals(adElementId);
            
            // Set refreshing to false.
            refreshingAdZone.setNoRefreshingAllowed(adElementId);

            return;
        }

        var self        = this;
        var hasRefreshed = this.refreshAdElement(adElementId, 'time');

        // Start auto-refresh.
        if(false && !hasRefreshed){ // TODO: Restrict to brand.

            var failRefreshInterval = setInterval(function(){

                if(!self.refreshAdElement(adElementId, 'autoRefresh')){

                    self.logger.debug('Not able to refresh. Timeout buffer changed to 2 sec', {
                        adElementId: adElementId,

                    });

                }else{

                    clearInterval(failRefreshInterval);
                }

            }, 2000);

            this.addRefreshInterval(adElementId, failRefreshInterval);
        }

        if(!refreshingAdZone.hasMaxNotBiddingLimitBeenReached()){

            this.setupNextAd(adElementId, refreshingAdZone, refreshingAdZone.isAllowedToPrefetch(), false, 'timerComplete');
        }
    },

    //
    // Init events log.
    initAdZoneEventsLogEntryIfNeeded: function(adElementId){

        if(!this.adZoneEventsLog[adElementId]){

            this.adZoneEventsLog[adElementId] = {
                isLoaded: false,
                isViewed: false,
                haveTimersStarted: false,
                isTimerComplete: false,
                isPrefetchTimeComplete: false,
                isMinimumTimerComplete: false,
                forcedEvents: false,
                currentFloatingStatus: 'disengaged',
            };
        }
    },

    //
    // Reset events log.
    resetAdZoneEventsLog: function(adElementId){

        if(!this.adZoneEventsLog[adElementId]){

            this.initAdZoneEventsLogEntryIfNeeded();
            return;
        }

        this.adZoneEventsLog[adElementId] = {
            isLoaded: false,
            isViewed: false,
            haveTimersStarted: false,
            isTimerComplete: false,
            isPrefetchTimeComplete: false,
            isMinimumTimerComplete: false,
            forcedEvents: false,
            currentFloatingStatus: this.adZoneEventsLog[adElementId]['currentFloatingStatus'],
        };
    },

    //
    // Handles ad zone no fill or error.
    handleNoFillOrError: function(adElementId){

        var brandsWithNewForcedRefreshOnNonFill = [];
        var ad                                  = this.__adsData[adElementId];
        var adZoneContainerElement              = (ad) ? ad.getAdZoneContainerElement() : null;
        var adZoneElement                       = (ad) ? ad.getAdZoneElement() : null;
        var hideButton                          = (ad) ? ad.getAdZoneRootContainerElementHideButton() : null;

        if(!ad || !adZoneContainerElement || !adZoneElement){

            this.logger.warn(`Unable to find ad unit in list and/or on page with ad element id: ${adElementId}.`);
        }

        adZoneContainerElement.classList.add('no-fill');

        if(adZoneElement && adZoneElement.classList.contains('ad-zone-floating')){

            adZoneContainerElement.style.display = 'none';
        }

        if(hideButton){

            hideButton.style.visibility = 'hidden';
        }

        this.log(`No fill or ad error handled for ad unit with ad element id: ${adElementId}.`);

        // Modify in-content ads vertical position if needed.
        this.__handleFloatingTopMiddle(adElementId, false);

        var refreshingAdZone = this.refreshingAdZones[adElementId];

        if(refreshingAdZone && ( !refreshingAdZone.hasMaxNotBiddingLimitBeenReached() || this.__isThereBidToBeUsed(adElementId)) ){

            var requestDelayWhenNoAdFill = this.getAdBehaviourValue('requestDelayNoAdFillDisplay') || 2000; 

            if(!this.__primeGeos.hasOwnProperty(this.getGeo())){

                requestDelayWhenNoAdFill = 30000;
            }

            // var originalAdElementId      = ad.getOriginalAdElementId();

            // if('TheGamer' === this.getBrandName() && refreshingAdZone){

            //     requestDelayWhenNoAdFill *= Math.max(refreshingAdZone.getNotBiddingCount(), 1);
            // }

            // // TODO: Is this still needed?
            // if(this.__noFillCountByOrignalAd[originalAdElementId] > this.MAX_NUMBER_OF_NO_FILL_RETRIES){

            //     requestDelayWhenNoAdFill = 20000;
            // }

            // requestDelayWhenNoAdFill = 30000; // Force to 30 seconds for now.

            this.log(`No fill. Forcing loaded and viewed ad zone events after ${requestDelayWhenNoAdFill} milliseconds.`, {
                adElementId: adElementId,
            });

            var refreshTimeout = setTimeout(function(){

                window.adsNinjaHeaderBiddingManager.log(`Forcing loaded and viewed ad zone events for auction: ${adElementId}.`);

                // These need to be called if no ad shows.
                window.adsNinjaHeaderBiddingManager.handleAdZoneForceEvents(adElementId);
            }, requestDelayWhenNoAdFill);

            this.addRefreshTimeout(adElementId, refreshTimeout);
        }
        else if(refreshingAdZone && ( refreshingAdZone.hasMaxNotBiddingLimitBeenReached() && !this.__isThereBidToBeUsed(adElementId) )){

            this.logger.info(`new refresh logic, Attempting to refresh ad. Refreshing is disabled because prebid did not bid ${refreshingAdZone.getMaxNotBidding()} times`, {
                adElementId: adElementId,
            });

            // Cancel all timeouts and intervals.
            this.__clearRefreshTimeouts(adElementId);
            this.__clearRefreshIntervals(adElementId);

            // Set refreshing to false.
            refreshingAdZone.setNoRefreshingAllowed(adElementId);

            return;
        }
        else{
         
            this.logger.debug(`Unable to find refreshing ad zone.`, {
                adElementId: adElementId,
                refreshingAdZone: refreshingAdZone,
            });
        }
    },

    //
    // Validates CSS size syntax.
    __isValidWidthHeightOrOffset(value){

        if(!value || (value.indexOf('px') === -1 && value.indexOf('em') === -1 && value.indexOf('%') === -1 && value.indexOf('auto') === -1)){

            return false;
        }

        return true;
    },

    //
    // Validates dimensions.
    __validateDimensions(dimensions){

        for(var x in dimensions){

            if(!this.__isValidWidthHeightOrOffset(dimensions[x])){

                return false;
            }
        }

        return true;
    },

    //
    // Sets up floating ad zones.
    setupFloatingAdZones: function(gamAdSlots, alreadyInView = true){

        if(!gamAdSlots || gamAdSlots.length === 0){

            this.log('No ad zone to setup floating for.');
            return;
        }

        var filteredGamAdSlots = gamAdSlots.filter(function(gamAdSlot){

            return (gamAdSlot['floating'] && typeof gamAdSlot['floating'] === 'object' && Object.keys(gamAdSlot['floating']).length > 0);
        });

        if(!filteredGamAdSlots){

            this.log('No ad zone to setup floating for.');
            return;
        }

        for(var x in filteredGamAdSlots){

            var floatingAdZoneData = filteredGamAdSlots[x];
            var adElementId        = floatingAdZoneData['adElementId'];
            var options            = floatingAdZoneData['floating'];

            if(this.floatingDelegate.hasWaypoints(adElementId)){

                this.log('Unable to setup floating for ad zone: floating has already been setup for this ad zone!', {
                    adElementId: adElementId,
                });
                continue;
            }

            // Check if refresh ad zone allowed to float.
            var refreshingAdZone = window.adsNinjaHeaderBiddingManager.refreshingAdZones[adElementId];

            if(refreshingAdZone && !refreshingAdZone.isAllowedToFLoat()){

                this.log('Unable to setup floating for ad zone: refreshing ad zone has been previously closed, floating not allowed!', {
                    adElementId: adElementId,
                });
                continue;
            }

            var adZoneContainerElementId = `ad-zone-container-${adElementId}`;
            var adZoneContainerElement   = document.getElementById(adZoneContainerElementId);

            if(!adZoneContainerElement){

                this.log('Unable to setup floating for ad zone: container element does not exist!', {
                    adElementId: adElementId,
                    adZoneContainerElementId: adZoneContainerElementId,
                });
                continue;
            }

            var adZoneElement = adZoneContainerElement.getElementsByClassName('ad-zone')[0];

            if(!adZoneElement){

                this.log('Unable to setup floating for ad zone: element does not exist for container!', {
                    adElementId: adElementId,
                    adZoneContainerElementId: adZoneContainerElementId,
                });
                continue;
            }

            // TODO: Can we simplify this?
            var heightRegular         = floatingAdZoneData['height'] || options['heightRegular'];
            var widthRegular          = floatingAdZoneData['width'] || options['widthRegular'];
            var heightFloating        = options['heightFloating'];
            var widthFloating         = options['widthFloating'];
            var floatingMode          = options['floatingMode'];
            var floatingOffset        = options['floatingOffset'] || 0;
            var position              = options['position'];
            var useCloseButton        = options['useCloseButton'];
            var floatUntilViewed      = options['floatUntilViewed'] || false;
            var floatUntilViewedDelay = options['floatUntilViewedDelay'] || 0;
            var clickToFloat          = options['clickToFloat'] || false;

            this.initAdZoneEventsLogEntryIfNeeded(adElementId);

            if(floatUntilViewed && this.adZoneEventsLog[adElementId]['isViewed']){

                continue;
            }

            if(floatingAdZoneData['height'] && floatingAdZoneData['width']){

                heightFloating = (options['heightFloating']) ? `${options['heightFloating']}${options['heightFloatingPostfix']}` : floatingAdZoneData['height'];
                widthFloating  = (options['widthFloating']) ? `${options['widthFloating']}${options['widthFloatingPostfix']}` : floatingAdZoneData['width'];

                if((options['floatingOffset'] || 0 === options['floatingOffset']) && '%' === options['floatingOffsetPostfix']){

                    floatingOffset = `${options['floatingOffset']}${options['floatingOffsetPostfix']}`;

                    if(!this.__isValidWidthHeightOrOffset(floatingOffset)){

                        this.log('Unable to setup floating for ad zone: validation failed!', {
                            adElementId: adElementId,
                            data: {
                                floatingOffset: floatingOffset,
                            },
                        });
                        continue;
                    }
                }
                else if((options['floatingOffset'] || 0 === options['floatingOffset']) && '%' !== options['floatingOffsetPostfix']){

                    floatingOffset = parseFloat(options['floatingOffset']);

                    if(isNaN(floatingOffset)){

                        this.log('Unable to setup floating for ad zone: validation failed!', {
                            adElementId: adElementId,
                            data: {
                                floatingOffset: floatingOffset,
                            },
                        });
                        continue;
                    }
                }
            }

            if('string' === typeof floatingOffset && floatingOffset.includes('px')){

                floatingOffset = parseFloat(floatingOffset.replace('px', ''));
            }

            // Validate.
            var valuesToValidate = {
                heightRegular: heightRegular,
                widthRegular: widthRegular,
                heightFloating: heightFloating,
                widthFloating: widthFloating,
            };

            if(!this.__validateDimensions(valuesToValidate)){

                this.log('Unable to setup floating for ad zone: validation failed!', {
                    adElementId: adElementId,
                    data: valuesToValidate,
                });
                continue;
            }

            if(!floatingMode || !position){

                this.log('Unable to setup floating for ad zone: validation failed!', {
                    adElementId: adElementId,
                    floatingType: floatingMode,
                    position: position,
                });
                continue;
            }

            // Set data attributes.
            adZoneElement.setAttribute('data-height-regular', heightRegular);
            adZoneElement.setAttribute('data-width-regular', widthRegular);
            adZoneElement.setAttribute('data-height-floating', heightFloating);
            adZoneElement.setAttribute('data-width-floating', widthFloating);
            adZoneElement.setAttribute('data-floating-mode', floatingMode);
            adZoneElement.setAttribute('data-waypoint-offset', floatingOffset);
            adZoneElement.setAttribute('data-position', position);
            adZoneElement.setAttribute('data-use-close-button', useCloseButton);
            adZoneElement.setAttribute('data-float-until-viewed', floatUntilViewed);
            adZoneElement.setAttribute('data-float-until-viewed-delay', floatUntilViewedDelay);
            adZoneElement.setAttribute('data-is-floating', 'false');
            adZoneElement.setAttribute('data-floating-allowed', 'true');
            adZoneElement.setAttribute('data-click-to-float', clickToFloat);
            adZoneElement.setAttribute('data-floating-setup', false);

            if(clickToFloat){

                // If click to play delay setup.
                var self                               = this;
                this.floatingInitializers[adElementId] = function(event){

                    if(adZoneElement.getAttribute('data-floating-setup') === 'true'){ 

                        return;
                    }

                    self.finishFloatingSetup(floatingMode, adElementId, adZoneContainerElementId, floatingOffset, position);
                    adZoneElement.setAttribute('data-floating-setup', true);
                    adZoneElement.removeEventListener('click', self.floatingInitializers[adElementId]);
                    adZoneElement.removeEventListener('touchend', self.floatingInitializers[adElementId]);
                    delete self.floatingInitializers[adElementId];
                    self.enableFloating(adElementId);
                };

                adZoneElement.addEventListener('click', this.floatingInitializers[adElementId]);
                adZoneElement.addEventListener('touchend', this.floatingInitializers[adElementId]);
            }
            else{
                
                this.finishFloatingSetup(floatingMode, adElementId, adZoneContainerElementId, floatingOffset, position);
                adZoneElement.setAttribute('data-floating-setup', true);
            }
        }
    },

    //
    // Finishes floating setup.
    finishFloatingSetup: function(floatingMode, adElementId, adZoneContainerElementId, floatingOffset, position){
      
        switch(floatingMode){

            case 'always':

                this.handleAlwaysFloatingAdZone(adElementId, floatingOffset, 'adsninja-body-anchor', position);
                break;

            case 'outOfView':

                this.handleFloatingAdZone(adElementId, floatingOffset, adZoneContainerElementId);
                break;

            default:

                this.log('Unable to setup floating for ad zone: unknown floating mode!', {
                    adElementId: adElementId,
                    floatingType: floatingMode,
                });
        }
    },

    //
    // Handles always floating ad zones.
    handleAlwaysFloatingAdZone: function(adElementId, floatingOffset, waypointElementId, position){

        var self              = this;
        var originalElementId = adElementId.split("-count-")[0];
        var ad                = this.getAdsData(adElementId);

        if(!ad){
            
            this.logger.warn('Unable to toggle floating for ad zone: ad does not exist!', {
                adElementId: originalElementId,
            });
            return;
        }

        var floatingOptions = ad.getFloatingOptions();

        if(!floatingOptions || typeof floatingOptions !== 'object' || Object.keys(floatingOptions).length === 0){
        
            this.logger.warn('Unable to toggle floating for ad zone: no floating options!', {
                adElementId: originalElementId,
                floatingOptions: floatingOptions,
            });
            return;
        }

        var rootAdZoneElement          = ad.getAdZoneRootContainerElement();
        var adZoneContainerElement     = ad.getAdZoneContainerElement();
        var adZoneSizeContainerElement = ad.getAdZoneSizeContainerElement();
        var adZoneElement              = ad.getAdZoneElement();

        if(!rootAdZoneElement || !adZoneContainerElement || !adZoneSizeContainerElement || !adZoneElement){

            this.logger.warn('Unable to toggle floating for ad zone: one or more elements does not exist!', {
                adElementId: originalElementId,
                elements: [
                    'adZoneContainerElement',
                    'adZoneSizeContainerElement',
                    'adZoneElement',
                ],
            });
            return;
        }

        var domainsDoNotHideStyle = [
            'pocket-lint.com',
            'thetalko.com',
            'therichest.com',
            'therecipe.com',
        ];

        for(var x in domainsDoNotHideStyle){

            if(-1 !== window.location.hostname.indexOf(domainsDoNotHideStyle[x])){

                var floatingPriority = (ad) ? ad.getFloatingPriority() : 2147482647;
                floatingPriority     = floatingPriority || 2147482647;

                // rootAdZoneElement.style = `height: 0; overflow: hidden; border: none;`;
                rootAdZoneElement.style = `height: 0; border: none; position: fixed; bottom: 0px; z-index: ${floatingPriority};`;

                break;
            }
        }

        if(ad.getUsingManualFloatControl()){

            return;
        }

        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);

        if(0 === floatingOffset){

            this.floatingManager.requestToFloat(
                adElementId, 
                floatingInfoForRequest.requestor,
                floatingInfoForRequest.adType, 
                floatingInfoForRequest.position, 
                floatingInfoForRequest.floatType, 
                this.requestFloatCallback.bind(this, adElementId),
                this.requestDefloatCallback.bind(this, adElementId)
            );

            return;
        }

        var zone = window.adsNinja.zoneDelegate.getByElementId(adElementId);

        if(!zone){

            this.logger.warn('Unable to setup floating for ad zone: zone does not exist!', {
                adElementId: adElementId,
            });
            return;
        }

        var zoneElement = zone.getElement();

        if(!zoneElement){

            this.logger.warn('Unable to setup floating for ad: zone elements does not exist!', {
                adElementId: adElementId,
            });
            return;
        }

        var observer = new IntersectionObserver(function(entries, observer){

            entries.forEach(function(entry){

                if(entry.isIntersecting){

                    self.floatingManager.requestToFloat(
                        adElementId, 
                        floatingInfoForRequest.requestor,
                        floatingInfoForRequest.adType, 
                        floatingInfoForRequest.position, 
                        floatingInfoForRequest.floatType, 
                        self.requestFloatCallback.bind(self, adElementId),
                        self.requestDefloatCallback.bind(self, adElementId)
                    );
                }
            });

            observer.unobserve(zoneElement);
        }, { rootMargin: `-${floatingOffset}px 0px -${floatingOffset}px 0px` });

        observer.observe(zoneElement);
    },

    //
    // Handles floating ad zones.
    handleFloatingAdZone: function(adElementId, floatingOffset, waypointElementId){

        // Creates in-view intersection observer for floating.
        var zone = window.adsNinja.zoneDelegate.getByElementId(adElementId);

        if(!zone){

            this.logger.warn('Unable to setup floating for ad zone: zone does not exist!', {
                adElementId: adElementId,
            });
            return;
        }

        var zoneElement = zone.getElement();

        if(!zoneElement){

            this.logger.warn('Unable to setup floating for ad: zone elements does not exist!', {
                adElementId: adElementId,
            });
            return;
        }

        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);
        var self                   = this;

        // TODO: Find a way to reuse the observer.
        var observer = new IntersectionObserver(function(entries, observer){

            entries.forEach(function(entry){

                if(entry.isIntersecting){

                    self.floatingManager.requestToDefloat(
                        adElementId, 
                        floatingInfoForRequest.requestor
                    );
                }
                else if(zone.hasBeenInView()){

                    self.floatingManager.requestToFloat(
                        adElementId, 
                        floatingInfoForRequest.requestor,
                        floatingInfoForRequest.adType, 
                        floatingInfoForRequest.position, 
                        floatingInfoForRequest.floatType, 
                        self.requestFloatCallback.bind(self, adElementId),
                        self.requestDefloatCallback.bind(self, adElementId)
                    );
                }
            });

        }, { rootMargin: `${floatingOffset}px 0px ${floatingOffset}px 0px`, threshold: 0.5 });

        observer.observe(zoneElement);
        this.floatingDelegate.addWaypoint(adElementId, observer);
    },

    //
    // Toggles floating ad zones.
    toggleFloatingAdZone: function(adElementId, float){

        var self = this;
        var ad   = this.getAdsData(adElementId);

        if(!ad){
            
            this.logger.warn('Unable to toggle floating for ad zone: ad does not exist!', {
                adElementId: adElementId,
            });

            return false;
        }

        var adZoneContainerElement     = ad.getAdZoneContainerElement();
        var adZoneSizeContainerElement = ad.getAdZoneSizeContainerElement();
        var adZoneInlineElement        = ad.getAdZoneInlineElement();
        var adZoneElement              = ad.getAdZoneElement();

        if(!adZoneContainerElement || !adZoneSizeContainerElement || !adZoneInlineElement || !adZoneElement){

            this.logger.warn('Unable to toggle floating for ad zone: one or more elements does not exist!', {
                adElementId: adElementId,
                aelements: [
                    'adZoneContainerElement',
                    'adZoneSizeContainerElement',
                    'adZoneInlineElement',
                    'adZoneElement',
                ],
            });

            return false;
        }

        var adElementId                        = ad.getAdElementId();
        var adZoneContainerElementId           = adZoneContainerElement.id;
        var heightRegular                      = adZoneElement.getAttribute('data-height-regular');
        var widthRegular                       = adZoneElement.getAttribute('data-width-regular');
        var heightFloating                     = adZoneElement.getAttribute('data-height-floating');
        var widthFloating                      = adZoneElement.getAttribute('data-width-floating');
        var positionFloating                   = adZoneElement.getAttribute('data-position');
        var useCloseButton                     = adZoneElement.getAttribute('data-use-close-button');
        var floatingMode                       = adZoneElement.getAttribute('data-floating-mode');
        var floatUntilViewed                   = adZoneElement.getAttribute('data-float-until-viewed');
        var floatUntilViewedDelay              = adZoneElement.getAttribute('data-float-until-viewed-delay');
        var floatUntilViewedDelayTransitioning = adZoneElement.getAttribute('data-float-until-viewed-delay-transitioning');

        if((this.isAdFloating(adElementId) && float) || (!this.isAdFloating(adElementId) && !float)){

            this.log(`Correct floating status already applied.`, {
                adElementId: adElementId,
                adZoneContainerElementId: adZoneContainerElementId,
                status: (adZoneElement.classList.contains('ad-zone-floating')) ? 'engaged' : 'disengaged',
            });

            return true;
        }

        // TODO: Option should only be available when using "always" float mode.
        // Handle float until viewed.
        if(this.adZoneEventsLog.hasOwnProperty(adElementId) && this.adZoneEventsLog[adElementId]['isViewed'] && 'true' === floatUntilViewed && !float){

            if(floatUntilViewedDelay && '0' !== floatUntilViewedDelay && 'true' !== floatUntilViewedDelayTransitioning){

                adZoneElement.setAttribute('data-float-until-viewed-delay-transitioning', 'true');

                var directionMultiplier = 1;

                if(-1 !== positionFloating.indexOf('top')){

                    directionMultiplier = -1;
                }

                var transitionTime = 1000;
                var animationDelay = parseInt(floatUntilViewedDelay) - transitionTime;

                adZoneElement.style.transform  = 'translateY(0px)';
                adZoneElement.style.transition = `transform ${transitionTime}ms ${animationDelay}ms ease`;
                adZoneElement.style.transform  = `translateY(${parseInt(heightFloating) * directionMultiplier}px)`;

                setTimeout(function(){

                    adZoneElement.setAttribute('data-float-until-viewed-delay-transintioning', 'false');

                    window.adsNinjaHeaderBiddingManager.log('Floating ad has been viewed and can no longer float.', {
                        adElementId: adElementId,
                    });

                    if(self.floatingDelegate.isAdFloating(ad)){

                        // TODO: Fix duplicate code.
                        adZoneElement.style.transition = 'none !important;';
                        adZoneElement.style.transform  = 'none !important;';

                        adZoneElement.classList.remove('ad-zone-floating');
                        adZoneElement.classList.remove(`an-floating-pos-${positionFloating}`);
                        adZoneElement.setAttribute('data-is-floating', 'false');

                        adZoneInlineElement.style                     = '';
                        adZoneSizeContainerElement.style              = '';
                        adZoneContainerElement.style                  = '';
                        adZoneElement.style                           = 'text-align: center;';
                        adZoneElement.style[heightProperty]           = heightRegular;
                        adZoneElement.style.width                     = widthRegular;

                        if('always' === floatingMode){

                            adZoneElement.style.overflow = 'unset';
                        }

                        self.hideCloseButton(adElementId);
                    }

                    // Delete floating waypoint if exists.
                    window.adsNinjaHeaderBiddingManager.deleteFloatingAdWaypoints(adElementId);
                    window.adsNinjaHeaderBiddingManager.deleteAutoScrollWaypoints(adElementId); // For safety.
                }, parseInt(floatUntilViewedDelay));

                return true;
            }
            else if('true' === floatUntilViewedDelayTransitioning){

                return true;
            }
        }
        else if(this.adZoneEventsLog.hasOwnProperty(adElementId) && this.adZoneEventsLog[adElementId]['isViewed'] && 'true' === floatUntilViewed && float){

            return true;
        }

        // Check if values are valid.
        if(!heightRegular || !widthRegular || !heightFloating || !widthFloating || !positionFloating || !floatingMode){

            window.adsNinjaHeaderBiddingManager.log('Unable to toggle floating on ad zone: invalid value!', {
                adElementId: adElementId,
                heightRegular: heightRegular,
                widthRegular: widthRegular,
                heightFloating: heightFloating,
                widthFloating: widthFloating,
                positionFloating: positionFloating,
                floatingType: floatingMode,
            });
            return false;
        }

        var status                      = null;
        var adData                      = window.adsNinjaHeaderBiddingManager.getAdsData(adElementId);
        var hasVideoValstreamCapability = this.__checkAdCapabilityByAdZoneName(this.AD_CAPABILITY_VIDEO_VALSTREAM, adData.zoneName);
        var hasSupportForVideoOutstream = (hasVideoValstreamCapability) ? adData.hasSupportForVideoOutstream() : false;
        var floatingOptions             = adData.getFloatingOptions();
        var floatingPriority            = adData.getFloatingPriority();

        var heightProperty = 'minHeight';

        if(adData.getUseAutoScroll() || 'always' === floatingMode || hasVideoValstreamCapability){

            heightProperty = 'height';
        }

        if(this.floatingDelegate.isAdFloating(ad)){

            // TODO: Fix duplicate code.
            adZoneElement.style.transition = 'none !important;';
            adZoneElement.style.transform  = 'none !important;';

            adZoneElement.classList.remove('ad-zone-floating');
            adZoneElement.classList.remove(`an-floating-pos-${positionFloating}`);
            adZoneElement.setAttribute('data-is-floating', 'false');

            // adZoneInlineElement.children[0].style.display = 'inherit;';
            adZoneInlineElement.style                     = '';
            adZoneSizeContainerElement.style              = '';
            adZoneContainerElement.style                  = '';
            adZoneElement.style                           = 'text-align: center;';
            adZoneElement.style[heightProperty]           = heightRegular;
            adZoneElement.style.width                     = widthRegular;

            if('always' === floatingMode){

                adZoneElement.style.overflow = 'unset';
            }

            if(hasVideoValstreamCapability){

                try{

                    var heightRegularValstream = ('auto' === heightRegular) ? 'inherit' : heightRegular;
                    var widthRegularValstream  = ('auto' === widthRegular) ? 'inherit' : widthRegular;

                    this.handleFloatingDisengagedVideoPlayer(adElementId, heightRegularValstream, widthRegularValstream);
                }
                catch(error){

                    this.log('Unable to handle Valstream floating disengaged.', {
                        error: error,
                    });
                }
            }

            this.hideCloseButton(adElementId);

            status = 'disengaged';
        }
        else if(!adZoneContainerElement.classList.contains('no-fill')){

            if(floatingOptions && typeof floatingOptions === 'object' && Object.keys(floatingOptions).length !== 0){

                adZoneElement.classList.add('ad-zone-floating');
                adZoneElement.classList.add(`an-floating-pos-${positionFloating}`);
                adZoneElement.setAttribute('data-is-floating', 'true');

                // adZoneInlineElement.children[0].style.display    = 'inline-block;';
                adZoneInlineElement.style                        = '';
                adZoneInlineElement.style                        = 'position: relative; display: inline-block;';
                adZoneElement.style                              = '';
                adZoneElement.style                              = 'text-align: center; margin: 0; padding: 0; position: fixed; display: block;' // TODO: display: flex; align-items: flex-end; need this to when player is not floating.
                adZoneElement.style.zIndex                       = floatingPriority;
                adZoneElement.style[heightProperty]              = heightFloating;
                adZoneElement.style.width                        = widthFloating;
                adZoneSizeContainerElement.style[heightProperty] = heightRegular;
                adZoneSizeContainerElement.style.width           = widthRegular;
                // adZoneContainerElement.style.zIndex           = floatingPriority;

                if('always' === floatingMode && !adData.isVideoRequestModeDisplay()){

                    adZoneElement.style.overflow = 'hidden';
                }

                if(hasVideoValstreamCapability){

                    try{

                        this.handleFloatingEngagedVideoPlayer(adElementId, heightFloating, widthFloating);
                    }
                    catch(error){

                        window.adsNinjaHeaderBiddingManager.log('Unable to handle Valstream floating engaged.', {
                            error: error,
                        });
                    }
                }
            }

            var closeButtonText  = '&#x2715';
            var closeButtonStyle = `width: 16px; height: 16px; font-family: arial,helvetica,clean,sans-serif; font-size: 11px; color: white; font-weight: 700; text-transform: uppercase; z-index: ${floatingPriority}; position: absolute; top: 0; right: -16px; background: none; background-color: dimgrey; padding: 2px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; text-align: center; line-height: normal;`;

            switch(positionFloating){

                case 'bottom-right':

                    if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){

                        adZoneElement.style.right           = '0';
                        adZoneElement.style.bottom          = (adData && adData.isVideoRequestModeDisplay()) ? '38px' : '55px';
                        closeButtonStyle                    = `width: 20px; height: 20px; font-family: arial,helvetica,clean,sans-serif; font-size: 16px; color: white; font-weight: 900; text-transform: uppercase; z-index: ${floatingPriority}; background: none; background-color: dimgrey; padding: 2px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0 0 0px auto;line-height: normal;`;
                        adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 20}px`; // Height of container with close button.
                    }
                    else{

                        adZoneElement.style.right           = (adData && adData.isVideoRequestModeDisplay()) ? '-18px' : '10px';
                        adZoneElement.style.bottom          = (adData && adData.isVideoRequestModeDisplay()) ? '-44px' : '11px';
                        closeButtonText                     = '&#x2715';
                        closeButtonStyle                    = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 40px; height: 35px; font-family: arial,helvetica,clean,sans-serif; position: absolute; font-size: 18px; top: 0px; left: 0px; color: white; font-weight: 700; text-align: center; text-transform: uppercase; z-index: ${floatingPriority}; background: none; positiion: absolute; padding: 2px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; line-height: normal;`;
                        // adZoneElement.style.backgroundColor = 'dimgrey';
                        adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 24}px`; // Height of container with close button.
                    }

                    break;

                case 'bottom-left':

                    if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){

                        if(adData.isVideo()){

                            adZoneElement.style.left            = '15px';
                            adZoneElement.style.bottom          = (ad && ad.isVideoRequestModeDisplay()) ? '38px' : '50px';
                            closeButtonStyle                    = `width: 23px; height: 23px; font-family: arial,helvetica,clean,sans-serif; font-size: 16px; color: white;  text-transform: uppercase; background: none;  outline: none; border: none; border-radius: 20px; cursor: pointer; margin: 0 0 0px; line-height: normal;position: absolute;top: 0px;left: 0px;text-shadow: 0px 0px 4px black;`;
                            adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 20}px`; // Height of container with close button.
                        }
                        else{

                            adZoneElement.style.left            = '0';
                            adZoneElement.style.bottom          = (adData && adData.isVideoRequestModeDisplay()) ? '38px' : '55px';
                            closeButtonStyle                    = `width: 20px; height: 20px; font-family: arial,helvetica,clean,sans-serif; font-size: 16px; color: white; font-weight: 900; text-transform: uppercase; z-index: ${floatingPriority}; background: none; background-color: dimgrey; padding: 2px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0 0 0px;line-height: normal;`;
                            // adZoneElement.style.width           = '100%';
                            // adZoneElement.style.bottom          = '0';
                            // closeButtonStyle                    = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 23px; height: 23px; font-family: arial,helvetica,clean,sans-serif; font-size: 30px; color: white; font-weight: 700; text-transform: uppercase; z-index: ${floatingPriority}; position: absolute; top: 5px; right: -38px; background: none; background-color: none; padding: 0px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; text-align: center; line-height: normal;`;
                            adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 20}px`; // Height of container with close button.
                            // adZoneElement.style                 = 'text-align: left; margin: 0; padding: 5px 5px 5px 15px !important; position: fixed; display: block;width: 100%;bottom: 0;' // TODO: display: flex; align-items: flex-end; need this to when player is not floating.
                        }
                    }
                    else{

                        adZoneElement.style.left            = (adData && adData.isVideoRequestModeDisplay()) ? '-21px' : '10px';
                        adZoneElement.style.bottom          = (adData && adData.isVideoRequestModeDisplay()) ? '-44px' : '11px';
                        closeButtonText                     = '&#x2715';
                        closeButtonStyle                    = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 40px; height: 35px; font-family: arial,helvetica,clean,sans-serif; position: absolute; font-size: 18px; top: 0px; left: 0px; color: white; font-weight: 700; text-align: center; text-transform: uppercase; z-index: ${floatingPriority}; background: none; positiion: absolute; padding: 2px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; line-height: normal;`;
                        // adZoneElement.style.backgroundColor = 'dimgrey';
                        adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 24}px`; // Height of container with close button.
                    }

                    break;

                case 'bottom-middle':
                    if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){
                        // closeButtonStyle = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 30px; height: 30px; font-family: arial,helvetica,clean,sans-serif; font-size: 30px; color: white; font-weight: 700; text-transform: uppercase; z-index: ${floatingPriority}; position: absolute; top: 5px; right: -38px; background: none; background-color: none; padding: 0px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; text-align: center; line-height: normal;`;

                            adZoneElement.style.left            = '0';
                            // adZoneElement.style.bottom          = (adData && adData.isVideoRequestModeDisplay()) ? '38px' : '55px';
                            // closeButtonStyle                    = `width: 20px; height: 20px; font-family: arial,helvetica,clean,sans-serif; font-size: 16px; color: white; font-weight: 900; text-transform: uppercase; z-index: ${floatingPriority}; background: none; background-color: dimgrey; padding: 2px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0 0 0px;line-height: normal;`;
                            adZoneElement.style.width           = '100%';
                            adZoneElement.style.bottom          = '0';
                            closeButtonStyle                    = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 23px; height: 23px; font-family: arial,helvetica,clean,sans-serif; font-size: 30px; color: white; font-weight: 700; text-transform: uppercase; z-index: ${floatingPriority}; position: absolute; top: 5px; right: -38px; background: none; background-color: none; padding: 0px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; text-align: center; line-height: normal;`;
                            adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 20}px`; // Height of container with close button.
                            adZoneElement.style                 = 'text-align: left; margin: 0; padding: 5px 5px 5px 15px !important; position: fixed; display: block;width: 100%;bottom: 0;' // TODO: display: flex; align-items: flex-end; need this to when player is not floating.
                    }
                    adZoneElement.style.width   = '100%';
                    adZoneElement.style.bottom  = '0';
                    adZoneElement.style.left    = '0';

                    break;

                case 'top-middle':

                    adZoneElement.style.width   = '100%';
                    adZoneElement.style.top     = '54px';
                    adZoneElement.style.left    = '0';

                    if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){

                        adZoneElement.style.padding = '.25rem 0';
                    }

                    break;

                case 'top-left':

                    adZoneElement.style.width   = floatingOptions.widthFloating + 90 + floatingOptions.widthFloatingPostfix;
                    adZoneElement.style.top     = '0';
                    adZoneElement.style.left    = '0';

                    if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){

                        adZoneElement.style.padding = '.25rem 0';
                    }

                    break;
            }

            if('false' !== useCloseButton){

                this.showCloseButton(adElementId, {
                    zIndex: floatingPriority,
                    text: closeButtonText,
                    isUsingFakeAds: this.__isUsingFakeAds(),
                    style: closeButtonStyle,
                }); 
            }

            status = 'engaged';
        }

        window.adsNinjaHeaderBiddingManager.log(`Floating ${status} for ad zone in container: ${adZoneContainerElementId}.`);

        window.adsNinjaHeaderBiddingManager.adZoneEventsLog[adElementId]['currentFloatingStatus'] = status;

        if('engaged' === status){

            // Modify in-content ads vertical position if needed.
            this.__handleFloatingTopMiddle(adElementId, true);
        }

        // Try to refresh ad.
        this.refreshAdElement(adElementId, 'float');

        return true;
    },

    //
    // Handles floating engaged.
    handleFloatingEngaged: function(adElementId){
      
        var self                   = this;
        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);

        this.floatingManager.requestToFloat(
            adElementId, 
            floatingInfoForRequest.requestor,
            floatingInfoForRequest.adType, 
            floatingInfoForRequest.position, 
            floatingInfoForRequest.floatType, 
            this.requestFloatCallback.bind(this, adElementId),
            this.requestDefloatCallback.bind(this, adElementId)
        );

        // var ad = this.getAdsData(adElementId);

        // if(!ad){
            
        //     this.logger.warn('Unable to toggle floating for ad zone: ad does not exist!', {
        //         adElementId: adElementId,
        //     });
        //     return;
        // }

        // var floatingOptions = ad.getFloatingOptions();

        // if(!floatingOptions || typeof floatingOptions !== 'object' || Object.keys(floatingOptions).length === 0){
        
        //     this.logger.warn('Unable to toggle floating for ad zone: no floating options!', {
        //         adElementId: adElementId,
        //         floatingOptions: floatingOptions,
        //     });
        //     return;
        // }

        // var rootAdZoneElement          = ad.getAdZoneRootContainerElement();
        // var adZoneContainerElement     = ad.getAdZoneContainerElement();
        // var adZoneSizeContainerElement = ad.getAdZoneSizeContainerElement();
        // var adZoneElement              = ad.getAdZoneElement();

        // if(!rootAdZoneElement || !adZoneContainerElement || !adZoneSizeContainerElement || !adZoneElement){

        //     this.logger.warn('Unable to toggle floating for ad zone: one or more elements does not exist!', {
        //         adElementId: adElementId,
        //         elements: [
        //             'adZoneContainerElement',
        //             'adZoneSizeContainerElement',
        //             'adZoneElement',
        //         ],
        //     });
        //     return;
        // }

        // var heightRegular     = adZoneElement.getAttribute('data-height-regular');
        // var widthRegular      = adZoneElement.getAttribute('data-width-regular');
        // var heightFloating    = adZoneElement.getAttribute('data-height-floating');
        // var widthFloating     = adZoneElement.getAttribute('data-width-floating');
        // var positionFloating  = adZoneElement.getAttribute('data-position');
        // var floatingPriority  = ad.getFloatingPriority();
        // var heightProperty    = ad.getFloatingAdHeightProperty();                               // TODO: Will be addressed in the next task.
        // var heightPropertyAlt = ('minHeight' === heightProperty) ? 'height' : 'min-height';     // TODO: Will be addressed in the next task.

        // rootAdZoneElement.classList.add('an-invisible');
        // rootAdZoneElement.classList.remove('an-visible');
        // adZoneElement.classList.add('an-invisible');
        // adZoneElement.classList.remove('an-visible');
        // adZoneElement.classList.add('ad-zone-floating');
        // adZoneElement.classList.add(`an-floating-pos-${positionFloating}`);
        // adZoneElement.setAttribute('data-is-floating', 'true');

        // if(positionFloating.includes('middle')){

        //     widthFloating = '100%';
        // }

        // adZoneElement.style.zIndex                          = floatingPriority;
        // adZoneElement.style[heightProperty]                 = heightFloating;
        // adZoneElement.style[heightPropertyAlt]              = '';
        // adZoneElement.style.width                           = widthFloating; // TODO: Will be addressed in the next task. (widthRegular) widthFloating;
        // adZoneSizeContainerElement.style[heightProperty]    = heightRegular;
        // adZoneSizeContainerElement.style[heightPropertyAlt] = '';
        // adZoneSizeContainerElement.style.width              = widthRegular;

        // var isVideoFloating         = this.handleFloatingEngagedVideoPlayer(adElementId, heightFloating, widthFloating);
        // var isDesktopAndBottomRight = false;
        // var closeButtonText         = '&#x2715';

        // // TODO: This should be configured in the UI.
        // if('bottom-right' === positionFloating && this.isDesktop()){ 

        //     closeButtonText         = 'CLOSE &#x2715';
        //     isDesktopAndBottomRight = true;
        // }

        // if(isDesktopAndBottomRight && isVideoFloating){

        //     adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 16}px`;     // Handle close button size.
        // }

        // Show the close button if needed. One will be created if it doesn't already exist.
        // this.showCloseButton(adElementId, {
        //     zIndex: floatingPriority,
        //     text: closeButtonText,
        //     isUsingFakeAds: this.__isUsingFakeAds(),
        // });

        // adZoneElement.classList.add('an-visible');
        // adZoneElement.classList.remove('an-invisible');
        // rootAdZoneElement.classList.add('an-visible');
        // rootAdZoneElement.classList.remove('an-invisible');
    },

    //
    // Handles floating disengaged.
    handleFloatingDisengaged: function(adElementId){

        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);

        this.floatingManager.requestToDefloat(
            adElementId, 
            floatingInfoForRequest.requestor
        );

        // var ad = this.getAdsData(adElementId);

        // if(!ad){
            
        //     this.logger.warn('Unable to toggle floating for ad zone: ad does not exist!', {
        //         adElementId: adElementId,
        //     });
        //     return;
        // }

        // var floatingOptions = ad.getFloatingOptions();

        // if(!floatingOptions || typeof floatingOptions !== 'object' || Object.keys(floatingOptions).length === 0){
        
        //     this.logger.warn('Unable to toggle floating for ad zone: no floating options!', {
        //         adElementId: adElementId,
        //         floatingOptions: floatingOptions,
        //     });
        //     return;
        // }

        // var rootAdZoneElement          = ad.getAdZoneRootContainerElement();
        // var adZoneSizeContainerElement = ad.getAdZoneSizeContainerElement();
        // var adZoneElement              = ad.getAdZoneElement();

        // if(!rootAdZoneElement || !adZoneSizeContainerElement || !adZoneElement){

        //     this.logger.warn('Unable to toggle floating for ad zone: one or more elements does not exist!', {
        //         adElementId: adElementId,
        //         elements: [
        //             'adZoneSizeContainerElement',
        //             'adZoneElement',
        //         ],
        //     });
        //     return;
        // }

        // var heightRegular  = adZoneElement.getAttribute('data-height-regular');
        // var widthRegular   = adZoneElement.getAttribute('data-width-regular');
        // var heightProperty = ad.getFloatingAdHeightProperty();                      // TODO: Will be addressed in the next task.

        // rootAdZoneElement.classList.add('an-invisible');
        // rootAdZoneElement.classList.remove('an-visible');
        // adZoneElement.classList.add('an-invisible');
        // adZoneElement.classList.remove('an-visible');
        // adZoneElement.classList.remove('ad-zone-floating');
        // adZoneElement.setAttribute('data-is-floating', 'false');

        // adZoneElement.style.zIndex                       = 1; 
        // adZoneElement.style[heightProperty]              = heightRegular;
        // adZoneElement.style.width                        = widthRegular;
        // adZoneSizeContainerElement.style[heightProperty] = 'inherit';
        // adZoneSizeContainerElement.style.width           = 'inherit';

        // var heightRegularValstream = ('auto' === heightRegular) ? 'inherit' : heightRegular;
        // var widthRegularValstream  = ('auto' === widthRegular) ? 'inherit' : widthRegular;

        // this.handleFloatingDisengagedVideoPlayer(adElementId, heightRegularValstream, widthRegularValstream);
        // this.hideCloseButton(adElementId);

        // adZoneElement.classList.add('an-visible');
        // adZoneElement.classList.remove('an-invisible');
        // rootAdZoneElement.classList.add('an-visible');
        // rootAdZoneElement.classList.remove('an-invisible');
    },

    //
    // Waits for consent to be known.
    waitForConsent: function(callback){

        this.__consentManager.waitForConsent(callback);
    },

    //
    // Returns ad slots for on pageload auction.
    __getGamAdSlotsForDynamicInjectionRefresh: function(gamAdSlots){

        gamAdSlots = Object.values(gamAdSlots);

        return gamAdSlots.filter(function(gamAdSlot){

            return (gamAdSlot['dynamicInjectionRefresh'] && typeof gamAdSlot['dynamicInjectionRefresh'] === 'object' && Object.keys(gamAdSlot['dynamicInjectionRefresh']).length > 0);
        });
    },

    //
    // Returns ad setup key.
    getAdSetupKey: function(){

        return this.__logData['chosenAdSetupKey'] || '';
    },

    //
    // Returns ad setup key.
    getAdSetupName: function(){

        if(this.__logData['chosenAdSetup'] && this.__logData['chosenAdSetup']['name']){

            return this.__logData['chosenAdSetup']['name'];
        }

        return 'None';
    },

    //
    // Returns chosen ad setup.
    getChosenAdSetup: function(){

        if(this.__logData['chosenAdSetup'] && this.__logData['chosenAdSetup']){

            return this.__logData['chosenAdSetup'];
        }
    },

    //
    // Returns chosen ad setup key details.
    getChosenAdSetupKeyDetails: function(){

        if(this.__logData['chosenAdSetupKeyDetails'] && this.__logData['chosenAdSetupKeyDetails']){

            return this.__logData['chosenAdSetupKeyDetails'];
        }
    },

    //
    // Returns client data that was added to the log.
    getClientData: function(){

        // TODO: Fix, injector hack. If no postId, return the global postId.
        // this.getPostId();

        return this.__logData['clientData'] || {};

        // TODO: Add GamID and isBoosted.
    },

    //
    // Returns winning ad unit IDs.
    getWinningAdUnitIds: function(){

        return this.__logData['winningAdUnitIds'] || [];
    },

    //
    // Returns brand name.
    getBrandName: function(){

        return this.__logData['clientData']['brandName'] || '';
    },    
    
    //
    // is AdBlockConverted
    isAdBlockConverted: function(){

        return this.__logData['clientData']['isAdBlockConverted'] || '0';
    },

    //
    // Is forum.
    isForum: function(){

        return (this.getBrandName() === 'CBRForums' || this.getBrandName() === 'XDAForums');
    },

    //
    // Returns content type.
    getContentType: function(){

        return this.__logData['clientData']['contentType'] || '';
    },

    //
    // Returns network category.
    getNetworkCategory: function(){

        return this.__logData['clientData']['networkCategory'] || '';
    },

    //
    // Returns template.
    getTemplate: function(){

        return this.__logData['clientData']['template'] || '';
    },

    //
    // Returns login to continue flag.
    getIsLoginToContinue: function(){

        if(!this.__logData['clientData']['extraParams'].hasOwnProperty('loginToContinue')){

            return '0';
        }

        return this.__logData['clientData']['extraParams']['loginToContinue'] || '0';
    },

    //
    // Returns site category.
    getSiteCategory: function(){

        return this.__logData['clientData']['extraParams']['siteCategory'] || '';
    },

    //
    // Returns post ID.
    getPostId: function(){

        // TODO: Fix, injector hack. If no postId, return the global postId.
        var postId = null;

        if(this.__logData && this.__logData['clientData'] && this.__logData['clientData']['extraParams'] && typeof this.__logData['clientData']['extraParams'] === 'object'){
            postId = this.__logData['clientData']['extraParams']['postId'] || (typeof VALNET_GLOBAL_POSTID !== 'undefined' ? VALNET_GLOBAL_POSTID : '');
            this.__logData['clientData']['extraParams']['postId'] = postId || '';
        }

        return postId;
    },

    //
    // Returns OS family.
    getOsFamily: function(){
        
        return (this.__logData['clientData']['extraParams'].hasOwnProperty('osFamily') && this.__logData['clientData']['extraParams']['osFamily']) ? this.__logData['clientData']['extraParams']['osFamily'].toLowerCase() : 'other';
    },

    //
    // Returns if Apple OS family.
    isAppleOsFamily: function(){

        return (this.getOsFamily() === 'apple');
    },

    //
    // Returns geo.
    getGeo: function(){

        return this.__logData['clientData']['geo'] || '';
    },

    //
    // Returns log data for event recording.
    getEventRecordingLogData: function(){

        return {
            chosenAdSetup: this.__logData['chosenAdSetup'],
            clientData: this.__logData['clientData'],
        };
    },

    //
    // Returns the cat ID for a brand if found
    getCat: function(){

        brandName = this.getBrandName();

        if(brandName && brandName !== ''){

            var catID = this.AMAZON_CONTENT_TAXONOMY[brandName];
            
            if(typeof catID !== 'undefined'){

                return catID;
            }
        }

        return '';
    },

    //
    // Sets up refreshing ads.
    setupExtendedSectionAds: function(headers, pageNumber, ads, adRefreshData){ // TODO: Rename.

        this.log('Preparing dynamic injection repeatable ads.', {
            headers: headers,
            pageNumber: pageNumber,
            ads: ads,
        });

        if(this.__isUsingFakeAds()){

            return;
        }

        for(var x in headers){

            // Check if string contains what we expect for a GAM ad.
            if(-1 === headers[x]['header'].indexOf('googletag.defineSlot')){

                this.log('A dynamic injection repeatable ad is in an unsupported format.', headers[x]);
                continue;
            }

            // Safely evaluates the code in gamAdSlot string.
            window.Function(this.__stripScriptTags(headers[x]['header']))();
        }

        var adsData = [];

        for(var x in ads){

            var ad        = ads[x];
            var newAdData = this.__createAndAddNewAdData(ad, pageNumber);

            adsData.push(newAdData);
        }

        // Hold an auction for ad zones.
        var auction = this.setupAjaxAuction(adsData, this.prebidAdUnitBidderConfigs);

        this.requestHeaderBids(auction.getId());
        this.startFailSafeTimeout(auction.getId());
        this.setupFloatingAdZones(auction.getGamAdSlots());
        this.setupDynamicallyInjectionRefreshAdZones(auction.getGamAdSlots(), adRefreshData);

        return adsData;
    },

    //
    // Returns ad slots filtered by ad element ID.
    __filterGamAdSlotsByAdElementId: function(gamAdSlots, pageNumber){

        gamAdSlots = Object.values(gamAdSlots);

        // Make sure we want an ad.
        return gamAdSlots.filter(function(gamAdSlot){

            return (-1 !== (gamAdSlot['adElementId'].indexOf(`-PAGE${pageNumber}`)));
        });
    },

    //
    // Returns ad slots filtered by ad element ID.
    __createAdsNinjaRefreshingAdZone(adElementId, refreshContainerElementId, data, prefetch, zoneName, zoneGroupName, minimumTimeBuffer, timeBuffer, pixelDistance, pixelTrigger, inview, first){

        this.refreshingAdZones[adElementId] = new window.AdsNinjaRefreshingAdZone(adElementId, refreshContainerElementId, data, prefetch, zoneName, zoneGroupName, minimumTimeBuffer, timeBuffer, pixelDistance, pixelTrigger, inview, this.logger);

        var ad = this.__adsData[adElementId];
        if (ad && ad.isVideoRequestModeDisplay()) {
          this.refreshingAdZones[adElementId].setMaxNotBidding(this.getAdBehaviourValue('requestsCapOutstream') || 7);
        } else {
          this.refreshingAdZones[adElementId].setMaxNotBidding(this.getAdBehaviourValue('requestsCapDisplay') || 4);
        }

        return this.refreshingAdZones[adElementId];
    },

    //
    // Returns Refreshing ad zone.
    getRefreshingAdZone: function(adElementId){

        return this.refreshingAdZones[adElementId] || null;
    },

    //
    // Creates an ad zone mapping.
    __createOrUpdateAdZoneMapping: function(zoneGroupName, zoneName, adElementId){

        // TODO: Support repeatable ads.
        var key     = this.__constructAdZoneMappingKey(zoneName, zoneGroupName);
        var adIndex = 'next';

        if(!this.__adZoneMapping.hasOwnProperty(key)){

            adIndex                   = 'current';
            this.__adZoneMapping[key] = {};
        }

        this.__adZoneMapping[key][adIndex] = adElementId;
    },

    //
    // Constructs ad zone mapping key.
    __constructAdZoneMappingKey(zoneName, zoneGroupName){

        var key = '';

        if(zoneGroupName){

            // TODO: Group name will be added in the future.
            key += `${zoneGroupName}_`;
        }

        key += `${zoneName}`;

        return key;
    },

    //
    // Returns zone mapping.
    getCurrentAdZoneMappingByZone: function(zoneGroupName, zoneName){

        var key = this.__constructAdZoneMappingKey(zoneName, zoneGroupName);

        return this.__adZoneMapping[key]['current'] || null;
    },

    //
    // Refreshes ad zone.
    refreshAdZone(zoneName, zoneGroupName = null){
        // TODO: Fix this doesn't work as expected anymore now that we've got repeatable ads or infinite scroll.
        // TODO: Add page and instance.

        var key = this.__constructAdZoneMappingKey(zoneName, zoneGroupName);

        if(!this.__adZoneMapping[key] || !this.__adZoneMapping[key]['current']){

            return false;
        }

        // Find ad element ID associated with the zone and zone group names.
        var adElementId = this.__adZoneMapping[key]['current'];

        this.initAdZoneEventsLogEntryIfNeeded(adElementId);

        var result = this.refreshAdElement(adElementId, 'custom');

        if(result){

            // Switch mappings for ad element IDs associated with zone and zone group names.
            if(this.__adZoneMapping[key]){

                this.__adZoneMapping[key]['current'] = this.__adZoneMapping[key]['next'];
                this.__adZoneMapping[key]['next']    = '';
            }
        }

        return result;
    },


    //
    // Refreshes ad zone given ad element ID.
    refreshAdElement(id, context){

        var adElementId = id;

        if(!adElementId){

            this.logger.warn('Attempting to refresh ad. There is no ad element ID.');
            return false;
        }

        // Acts as a safety check for page setup.
        if(!this.auctionManager.doesAuctionExistForElementId(adElementId)){
            
            this.logger.warn(`Attempting to refresh ad. There is no auction for ad element ID: ${adElementId}.`);
            return false;
        }

        var adUnit = this.getAdsData(adElementId);

        if(!adUnit){

            this.logger.warn(`Attempting to refresh ad. There is no ad unit with ad element ID: ${adElementId}.`);
            return false;
        }

        if(!adUnit.hasCreativeBeenViewed()){

            this.logger.warn(`Attempting to refresh ad. Ad unit with ad element ID: ${adElementId} has not been viewed.`);
            return false;
        }

        var refreshingAdZone = this.refreshingAdZones[adElementId];

        if(!refreshingAdZone){

            this.logger.warn(`Attempting to refresh ad. There is no refreshing ad zone with ad element ID: ${adElementId}.`);
            return false;
        }

        // TODO: Limiting to timer refresh for now.
        if(!refreshingAdZone.hasTimerRefresh()){

            this.logger.warn(`Attempting to refresh ad. There is no timer refresh for ad element ID: ${adElementId}.`, {
                context: context,
            });
            return false;
        }

        this.setupNextAd(adElementId, refreshingAdZone, false, ('inBannerVideo' === context || 'force' === context), context);

        // When ad unit is using refresh mode regular, we need to refresh it.
        if(adUnit.isRefreshModeRegular() && 'inBannerVideo' === context && this.floatingDelegate.isAdFloating(adUnit)){

            context = 'force';
        }

        var isReadyToRefresh = refreshingAdZone.isReadyForRefresh(context);

        // this.logger.debug(`Is ready to refresh?`, {
        //     adElementId: adElementId,
        //     isReadyToRefresh: isReadyToRefresh,
        //     context: context,
        //     adZoneEventsLog: this.adZoneEventsLog[adElementId] || null,
        //     hasTransitionStarted: refreshingAdZone.getHasTransitionStarted(),
        //     isAllowedToRefresh: refreshingAdZone.isAllowedToRefresh(),
        // });

        if(!isReadyToRefresh){

            return false;
        }

        this.logger.debug(`Ready to refresh passed for element: ${adElementId}.`, {
            context: context,
        });

        var latestAuction = this.__getLatestAuction(adElementId);

        if(adUnit.isRefreshModeRegular() && latestAuction && !latestAuction.isAdServerRequestSent()){

            // Prebid and Amazon bids are not guaranteed to be back or given a chance at this point.
            // Get and show next ad.
            this.resetAdZoneEventsLog(adElementId);

            // Delete autoRefresh waypoint if exists.
            if(this.autoRefreshAdZones.hasOwnProperty(adElementId)){

                for(var x in this.autoRefreshAdZones[adElementId]){

                    this.autoRefreshAdZones[adElementId][x].destroy();
                }
            }
            
            var adZoneContainerElement = adUnit.getAdZoneContainerElement();
            var adZoneElement          = adUnit.getAdZoneElement();

            // Reset classes on ad element containers.
            if(adZoneContainerElement && adZoneElement){

                adZoneContainerElement.classList.remove('no-fill');
                adZoneContainerElement.classList.remove('ad-loaded');
                adZoneContainerElement.classList.remove('ad-loading');

                adZoneContainerElement.style.display = 'block';
            }

            // Cancel all timeouts and intervals.
            this.__clearRefreshIntervals(adElementId);
            this.__clearRefreshTimeouts(adElementId);

            this.sendAdServerRequest(latestAuction.getId());
        }
        else if(!adUnit.isRefreshModeRegular()){

            var nextAdElementId = refreshingAdZone.getNextAdElementId();

            if(!nextAdElementId){

                // Next ad not setup.
                this.logger.debug(`Attempting to refresh ad. Next ad is not setup for element: ${adElementId}.`);
                return false;
            }

            // Get Auction.
            if(!this.doesAuctionExist(nextAdElementId)){

                this.logger.warn(`Attempting to refresh ad. There is no auction registered with the ID: ${nextAdElementId}.`);
                return false;
            }

            refreshingAdZone.setHasTransitionStarted(true);
            this.log(`Refresh initiated by ${context} action for element: ${adElementId}.`);

            // Delete floating waypoint if exists.
            this.deleteFloatingAdWaypoints(adElementId);
            this.deleteAutoScrollWaypoints(adElementId); // For safety.

            // Delete autoRefresh waypoint if exists.
            if(this.autoRefreshAdZones.hasOwnProperty(adElementId)){

                for(var x in this.autoRefreshAdZones[adElementId]){

                    this.autoRefreshAdZones[adElementId][x].destroy();
                }
            }

            // Delete scroll event listener.
            refreshingAdZone.removeScrollTimerRefresher();

            var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);

            this.floatingManager.requestToDefloat(
                adElementId, 
                floatingInfoForRequest.requestor
            );

            // Setup floating.
            this.setupFloatingAdZones(this.auctions[nextAdElementId].getGamAdSlots(), refreshingAdZone.isInView());

            // Mark current ad as previous and hide.
            // Mark next ad as current and show.
            // Prepare for next go around.
            refreshingAdZone.changeShownAdInContainer();

            // Prebid and Amazon bids are not guaranteed to be back or given a chance at this point.
            // Get and show next ad.
            this.sendAdServerRequest(nextAdElementId);

            // Cancel all timeouts and intervals.
            this.__clearRefreshIntervals(adElementId); // TODO: Move above.
            // TODO: Clear refresh timeouts.
        }
        else{

            this.logger.debug(`Already refreshed for element: ${adElementId}.`);
            return false;
        }

        return true;
    },

    //
    // Sets up next ad of a refreshing ad zone.
    setupNextAd: function(adElementId, refreshingAdZone, prefetch, forceAuction = false, context = 'force'){

        if(!refreshingAdZone || typeof refreshingAdZone !== 'object' || Object.keys(refreshingAdZone).length == 0){

            this.log(`Parameter must be a non-falsy object with one or more keys.`, {
                refreshingAdZone: refreshingAdZone,
            });
            return;
        }

        if(!adElementId){

            this.log(`Parameter must be a non-falsy string.`, {
                adElementId: adElementId,
            });
            return;
        }

        if(false){

            if(!refreshingAdZone.isReadyForPrefetch(context)){

                this.log(`Not able to prefetch because not in view and no forced events.`, {
                    adElementId: adElementId,
                });
                return;
            }

            this.logger.debug(`Ready to prefetch passed for element: ${adElementId}.`);
        }

        if(refreshingAdZone.haveTimersStarted()){

            this.log(`Timer already started for refreshing ad zone.`, refreshingAdZone);
        }
        else{

            this.initAdZoneEventsLogEntryIfNeeded(adElementId);

            var minimumTimeBuffer = refreshingAdZone.getMinimumTimeBuffer();

            if(minimumTimeBuffer){

                // Needs to be expressed in milliseconds.
                minimumTimeBuffer = Number(minimumTimeBuffer) * 1000;

                var minTimer = setTimeout(function(){

                    window.adsNinjaHeaderBiddingManager.handleAdZoneMinimumTimerCompleteEvent(adElementId);
                }, minimumTimeBuffer);

                this.addRefreshTimeout(adElementId, minTimer);
            }

            var timeBuffer = refreshingAdZone.getTimeBuffer();

            if(timeBuffer){

                // Needs to be expressed in milliseconds.
                timeBuffer = Number(timeBuffer) * 1000;

                var refreshTimer = setTimeout(function(){

                    // TODO: Fix get current refresh count.
                    window.adsNinjaHeaderBiddingManager.handleAdZoneTimerCompleteEvent(adElementId);
                }, timeBuffer);

                this.addRefreshTimeout(adElementId, refreshTimer);
            }

            this.adZoneEventsLog[adElementId]['haveTimersStarted'] = true;

            // TODO: Fix, this is now the minimumTimeBuffer. We'll also need a new timer for timer refresh.
        }

        // Verify if we can prefetch the bids.
        if(refreshingAdZone.isAllowedToPrefetch() !== prefetch && !forceAuction){

            if(prefetch){

                this.log(`Not allowed to prefetch next ad for refreshing ad zone.`, refreshingAdZone);
                this.log(`Not allowed to prefetch next ad for element: ${adElementId}.`);
            }

            return;
        }

        var refreshContainerElement = refreshingAdZone.getRefreshContainerElement();

        if(!refreshContainerElement){

            this.log(`Unable to find dynamic injection refreshing ad zone container.`, refreshingAdZone);
            this.log(`Unable to find dynamic injection refreshing ad zone container for element: ${adElementId}.`);
            return;
        }

        if(refreshingAdZone.isNextAdSetup()){

            this.log(`Already setup for next ad for refreshing ad zone.`, refreshingAdZone);
            this.log(`Already setup for next ad for element: ${adElementId}.`);
            return;
        }

        var currentAd = this.getAdsData(adElementId);

        // Check user activity for second auction and up.
        if(this.__isUserConsideredInactiveForAd(currentAd)){

            this.logger.debug('Unable to setup refresh auction for ad. User is considered inactive.', {
                adElementId: adElementId,
            });

            this.log(`Unable to setup refresh auction for ad. User is considered inactive for element: ${adElementId}.`);

            return;
        }

        var newAdData     = null;
        var idAuction     = null;
        var adUnit        = this.getAdsData(adElementId);
        var latestAuction = this.__getLatestAuction(adElementId);
        var gamAdSlot     = null;

        if(adUnit.isRefreshModeRegular() && latestAuction && latestAuction.isAdServerRequestSent()){

            idAuction = currentAd.getAdElementId() + '_' + Date.now();
            gamAdSlot = currentAd;

            refreshingAdZone.incrementRefreshCount();
        }
        else if(!adUnit.isRefreshModeRegular()){

            refreshingAdZone.setIsNextAdSetup(true);

            var nextAdElementId = refreshingAdZone.createNextAdElementId();

            if(!nextAdElementId){

                this.logger.error(`Unable to setup next ad: cannot create next ad element ID.`);
                this.log(`Unable to setup next ad: cannot create next ad element ID for element: ${adElementId}.`);

                return;
            }

            // Make new refreshingAdZones entry.
            var nextRefreshingAdZone = this.__createAdsNinjaRefreshingAdZone(nextAdElementId, refreshingAdZone.getRefreshContainerElementId(), refreshingAdZone.getData(), refreshingAdZone.isAllowedToPrefetch(), refreshingAdZone.getZoneName(), refreshingAdZone.getZoneGroupName(), refreshingAdZone.getMinimumTimeBuffer(), refreshingAdZone.getTimeBuffer(), refreshingAdZone.getPixelDistance(), refreshingAdZone.getPixelTrigger(),refreshingAdZone.getInview(), false);

            // Append new ad zone content.
            refreshContainerElement.insertAdjacentHTML('beforeend', nextRefreshingAdZone.getRefreshContent());

            // Inject a new element into the page, hidden for now.
            var gamAdSlotHeader = nextRefreshingAdZone.getRefreshHeader();

            try{
            
                // Lookup and add the new injected ads in the adsData list.
                newAdData = this.copyAndAddNewAdDataFromExisting(adElementId, nextAdElementId);
            }
            catch(error){

                this.log(`Unable to setup next ad: error thrown.`, {error: error});
                return;
            }

            gamAdSlot = newAdData;

            // Safely evaluates the code in gamAdSlot string.
            window.Function(this.__stripScriptTags(gamAdSlotHeader))();

            if(nextAdElementId !== gamAdSlot['adElementId']){

                this.log(`Unable to find gamAdSlot for dynamic injection refreshing ad zone container.`, {
                    adElementId: nextAdElementId,
                });
                this.log(`Unable to find gamAdSlot for dynamic injection refreshing ad zone container for element: ${adElementId}.`);
                return;
            }
        }
        else{

            this.log(`Already setup for next ad for refreshing ad zone.`, refreshingAdZone);
            return;
        }

        var noBiddingAuction = refreshingAdZone.hasMaxNotBiddingLimitBeenReached();

        // Hold another auction for refresh ad zones.
        //add a noBiddingAuction param to the setupRefreshAuction function like we do for videoAuction. The flag should be set to true if refreshingAdZone.hasMaxNotBiddingLimitBeenReached() is true.
        var auction = this.setupRefreshAuction(gamAdSlot, this.prebidAdUnitBidderConfigs, null, null, idAuction, noBiddingAuction);

        if(!auction){

            this.logger.debug('No refresh auction to be held!');
            return;
        }

        // New check with Nick for the right placement
        //use the flag from the auction to see if it is a noBiddingAuction instead of relyinh on hasMaxNotBiddingLimitBeenReached function
        if(noBiddingAuction){

            this.log(`new refresh logic, Stop running auctions for element: ${adElementId} because we have reached the max not bidding limit of ${refreshingAdZone.getMaxNotBidding()} times`, {
                adElementId: adElementId,
            });

            return;
        }

        this.requestHeaderBids(auction.getId());
    },

    //
    // Injects waypoint anchor in body for inview calculations.
    __injectAnchor: function(){

        var div = document.createElement('div');
        div.setAttribute('id', 'adsninja-body-anchor');

        document.body.prepend(div);
    },

    //
    // Strip script tags.
    __stripScriptTags: function(string){

        return string.replace('<script>', '').replace('</script>', '');
        // return window.adsNinja.stripScriptTags(string);
    },

    //
    // Determines if passive event listeners are supported.
    arePassiveEventListenersSupported: function(){

        return this.__eventHelper.arePassiveEventListenersSupported();
    },

    //
    // Adds more refresh points based on new height of document.
    updatePixelRefreshers: function(){

        var currentDocumentHeight = this.getDocumentHeight();

        if(currentDocumentHeight <= this.__previousDocumentHeight){

            this.log('No need to update pixel refreshers.');
            return;
        }

        this.__previousDocumentHeight = currentDocumentHeight;

        this.log('Updating pixel refreshers.');

        for(var x in this.pixelRefreshers){

            this.pixelRefreshers[x].update(currentDocumentHeight);
        }
    },

    //
    // Returns document height.
    getDocumentHeight(){

        return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    },

    //
    // Run method.
    // TODO: Move all code in client to this method.
    run: function(data, preAuctionCallback, postAuctionCallback){
        
        if(typeof window.googletag === typeof undefined || !window.googletag.hasOwnProperty('cmd')){

            this.logger.error('Bidding manager: googletag is not defined!');
            return;
        }

        var self = this;

        this.__addGlobalTargeting();
        this.__registerGAMAdEventListeners();

        this.__refreshData = data['dynamicInjectionRefreshAdZones'];

        var brandName = self.getBrandName();
        initComscore(brandName);

        window.googletag.cmd.push(function(){

            if('function' === typeof preAuctionCallback){
    
                preAuctionCallback();
            }

            var adsNinjaAuction1 = self.setup(self.getAllAdsData(), true);
    
            self.setupDynamicallyInjectionRefreshAdZones(adsNinjaAuction1.getGamAdSlots(), data['dynamicInjectionRefreshAdZones']);
    
            var nonOnPageLoadGamAdSlots = self.__filterGamAdSlotsByPageLoadAndIsDefined(self.getAllAdsData(), false);

            // if('TheGamer' !== brandName && nonOnPageLoadGamAdSlots && Array.isArray(nonOnPageLoadGamAdSlots) && nonOnPageLoadGamAdSlots.length !== 0){
            if(nonOnPageLoadGamAdSlots && Array.isArray(nonOnPageLoadGamAdSlots) && nonOnPageLoadGamAdSlots.length !== 0){

                self.auctionManager.waitTillAdsAreInview(nonOnPageLoadGamAdSlots);
            }
            
            var shouldWaitForConsent = self.__consentNeeded && !self.__consentManager?.getIsConsentKnown?.();

            if(!adsNinjaAuction1.getConsentNeeded()){

                window.googletag.cmd.push(function(){

                    window.googletag.pubads().setTargeting('Consent', '1');            
                });

                if(self.getGeo() === 'GB') {
                    self.__consentManager.__setGtagConsentGrantAll();
                }
    
                self.__consentManager.setupSP();
                self.requestHeaderBids(adsNinjaAuction1.getId());
            }
            else{
                
                window.googletag.cmd.push(function(){

                    window.googletag.pubads().setTargeting('Consent', '0');            
                });

                self.logger.info('Delaying header bidding requests so that the CMP tool may load first.');
                self.waitForConsent(function(){
    
                    self.requestHeaderBids(adsNinjaAuction1.getId());
                });
            }
    
            self.startFailSafeTimeout(adsNinjaAuction1.getId());
            self.setupFloatingAdZones(adsNinjaAuction1.getGamAdSlots());
    
            if(typeof self.setupRailAdZones == 'function'){
    
                self.setupRailAdZones(data['railAds']);
            }
    
            if('function' === typeof postAuctionCallback){
    
                postAuctionCallback();
            }
        });
    },

    //
    // Run for an extended section.
    runForExtendedSection: function(data){

        var self = this;

        var waitForNextRedraw = function(){

            window.requestAnimationFrame(function(){

                window.requestAnimationFrame(function(){

                    self.logger.debug('Running extended section.', {
                        data: data,
                    });

                    if(data){

                        self.__logExtendedSectionData(data);

                        self.setAdCountData(data.adCountData);

                        if(self.__adCountData.hasOwnProperty('articleNumber') && self.__adCountData.articleNumber > 0){

                            self.__hasLoadedInfiniteArticle = true;
                        }

                        self.__setEventTrackingDictionary(data['eventTrackingDictionary']);
                        self.setupExtendedSectionAds(data.adHeaders, self.__adCountData.pageNumber, data.ads, data.adRefreshData);
                        self.updatePixelRefreshers();
                        self.setupRailAdZones(data.railAds);

                        if(data.hasOwnProperty('jsToRun') && data.jsToRun.length > 0){

                            for(var x in data.jsToRun){

                                // Safely evaluates the code.
                                window.Function(self.__stripScriptTags(data.jsToRun[x]))();
                            }
                        }

                        if(typeof self.__configureNewVideoPlayers === 'function'){

                            self.__configureNewVideoPlayers();
                        }
                    }

                    // Inject for pixel distance.
                    // Wait 2 seconds before running injector to allow for the DOM to update.
                    setTimeout(function(){

                        window.adsNinja.runInjector();
                    }, 2000);
                });
            });
        };

        waitForNextRedraw();
    },

    //
    // Is using fake ads.
    __isUsingFakeAds(){

        return (this.MODE_ADS_FAKE === this.__modeAds);
    },

    __isUsingRegularAds(){

        return (this.MODE_ADS_REGULAR === this.__modeAds);
    },

    __isUsingNoAds(){

        return (this.MODE_ADS_NONE === this.__modeAds);
    },

    //
    // Delete floating waypoint if exists.
    deleteFloatingAdWaypoints: function(adElementId){

        this.floatingDelegate.deleteWaypoints(adElementId);
    },

    //
    // Disable floating waypoint if exists.
    disableFloatingAdWaypoints: function(adElementId){

        this.floatingDelegate.disableWaypoints(adElementId);
    },

    //
    // Enable floating waypoint if exists.
    enableFloatingAdWaypoints: function(adElementId){

        this.floatingDelegate.enableWaypoints(adElementId);
    },

    //
    // Set data used for extended section ajax requests.
    setAdCountData: function(adCountData){

        this.__adCountData = adCountData;
    },

    //
    // Set event tracking dictionary.
    __setEventTrackingDictionary: function(data){

        if(!data || typeof data !== 'object' || Object.keys(data).length === 0){

            return;
        }

        if(Object.keys(this.__eventTrackingDictionary).length === 0){

            this.__eventTrackingDictionary = data;
        }
        else{

            for(var x in data){

                this.__eventTrackingDictionary[x] = data[x];
            }
        }
    },

    //
    // Add to event tracking dictionary.
    addToEventTrackingDictionary: function(adElementId, key){

        if(this.__eventTrackingDictionary.hasOwnProperty(adElementId)){

            return;
        }

        this.__eventTrackingDictionary[adElementId] = {
            id: key,
            clientData: {
                chosenAdSetup: this.getChosenAdSetup(),
                clientData: this.getClientData(),
            },
        };
    },

    //
    // Overwrite event tracking dictionary.
    overwirteEventTrackingDictionaryItem: function(adElementId, key){

        this.__eventTrackingDictionary[adElementId] = {
            id: key,
            clientData: {
                chosenAdSetup: this.getChosenAdSetup(),
                clientData: this.getClientData(),
            },
        };
    },

    //
    // Returns data used for extended section ajax requests.
    getExtendedSectionAdRequestData: function(isLoadingNextArticle = true){

        var adSetupKey        = this.getAdSetupKey();
        var winningAdUnitIds  = this.getWinningAdUnitIds();

        if(isLoadingNextArticle && this.__adCountData.hasOwnProperty('articleNumber')){

            this.__adCountData.articleNumber              += 1;

            if(this.__adCountData.hasOwnProperty('injectionTypeCounts')){

                for(var x in this.__adCountData.injectionTypeCounts){

                    this.__adCountData.injectionTypeCounts[x].adPosition                 = 0;
                    this.__adCountData.injectionTypeCounts[x].nbrPlacementsScanned       = 0;
                    this.__adCountData.injectionTypeCounts[x].nbrPlacementFilledEachSkip = 0;
                    this.__adCountData.injectionTypeCounts[x].actualCount                = 0;
                }
            }
        }

        if (!(window.googletag ===  undefined) && window.googletag.hasOwnProperty('cmd')){
            window.googletag.cmd.push(function(){
                googletag.pubads().clearTargeting('pageUrl');
                googletag.pubads().clearTargeting('pageUrlIdentifier');
                googletag.pubads().clearTargeting('isBoosted');
            });
        }

        this.__adCountData.pageNumber += 1;
        var clientData                = this.getClientData();

        return {
            adSetupKey: adSetupKey,
            adUnitIds: winningAdUnitIds,
            contentType: clientData.contentType,
            networkCategory: clientData.networkCategory,
            template: clientData.template,
            siteCategory: clientData.siteCategory,
            adCountData: this.__adCountData,
        };
    },

    //
    // Logs extended section data.
    __logExtendedSectionData: function(data){

        this.__extendedSectionDataLog.push(data);
    },

    //
    // Sets up rail ads.
    setupRailAdZones: function(railAdZones){

        var railElementHeight = 0;
        for (var i in this.__adsData){
            // TODO: Fix reconfigure __adZoneMapping to include all ads not just refreshing ones to use as lookup here.

            var zoneName = this.__adsData[i]['zoneName'];
            if(zoneName === 'Infinite Scroll Rail'){

                railElementHeight = this.__adsData[i]['height'];

            }
        }

        if(this.railAdZones && Object.keys(this.railAdZones).length !== 0){

            this.__recalculateRailAdZones();
        }

        var railAdZone = null;
        var result     = null;

        for(var x in railAdZones){

            var railElementId               = railAdZones[x]['railElementId'];
            var originalAdElementId         = railAdZones[x]['originalAdElementId'];
            var data                        = railAdZones[x]['railSettings'];
            railAdZone                      = new window.AdsNinjaRailAdZone(railElementId, originalAdElementId, data, railElementHeight, this.logger);
            result                          = railAdZone.setup();
            this.railAdZones[railElementId] = railAdZone;
        }

        this.__previousDocumentHeightRailAdZones = this.getDocumentHeight();
    },

    //
    // Recalculate the rail ad zones, to inject more ads if the document height increased.
    __recalculateRailAdZones: function(){

        var currentDocumentHeight = this.getDocumentHeight();

        if(this.__previousDocumentHeightRailAdZones >= currentDocumentHeight){

            return;
        }

        for(var x in this.railAdZones){

            this.railAdZones[x].recalculate();
        }

        this.__previousDocumentHeightRailAdZones = this.getDocumentHeight();
    },

    //
    // TODO: Make private.
    // Sets data from run method.
    setData: function(data){

        this.__directDealsMapping            = (typeof data['directDealsMapping'] === 'object' && Object.keys(data['directDealsMapping']).length !== 0) ? data['directDealsMapping'] : {};
        this.__prebidServerAliasData         = data['prebidServerAliasData'];
        this.__adCapabilities                = data['adCapabilities'];
        this.__videoList                     = data['videoList'];
        this.prebidAdUnitBidderConfigs       = data['adUnitBidderConfigs'] || window.adUnitBidderConfigs; // For backwards compatability.
        window.adUnitBidderConfigs           = this.prebidAdUnitBidderConfigs || null; // For backwards compatability.
        this.sspsThatCouldHaveOwnCloseButton = data['sspsThatCouldHaveOwnCloseButton'] || {};
        this.__siteConfig                    = data['siteConfig'] || {};
        this.__consentContext                = data['consentContext'] || null;
        this.__pageGamId                     = data['pageGamId'] || null;
        this.__version                       = data['apiVersion'] || 'v1';

        this.__setBoostingUrlData(data['boostedUrlData']);
        this.__setBoostingModes(data['boostedUrlData']);
        this.setModeAds(data['modeAds']);
        this.setDeviceType(data['deviceType']);
        this.setAdCountData(data['adCountData']);
        this.__setEventTrackingDictionary(data['eventTrackingDictionary']);
        this.__setAdBehaviours(data['adBehaviours']);
        this.__setConnectionConfig(data);
    },

    /**
     * Set additional data missing from initializer.
     *
     * @deprecated Use setData(data) instead.
     */
    setAdditionalData: function(data){

        this.setData(data);
    },

    //
    // Determine if an ad has a certain capability.
    __checkAdCapabilityByAdZoneName: function(capability, adZoneName){

        if(!capability || !adZoneName){

            return false;
        }

        return (this.__adCapabilities['byAdZoneName'].hasOwnProperty(adZoneName) && this.__adCapabilities['byAdZoneName'][adZoneName] && typeof this.__adCapabilities['byAdZoneName'][adZoneName] === 'object' && this.__adCapabilities['byAdZoneName'][adZoneName].hasOwnProperty(capability));
    },

    //
    // Determine if an ad has a certain capability.
    checkAdCapabilityByAdElementId: function(capability, adElementId){

        if(!capability || !adElementId){

            return false;
        }

        return (this.__adCapabilities['byAdElementId'].hasOwnProperty(adElementId) && this.__adCapabilities['byAdElementId'][adElementId] && typeof this.__adCapabilities['byAdElementId'][adElementId] === 'object' && this.__adCapabilities['byAdElementId'][adElementId].hasOwnProperty(capability));
    },

    //
    // Determine if an ad has a certain capability.
    __checkAdCapabilityByCapabilityAndAdElementId: function(capability, adElementId){

        if(!capability || !adElementId){

            return false;
        }

        return (this.__adCapabilities['byCapability'].hasOwnProperty(capability) && this.__adCapabilities['byCapability'][capability] && typeof this.__adCapabilities['byCapability'][capability] === 'object' && this.__adCapabilities['byCapability'][capability].hasOwnProperty('byAdElementId') && this.__adCapabilities['byCapability'][capability]['byAdElementId'].hasOwnProperty(adElementId));
    },

    //
    // Copy ad capabilities.
    copyAdCapabilities: function(originalItem, newItem){
        
        var originalAdElementId = originalItem['adElementId'];
        var newAdElementId      = newItem['adElementId'];
        var originalAdZoneName  = originalItem['zoneName'];
        var newAdZoneName       = newItem['zoneName'];

        if(this.__adCapabilities['byAdElementId'][originalAdElementId]){

            this.__adCapabilities['byAdElementId'][newAdElementId] = this.__adCapabilities['byAdElementId'][originalAdElementId];
        }

        if(this.__adCapabilities['byAdZoneName'][originalAdZoneName]){

            this.__adCapabilities['byAdZoneName'][newAdZoneName] = this.__adCapabilities['byAdZoneName'][originalAdZoneName];
        }

        for(var capability in this.__adCapabilities['byCapability']){

            if(this.__adCapabilities['byCapability'][capability]['byAdElementId'][originalAdElementId]){

                this.__adCapabilities['byCapability'][capability]['byAdElementId'][newAdElementId] = this.__adCapabilities['byCapability'][capability]['byAdElementId'][originalAdElementId];
            }

            if(this.__adCapabilities['byCapability'][capability]['byAdZoneName'][originalAdZoneName]){

                this.__adCapabilities['byCapability'][capability]['byAdZoneName'][newAdZoneName] = this.__adCapabilities['byCapability'][capability]['byAdZoneName'][originalAdZoneName];
            }
        }
    },

    //
    // Toggle class on element.
    // Used for adding style on mobile when top-middle ad is present to make sure in-content ad isn't behind top-middle.
    __toggleInStickyContentAdZoneInlineTop: function(enable){

        var elements = document.getElementsByClassName('in-sticky-content');

        for(var i = 0; i < elements.length; i++){

            if(enable){

                elements[i].classList.add('an-in-sticky-content-zone-inline-top');
            }
            else{

                elements[i].classList.remove('an-in-sticky-content-zone-inline-top');
            }
        }
    },

    //
    // Handle adding and removing style for in-content ads based on presence of floating top-middle ad.
    __handleFloatingTopMiddle: function(adElementId, enableClass){

        if('mobile' === this.getDeviceType() && this.__adsData && Object.keys(this.__adsData).length > 0 && this.__adsData.hasOwnProperty(adElementId)){

            var adZoneName = this.__adsData[adElementId]['zoneName'];

            if(this.__checkAdCapabilityByAdZoneName(this.AD_CAPABILITY_FLOATING_TOP_MIDDLE, adZoneName)){

                this.__toggleInStickyContentAdZoneInlineTop(enableClass);
            }
        }
    },

    //
    // Returns ad data.
    getAllAdsData: function(){

        return this.__adsData;
    },

    //
    // Returns data of an ad.
    getAdsData: function(adElementId){

        var result = this.__adsData[adElementId] || null;

        if(!result){

            this.logger.warn(`Cannot find adsData with adElementId: "${adElementId}"!`);
            return null;
        }

        return result;
    },

    //
    // Returns ad by zone name.
    getAdByZone: function(zoneGroupName, zoneName){

        var key     = this.__constructAdZoneMappingKey(zoneName, zoneGroupName);
        var mapping = this.__adZoneMapping[key] || null;

        if(!mapping || typeof mapping !== 'object' || !mapping.hasOwnProperty('current')){
            
            return null;
        }

        return this.getAdsData(mapping.current);
    },

    //
    // Handler for floating engaged.
    handleFloatingEngagedVideoPlayer: function(adElementId, height, width){

        var adData = this.getAdsData(adElementId);

        if(!adData){

            return false;
        }

        if(!this.__checkAdCapabilityByAdZoneName(this.AD_CAPABILITY_VIDEO_VALSTREAM, adData.zoneName)){

            return false;
        }

        if(!this.__floatingEventDictionary.hasOwnProperty(adElementId)){

            this.logger.warn('Unable to handle floating event: engaged.', {
                adElementId: adElementId,
                height: height,
                width: width,
            });
            return;
        }

        this.__floatingEventDictionary[adElementId].engaged(height, width);
    },

    //
    // Handler for floating disengaged.
    handleFloatingDisengagedVideoPlayer: function(adElementId, height, width){

        var adData = this.getAdsData(adElementId);

        if(!adData){

            return false;
        }

        if(!this.__checkAdCapabilityByAdZoneName(this.AD_CAPABILITY_VIDEO_VALSTREAM, adData.zoneName)){

            return false;
        }

        if(!this.__floatingEventDictionary.hasOwnProperty(adElementId)){

            this.logger.warn('Unable to handle floating event: disengaged.', {
                adElementId: adElementId,
                height: height,
                width: width,
            });
            return;
        }

        try{

            this.__floatingEventDictionary[adElementId].disengaged(height, width);
        }
        catch(error){
    
            this.logger.warn('Unable to handle video player floating disallowed.', {
                error: error,
            });
        }
    },

    //
    // Handler for floating disallowed.
    handleFloatingDisallowedVideoPlayer: function(adElementId){

        var adData = this.getAdsData(adElementId);

        if(!adData){

            return false;
        }

        if(!this.__checkAdCapabilityByAdZoneName(this.AD_CAPABILITY_VIDEO_VALSTREAM, adData.zoneName)){

            return false;
        }

        if(!this.__floatingEventDictionary.hasOwnProperty(adElementId)){

            this.logger.warn('Unable to handle floating event: disallowed.', {
                adElementId: adElementId,
            });
            return;
        }

        this.incrementRefloatCount(adElementId); // TODO: This is being called before checking if refloat is allowed. This should be changed.

        var ad          = this.getAdsData(adElementId);
        var isOutstream = ad.hasSupportForVideoOutstream();
        var canRefloat  = (isOutstream) ? this.canRefloat(adElementId, 'outstream') : false;

        try{
            // TODO: Change when more types of refloats are allowed.
            this.__floatingEventDictionary[adElementId].disallowed(canRefloat);
        }
        catch(error){
    
            this.logger.warn('Unable to handle video player floating disallowed.', {
                error: error,
            });
        }
    },

    //
    // Setup floating events.
    registerEventHandlersForFloating: function(adElementId, callbacks){

        if(!this.__adsData.hasOwnProperty(adElementId)){

            this.logger.warn(`There is no ad data registered with the ID: ${adElementId}.`);
            return false;
        }

        if(!callbacks || !callbacks.engaged || typeof callbacks.engaged !== 'function' || !callbacks.disengaged || typeof callbacks.disengaged !== 'function' || !callbacks.disallowed || typeof callbacks.disallowed !== 'function'){

            this.logger.debug(`Unable to register floating events with ad element ID: ${adElementId}. One or more callbacks are missing.`);
            return false;
        }

        if(this.__floatingEventDictionary.hasOwnProperty(adElementId)){

            this.logger.warn(`Unable to register floating events with ad element ID: ${adElementId}. Already registered events for this element.`);
            return false;
        }

        // Setup floating.
        if(!this.__adsData.hasOwnProperty(adElementId)){

            this.logger.error(`There is no ad data registered for ad element ID: ${adElementId}.`);
            return false;
        }

        // Add to dictionary.
        this.__floatingEventDictionary[adElementId] = callbacks;

        this.setupFloatingAdZones([this.__adsData[adElementId]]);

        return true;
    },

    //
    // Registers callback.
    registerConfigureNewVideoPlayersHandler: function(callback){

        this.__configureNewVideoPlayers = callback;
    },

    //
    // Setups up the next auction.
    requestNextAuctionVideo: function(adElementId, placement, inflateBidPool, completionCallback){

        if(typeof completionCallback !== 'function'){

            this.logger.error('Missing completion callback for video auction.', {
                adElementId: adElementId,
                placement: placement,
            });
            return;
        }

        if(this.__videoAuctionsDisabled.hasOwnProperty(adElementId)){

            this.logger.debug('Auctions have been disabled for this video player.', {
                adElementId: adElementId,
                placement: placement,
            });

            completionCallback('', true);
            return;
        }

        if(!this.__adsData.hasOwnProperty(adElementId)){

            this.logger.warn(`There is no ad data registered with the ID: ${adElementId}.`);
            completionCallback('');
            return;
        }

        var ad = this.__adsData[adElementId];
        var shouldWaitForConsent = this.__consentNeeded && !this.__consentManager?.getIsConsentKnown?.();

        // Determine if user activity check is needed. Check user activity for second auction and up.
        if(this.__auctionDictionaryByAdElementId.hasOwnProperty(adElementId) && this.__isUserConsideredInactiveForAd(ad)){

            this.logger.debug('Unable to setup video auction for ad. User is considered inactive.', {
                ad: ad,
            });
            completionCallback('');
            return;
        }
        
        var self = this;
        var videoAuction = null; 

        if(ad.hasSupportForVideoOutstream() && this.__numberOfConsecutiveNoNewBidAuctions.hasOwnProperty(adElementId) && this.__numberOfConsecutiveNoNewBidAuctions[adElementId] >= this.getRequestsCapOutstream()){

            this.logger.debug('Video player exceeded number of no bid auctions. Trying to use up remaining bids in pool if available.', {
                adElementId: adElementId,
                placement: placement,
                maxnumberOfConsecutiveNoNewBidAuctions: this.getRequestsCapOutstream(),
                numberOfConsecutiveNoNewBidAuctions: this.__numberOfConsecutiveNoNewBidAuctions[adElementId],
            });

            // No new bid requests auction.
            // Try and use remaining bids from previous auctions.
            videoAuction = self.setupAuctionVideo(ad, self.prebidAdUnitBidderConfigs, placement, false, true, completionCallback); 
            if (videoAuction) {

                // Make sure to wait for googletag.
                window.googletag.cmd.push(function(){
                
                    window.pbjs.que.push(function(){
                        
                        self.registerAuctionVideoIfAvailable(videoAuction.getId(), true); 
                    });
                });
            }
        }
        else{

            videoAuction = self.setupAuctionVideo(ad, self.prebidAdUnitBidderConfigs, placement, inflateBidPool, false, completionCallback);
            if (videoAuction) {
                if (shouldWaitForConsent) {
                    self.waitForConsent(function() {

                        // Make sure to wait for googletag.
                        window.googletag.cmd.push(function(){
                        
                            self.requestHeaderBids(videoAuction.getId(), 'video');
                        });
                    })

                    self.startFailSafeTimeout(videoAuction.getId());
                } else {
                    // Make sure to wait for googletag.
                    window.googletag.cmd.push(function(){
                    
                        self.requestHeaderBids(videoAuction.getId(), 'video');
                    });
                }
            }
        }

        if(!videoAuction){

            this.logger.debug('No video auction to be held!', {
                adElementId: adElementId,
                placement: placement,
            });
        }
    },

    //
    // Returns the next preroll ad.
    requestNextPrerollAd: function(adElementId){

        // Similar to method retryPrerollAd except there's no need to mark bids as used.
        return this.__buildIUrlVideo(adElementId, 'preroll');
    },

    //
    // Function for getting the CPM of direct deals.
    // TODO: Make more dynamic.
    matchCreativeIdsToCPM: function(creativeIds){

        var cpm = null;

        for(var i = 0; i < creativeIds.length; i++){

            if(this.__directDealsMapping.hasOwnProperty(creativeIds[i])){

                cpm = this.__directDealsMapping[creativeIds[i]];

                break;
            }
        }

        return cpm;
        
        var cpm;
        var nintendoCampaigns = ['138498062660', '138497699259', '138497699301', '138498062801'];
        var mpw = ['138475313070'];
        var tg_12 = ['138498764711', '138497602460'];
        var tg_14 = ['138475313070'];
        var tg_16 = ['138500864398', '138484188431', '138502480580', '138502480328', '138502480331'];
        var tg_17 = ['138500310545', '138500166637', '138500166520'];

        var sr_14 = ['138475313070'];
        var sr_15 = ['138503276197', '138503276449', '138503663893', '138502892334', '138503177256'];
        var sr_17 = ['138501687742', '138501690166', '138500866809', '138501690163'];

        var camp_15 = ['138418651661', '138418651643', '138504456690', '138504456768', '138419287153', '138419287447', '138418651646', '138420647423'];

        var camp_12 = ['138498878799'];

        var camp_18 = ['138477503980'];

        var camp_13 = ['138501545901', '138501762710', '138501762806'];




        if (creativeIds.some(id => nintendoCampaigns.includes(id))) {
            cpm = 17;
        }

        if (creativeIds.some(id => mpw.includes(id))) {
            cpm = 16.50;
        }

        if (creativeIds.some(id => tg_12.includes(id))) {
            cpm = 12.73;
        }

        if (creativeIds.some(id => tg_14.includes(id))) {
            cpm = 14.85;
        }

        if (creativeIds.some(id => tg_16.includes(id))) {
            cpm = 16.20;
        }

        if (creativeIds.some(id => tg_17.includes(id))) {
            cpm = 17.00;
        }

        if (creativeIds.some(id => sr_14.includes(id))) {
            cpm = 14.85;
        }

        if (creativeIds.some(id => sr_15.includes(id))) {
            cpm = 15.00;
        }

        if (creativeIds.some(id => sr_17.includes(id))) {
            cpm = 17.00;
        }

        if (creativeIds.some(id => camp_15.includes(id))) {
            cpm = 15.00;
        }

        if (creativeIds.some(id => camp_12.includes(id))) {
            cpm = 12.23;
        }

        if (creativeIds.some(id => camp_18.includes(id))) {
            cpm = 18.00;
        }

        if (creativeIds.some(id => camp_13.includes(id))) {
            cpm = 13.50;
        }

        return cpm;
    },

    getBidFromCreativeIds(creativeIds) {
        var matchingKey = Object.keys(this.adIdMap).find(function(key){

            return creativeIds.some(function(creativeId){

                return creativeId === key;
            });
        });

        return matchingKey && this.adIdMap[matchingKey];
    },

    //
    // Records ad Impression in 3rd party tracking.
    recordAdImpression(creativeIds, elementId){

        var bid         = this.getBidFromCreativeIds(creativeIds);
        var adUnit      = this.getAdsData(elementId);
        var adUnitName  = adUnit && adUnit.getName();
        var adUnitPath  = adUnit && adUnit.getAdUnitPath();
        var networkCode = this.getNetworkCodeFromGAMPath(adUnitPath);
        var browserName = utils.getBrowserName(window.navigator.userAgent);

        var recordingOptions = {};
                
        if(this.__bannerEnabledEventTrackingBrand.includes(this.getBrandName())){

            recordingOptions = this.getRecordingOptions(adUnit);
        }
        
        if(bid){

            var gamCPM  = this.matchCreativeIdsToCPM(creativeIds);
            var bid_src = 'prebid';

            if(bid.slotID){

                bid_src = 'amazon';
            } 
            else if(gamCPM){

                bid_src = 'gam';
            }

            var bidder             = bid.bidderCode || bid.targeting && bid.targeting.amznp;
            var bidderForTelemetry = bid.bidder || 'amazon';
            var ad_unit            = bid.adUnitCode || bid.slotID;
            var creative_id        = bid.creativeId;
            var revenueEvent       = {
                networkCode,
                bid_src,
                bidder,
                ad_unit,
                adUnitName,
                creative_id,
                cpm: gamCPM || bid.cpm,
                duration: bid.duration,
                transaction_id: window.crypto.randomUUID(),
                type: "ad_impression",
                brandName: this.getBrandName(),
                template: this.getTemplate(),
                country: this.getGeo(),
                device: this.getDeviceType(),
                source: this.getClientData()['source'],
                operatingSystem: this.getMobileOperatingSystem()
            };

            if(this.__brandsServingVideosOutsideOfGAM.indexOf(this.getBrandName()) !== -1){
                window._crucible = window._crucible || {q: []};
                window._crucible.q.push(() => {
                   window._crucible.track(revenueEvent, { custom_1: String(browserName) });
                });
            

                this.logger.debug(`Sending impression to be recoreded.`, {
                revenueEvent: revenueEvent
                });

                var bidLifeTime = null;
                if(bid_src === 'prebid' && bid.responseTimestamp){
                    bidLifeTime = (Date.now() - bid.responseTimestamp) / 1000;
                }

                this.__revenueRecorder.recordImpression(adUnit.getName(), ('gam' === bid.bidder) ? 'gam' : bid_src, bidderForTelemetry, (gamCPM) ? gamCPM : bid.cpm || 0, recordingOptions, bidLifeTime);
            }
        }
    },

    //
    // Records ad error in 3rd party tracking. Adds SSP to video blacklist
    recordAdError(event, creativeIds, adWrapperSystems, elementId){

        var errorMessage = event.data?.AdError?.data?.errorMessage;
        var innerErrorMessage = event.data?.AdError?.data?.innerError;
        var errorCode = event.data?.AdError?.data?.errorCode;

        var bid         = this.getBidFromCreativeIds(creativeIds);
        var adUnit      = this.getAdsData(elementId);
        var adUnitName  = adUnit && adUnit.getName();
        var adUnitPath  = adUnit && adUnit.getAdUnitPath();
        var networkCode = this.getNetworkCodeFromGAMPath(adUnitPath);

        if(bid){
            var gamCPM  = this.matchCreativeIdsToCPM(creativeIds);
            var bid_src = 'prebid';

            if(bid.slotID){
                bid_src = 'amazon';
            }
            else if(gamCPM){
                bid_src = 'gam';
            }
            var bidder           = bid.bidderCode || bid.targeting && bid.targeting.amznp;
            var adWrapperSystems = [bid.adId, ...adWrapperSystems].join('-'); // Decorate creative id with ad systems to see naughty DSPs
            var adomains         = (bid.meta?.advertiserDomains || []).join('-');
            var details          = {
                networkCode,
                bid_src,
                bidder,
                creative_id: `${bid.adId}_${bid.creativeId}_${adWrapperSystems}_${adomains}`,
                cpm: gamCPM || bid.cpm,
                duration: bid.duration,
            };

            var rand = Math.floor(Math.random() * (100 - 1 + 1) + 1);
            // Ignore when the impression doesn't fill
            if (errorCode && rand <= 10) {
                // Send errors to crucible
                var errorDetails = {
                    ...details,
                    type: "error",
                    error_code: errorCode,
                    error_message: `Message: ${errorMessage}, Inner Message: ${innerErrorMessage}`,
                }

                window._crucible = window._crucible || {q: []};
                window._crucible.q.push(() => {
                   window._crucible.track(errorDetails);
                });
            }
        }
    },

    //
    // Marks a bid as used for video by adId.
    markBidAsUsedByAdId(adElementId, creativeIds, completionCallback){
        var matchingKey = Object.keys(this.adIdMap).find(function(key) {
          return creativeIds.some(function(creativeId) {
            return creativeId === key;
          })
        });

        var bid          = matchingKey && this.adIdMap[matchingKey];
        bid.valnetUsed = true;
        bid.status = 'rendered';

        var latestAuctionId = this.__getLatestAuctionId(adElementId);
        var ad              = window.adsNinjaHeaderBiddingManager.auctions[latestAuctionId].getAd(adElementId);
        var amazonSlotId    = (ad.hasSupportForVideoInstream()) ? 'preroll' : 'outstream';
        this.auctions[latestAuctionId].allowBidsToBeReused(this.BIDDING_LIBRARY_PREBID, adElementId);
        this.auctions[latestAuctionId].allowBidsToBeReused(this.BIDDING_LIBRARY_AMAZON, amazonSlotId);
        var isAmazonAd = bid.adId && bid.adId.includes('amazon');
        var isPrebidAd = bid.adId && bid.adId.includes('prebid');
        if(typeof completionCallback === 'function'){
            completionCallback(isAmazonAd || isPrebidAd);
        }

        window.adsNinjaHeaderBiddingManager.log(`Mark bid used by ad id details: `, {
            adElementId,
            matchingKey,
            creativeIds,
            bid,
            latestAuctionId,
        });
    },

    //
    // Marks a bid as used for video.
    markBidAsUsed(adElementId, creativeIds, completionCallback = null){

        if(!adElementId){

            this.logger.debug(`Unable to mark bids as used one or more params are invalid.`, {
                adElementId: adElementId,
                creativeIds: creativeIds,
            });

            return false;
        }

        if(!this.__adsData.hasOwnProperty(adElementId)){

            this.logger.warn(`There is no ad data registered with the ID: ${adElementId}.`);
            return false;
        }

        // Get latest auction.
        var latestAuctionId = this.__getLatestAuctionId(adElementId);

        if(!this.doesAuctionExist(latestAuctionId)){

            throw new Error(`There is no auction registered with the ID: ${latestAuctionId}.`);
        }

        if(!creativeIds || !Array.isArray(creativeIds) || creativeIds.length === 0){

            this.logger.debug(`Creative IDs passed are empty unable to confidently mark bids as used. Invalidating highest bids in the bid pools of each bidding library.`, {
                adElementId: adElementId,
                creativeIds: creativeIds,
            });

            this.auctions[latestAuctionId].markAllHighestBidsAsUsed(adElementId);

            return true;
        }

        var isAmazonAd = false;
        var isPrebidAd = false;

        // Determine if bid is Amazon or Prebid.
        for(var creativeId of creativeIds){
            // Allows us to use prebid_xxx and amazon_xxx for VAST wrapper creative ids.
            var _creativeId = creativeId.replace(/_.*|_.*/g, '');

            if(this.PREBID_CREATIVE_IDS.includes(_creativeId)){

                isPrebidAd = true;

                break;
            }

            if(this.AMAZON_CREATIVE_IDS.includes(_creativeId)){

                isAmazonAd = true;

                break;
            }
        }

        var resultAmazon = false;
        var resultPrebid = false;
        var ad           = window.adsNinjaHeaderBiddingManager.auctions[latestAuctionId].getAd(adElementId);
        var amazonSlotId = (ad.hasSupportForVideoInstream()) ? 'preroll' : 'outstream';

        // Not Amazon or Prebid then do nothing.
        if(isAmazonAd){

            // TODO: Make configurable, can only have 1 player with Amazon on the page like this.
            resultAmazon = this.auctions[latestAuctionId].markHighestBidAsUsed(this.BIDDING_LIBRARY_AMAZON, amazonSlotId);

            this.auctions[latestAuctionId].allowBidsToBeReused(this.BIDDING_LIBRARY_PREBID, adElementId);


            window.adsNinjaHeaderBiddingManager.log(`video auction: amazon bid marked as used:`, {
                resultAmazon : resultAmazon,
            });

        }
        else if(isPrebidAd){

            resultPrebid = this.auctions[latestAuctionId].markHighestBidAsUsed(this.BIDDING_LIBRARY_PREBID, adElementId);
            this.auctions[latestAuctionId].allowBidsToBeReused(this.BIDDING_LIBRARY_AMAZON, amazonSlotId);

            window.adsNinjaHeaderBiddingManager.log(`video auction: prebid bid marked as used:`, {
                resultPrebid : resultPrebid,
            });
        }
        else{

            this.auctions[latestAuctionId].allowBidsToBeReused(this.BIDDING_LIBRARY_PREBID, adElementId);
            this.auctions[latestAuctionId].allowBidsToBeReused(this.BIDDING_LIBRARY_AMAZON, amazonSlotId);

            window.adsNinjaHeaderBiddingManager.log(`video auction: allowing all bids to be re-used:`, {
            });
        }

        this.logger.debug('Attempted to mark highest bid as used.', {
            creativeIds: creativeIds,
            isAmazonAd: isAmazonAd,
            markHighestBidAsUsedAmazon: resultAmazon,
            isPrebidAd: isPrebidAd,
            markHighestBidAsUsedPrebid: resultPrebid,
        });

        if(typeof completionCallback === 'function'){

            // Add a skip button when not an AdX ad.
            // AdX is pretty good about adhering to the skip policy.
            // Sometimes we get an unskippable AdX ad and the reason.
            // In that case we don’t add a skip button because it’s against AdX policy to overlay stuff over their ads.
            completionCallback(isAmazonAd || isPrebidAd);
        }

        return resultAmazon || resultPrebid;
    },

    //
    // Prepares another ad request URL. No new Prebid or Amazon auctions are held but an EDBA one will.
    retryPrerollAd: function(adElementId){

        this.logger.debug(`Retrying Pre-roll ad for video player.`, {
            adElementId: adElementId,
        });

        this.markBidAsUsed(adElementId, this.PREBID_CREATIVE_IDS);

        // This is essentially a new auction with EDBA but not Amazon or Prebid.
        return this.__buildIUrlVideo(adElementId, 'preroll');
    },

    __buildVastXMLWaterfall: function(adElementId, amazonBids, prebidBids) {
      var allBids = [];

      for (var amazonBid of amazonBids) {
        amazonBid.xmlAdId = `amazon_${amazonBid.adId}`;
        amazonBid.creativeId = amazonBid.targeting.amzniid;
      }

      for (var prebidBid of prebidBids) {
        prebidBid.xmlAdId = `prebid_${prebidBid.adId}`;
      }

      allBids.push(...prebidBids, ...amazonBids);

      // Sort bids before including GAM
      var sortedBids = allBids.sort(function(a, b) { return b.cpm - a.cpm });

      // GAM request URL is floored to highest bid. This will return a higher bid or fallback to the highest bid.
      var gamBid = this.getFlooredGAMBid(adElementId, sortedBids[0]);
      gamBid.xmlAdId = `gam_${gamBid.adId}`;
      gamBid.creativeId = 'gam';
      sortedBids.unshift(gamBid);

      var vastAds = sortedBids.map(function(bid, index) {

        var url = bid.vastUrl;

        // Test prebid local cache
        const excludedDomains = ['military.com'];

        if (!excludedDomains.some(domain => window.location.hostname.includes(domain))) {
            if (bid.vastXml) {
                url = `data://text/xml;base64,${btoa(bid.vastXml)}`;
            } else if (bid.vastUrl && bid.vastUrl.startsWith('blob:')) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', bid.vastUrl, false); // synchronous
                xhr.send();
                if (xhr.status === 200) {
                    url = `data://text/xml;base64,${btoa(xhr.responseText)}`;
                } else {
                    url = bid.vastUrl;
                }
            } else {
                url = bid.vastUrl;
            }
        }

        return `<Ad id="${bid.xmlAdId}">
  <Wrapper fallbackOnNoAd="true">
   <AdSystem>GDFP</AdSystem>
   <VASTAdTagURI><![CDATA[${url}]]></VASTAdTagURI>
   <Creatives>
    <Creative id="${bid.creativeId}" sequence="1"></Creative>
   </Creatives>
   <Extensions><Extension type="waterfall" fallback_index="${index}"/></Extensions>
  </Wrapper>
</Ad>`
      })

      return `<?xml version="1.0" encoding="UTF-8"?>
<VAST xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="vast.xsd" version="4.0">
  ${vastAds.join('\n')}
</VAST>`;
    },

    //
    // Returns a GAM video URL for instream ads.
    __buildIUrlVideo: function(adElementId, placement){

        if(!this.__adsData.hasOwnProperty(adElementId)){

            this.logger.warn(`There is no ad data registered with the ID: ${adElementId}.`);
            return '';
        }

        // Get latest auction.
        var auctionId = this.__getLatestAuctionId(adElementId);

        if(!this.doesAuctionExist(auctionId)){

            throw new Error(`There is no auction registered with the ID: ${auctionId}.`);
        }

         var auction = window.adsNinjaHeaderBiddingManager.auctions[auctionId];

         window.adsNinjaHeaderBiddingManager.log(`video auction: auction to be used for GAM ad request:`, {
            auction : auction,
        });


        if(this.__numberOfConsecutiveNoNewBidAuctions && typeof this.__numberOfConsecutiveNoNewBidAuctions === 'object'){

            if(!this.__numberOfConsecutiveNoNewBidAuctions.hasOwnProperty(adElementId)){

                this.__numberOfConsecutiveNoNewBidAuctions[adElementId] = 0;
            }

            if(!auction.hasNewBids(adElementId)){

                this.__numberOfConsecutiveNoNewBidAuctions[adElementId]++;

                this.logger.debug('No new bids received from all bidding systems.', {
                    adElementId: adElementId,
                    auctionId: auctionId,
                    maxnumberOfConsecutiveNoNewBidAuctions: this.getRequestsCapOutstream(),
                    numberOfConsecutiveNoNewBidAuctions: this.__numberOfConsecutiveNoNewBidAuctions[adElementId],
                });
            }
            else{

                this.__numberOfConsecutiveNoNewBidAuctions[adElementId] = 0;
            }
        }

        var ad           = auction.getAd(adElementId);
        var amazonSlotId = (ad.hasSupportForVideoInstream()) ? 'preroll' : 'outstream';
        var prebidBid    = auction.getHighestUnusedBid(this.BIDDING_LIBRARY_PREBID, adElementId, this.__videoBidderBlacklist, this.__onlyFromAuctionBidder);
        var amazonBid    = auction.getHighestUnusedBid(this.BIDDING_LIBRARY_AMAZON, amazonSlotId,this.__videoBidderBlacklist, this.__onlyFromAuctionBidder); // TODO: Make configurable, can only have 1 player with Amazon on the page like this.
        var videoUrl     = null;
        var adUnitPath   = ad.getAdUnitPath();
        var additionalVideoParams = this.__buildVideoAdParams(adElementId, placement);
        var isVideo = ad.__hasAdDataVideoOptions();
        var zoneGroupName = ad.zoneGroupName;

        var mode = ad.getVideoContextName();
        var videoUrlData = {};

        if(!this.__isPrebidDisabled){

            var adUnit       = auction.getPrebidAdUnit(adElementId);
            videoUrlData = {
                adUnit: adUnit,
                params: {
                    iu: adUnitPath,
                    sz: '640x480', // Needs to match GAM size.
                },
            };
        }

        // TODO: Make configurable so that ad ops can decide when to send requests to GAM if no bids are received from all bidding systems. 
        if(ad.hasSupportForVideoOutstream() 
            && (!prebidBid || typeof prebidBid !== 'object' || Object.keys(prebidBid).length === 0) 
            && (!amazonBid || typeof amazonBid !== 'object' || Object.keys(amazonBid).length === 0)
            && 'TheGamer' !== this.getBrandName()
        ){

            if(!auction.getNoBiddingAuction()){

                if(ad){

                    var adUnitName = ad.getName();

                    this.__requestsNotSentToGAMCounter.increment(adUnitName, 'video', false);
                }
            }

            this.logger.debug('No highest bids for all bidding systems. Returning empty video URL.');
            return '';
        }

        // If the Prebid bid is empty. Method "buildVideoUrl" will try and find a highest bid if one is available.
        // Without using "markWinningBidAsUsed" could be reusing a bid that was already used on page.
        if(prebidBid){

            if('TheGamer' === this.getBrandName()){

                this.confirmBidNotUsed(adElementId, (prebidBid.hasOwnProperty('adId')) ? prebidBid.adId : 0);
            }

            videoUrlData['bid'] = prebidBid;
        }

        window.adsNinjaHeaderBiddingManager.log(`video auction: prebid bid to be used for GAM ad request:`, {
            prebidBid : prebidBid,
        });

        window.adsNinjaHeaderBiddingManager.log(`video auction: amazon bid to be used for GAM ad request:`, {
            amazonBid : amazonBid,
        });

        // rendering video outside GAM 
        if(this.__brandsServingVideosOutsideOfGAM.indexOf(this.getBrandName()) !== -1){

            var recordingOptions = {};
                
            if(this.__bannerEnabledEventTrackingBrand.includes(this.getBrandName())){

                recordingOptions = this.getRecordingOptions(ad);
            }

            this.__revenueRecorder.recordRequest(ad.getName(), auction.getBidders(adElementId), recordingOptions); 

            // Track ad Requests in Crucible
            if(["TheGamer", "SimpleFlying"].indexOf(this.getBrandName()) !== -1){
                window._crucible = window._crucible || {q: []};
                window._crucible.q.push(() => {
                    const adRequest = {
                      media_type: 'video',
                      ad_unit: 'adunitA',
                      type: 'ad_opportunity',
                    }
                   window._crucible.track(adRequest);
                });
            }

            var prebidBids = prebidBid ? [prebidBid] : [];
            var amazonBids = amazonBid ? [amazonBid] : [];

            // top 3 prebid, top 3 amazon bids in vast waterfall
            var prebidBids = [prebidBid, ...auction.getHighestUnusedBids(this.BIDDING_LIBRARY_PREBID, adElementId, 2, this.__videoBidderBlacklist, this.__onlyFromAuctionBidder)].filter(function(x) { return x });
            var amazonBids = [amazonBid, ...auction.getHighestUnusedBids(this.BIDDING_LIBRARY_AMAZON, amazonSlotId, 2, this.__videoBidderBlacklist, this.__onlyFromAuctionBidder)].filter(function(x) { return x });

            this.__currentWaterfallBids = [...prebidBids]

            return this.__buildVastXMLWaterfall(adElementId, amazonBids, prebidBids);
        }

        if(!this.__isPrebidDisabled){
            if(window.pbjs.adServers.hasOwnProperty('dfp')){
                videoUrl = window.pbjs.adServers.dfp.buildVideoUrl(videoUrlData);
            }else{
                videoUrl = window.pbjs.adServers.gam.buildVideoUrl(videoUrlData);
            }
        }else{
            videoUrl = this.__buildVideoUrl(ad);
        }
        
        if(amazonBid){

            var amazonBidTargeting = amazonBid.encodedQsParams || amazonBid.helpers.encodedQsParams();
            videoUrl               = videoUrl + amazonBidTargeting;
        }

        var siteKeyValuePairs    = '';
        var additionalVideoParamsPairs = '';

        
        var keyValueUriComponent = `&Site=${this.getBrandName()}`
            + `&ContentType=${this.getContentType()}`
            + `&Template=${this.getTemplate()}`
            + `&NetworkCategory=${this.getNetworkCategory()}`
            + `&SiteCategory=${this.getSiteCategory()}`
            + `&PostID=${this.getPostId()}`
            + `&mode=${mode}`;

        var videoElementId = adElementId + '-video';

        // Attach additional video params to request.
        try{

            if(additionalVideoParams){

                for(var paramKey in additionalVideoParams){

                    var value = additionalVideoParams[paramKey];
                    additionalVideoParamsPairs = `${additionalVideoParamsPairs}${paramKey}=${value}&`;
                }
            }
        }
        catch(error){

            this.logger.error('Error setting additional video params.', {
                error: error,
            });
        }

        

        // Attach site wide gpt targeting to request.
        try{

            var gptTargetingKeys = window.googletag.pubads().getTargetingKeys() || [];

            for(var key of gptTargetingKeys){

                var value         = window.googletag.pubads().getTargeting(key);
                siteKeyValuePairs = `${siteKeyValuePairs}&${key}=${value}`
            }
        }
        catch(error){

            this.logger.error('Error setting site wide kv pairs.', {
                error: error,
            });
        }

        videoUrl = videoUrl + window.encodeURIComponent(keyValueUriComponent + siteKeyValuePairs);

        // Make sure additional cust_params like GDPR and us_privacy are encoded.
        var splitUrlParts = videoUrl.split('cust_params=');

        if(splitUrlParts.length > 0){

            var splitUrl                 = splitUrlParts[0];
            var splitCustomParams        = splitUrlParts[1];
            var splitCustomParamsDecoded = window.decodeURIComponent(splitCustomParams);

            if(additionalVideoParamsPairs != ''){

                splitUrl = splitUrl + additionalVideoParamsPairs;

            }
            videoUrl  = splitUrl + 'cust_params=' + window.encodeURIComponent(splitCustomParamsDecoded);
        }

        return videoUrl;
    },
    

    __buildVideoUrl : function(ad){

        var googleVastTagParams = [];
        var googleVastTagParamsPairs = '';

        var baseUrl = 'https://securepubads.g.doubleclick.net/gampad/ads?';

        var descriptionUrl = window.encodeURIComponent(window.location.origin + window.location.pathname);

        googleVastTagParams['env'] = 'vp';
        googleVastTagParams['gdfp_req'] = 1;
        googleVastTagParams['output'] = 'xml_vast4';
        googleVastTagParams['unviewed_position_start'] = 1
        googleVastTagParams['sz'] = '640x480';
        googleVastTagParams['url'] = descriptionUrl;
        googleVastTagParams['iu'] = ad['adUnitPath'];
        googleVastTagParams['description_url'] = descriptionUrl;


        if(googleVastTagParams){

            for(var paramKey in googleVastTagParams){

                var value = googleVastTagParams[paramKey];
                googleVastTagParamsPairs = `${googleVastTagParamsPairs}${paramKey}=${value}&`;
            }
        }

        var videoUrl = baseUrl + googleVastTagParamsPairs + '&cust_params=';

        var copyVideoUrl = videoUrl;
        
        return videoUrl;
    
    },
        // Returns a GAM video Request params.
    __buildVideoAdParams: function(adElementId, placement){

        var ad = this.__adsData[adElementId];
        var mode = ad.getVideoContextName();
        var videoOptions = ad.getVideoSettings();
        var autoplay = videoOptions['allowAutoplay'];
    
        var videoAdRequestParams = [];
        var plcmt = null;
    
        switch(mode){
    
            case 'instream':
    
                plcmt = 1
                break;
    
            case 'outstream':
    
                plcmt = 4
                break;
    
            case 'companion':
    
                plcmt = 2
                break;
            }
    
        videoAdRequestParams['description_url'] = window.encodeURIComponent(window.location.origin + window.location.pathname);
    
        if(plcmt !== null){
    
            videoAdRequestParams['plcmt'] = plcmt;
    
        }
    
        if(autoplay){
    
            videoAdRequestParams['vpa'] = 'auto';
        }else{
    
            videoAdRequestParams['vpa'] = 'click';
    
        }

        if(placement !== null){

            videoAdRequestParams['vpos'] = placement;
        }

        videoAdRequestParams['wta'] = '1';

        videoAdRequestParams['loginToContinue'] = this.getIsLoginToContinue();
    
        return videoAdRequestParams;
        
    },

    //
    // Returns last auction ID given an adElementId, throws exception when not found.
    __getLatestAuctionId: function(adElementId){

        if(!this.__auctionDictionaryByAdElementId.hasOwnProperty(adElementId)){

            throw new Error(`Unable to find latest auction for adElementId: ${adElementId}`);
        }

        var length = this.__auctionDictionaryByAdElementId[adElementId].length;

        return this.__auctionDictionaryByAdElementId[adElementId][length - 1];
    },

    //
    // Returns last auction.
    __getLatestAuction: function(adElementId){
        
        var auctionId = this.__getLatestAuctionId(adElementId);

        if(!this.doesAuctionExist(auctionId)){

            return null;
        }

        return this.auctions[auctionId];
    },

    //
    // Adds auctions IDs to a lookup table that will be used for video auctions.
    registerAuctionVideoIfAvailable: function(auctionId, isNoBidAuction = false){

        if(!this.doesAuctionExist(auctionId)){

            throw new Error(`There is no auction registered with the ID: ${auctionId}.`);
        }

        var auction = this.auctions[auctionId];

        // Get auction video div IDs.
        var videoDivIds = auction.getDivIdsOnlyVideo();

        if(videoDivIds.length === 0){

            // No instream video ads in auction.
            return;
        }

        if(!window.pbjs.hasOwnProperty('adServers') || ((!window.pbjs.adServers.hasOwnProperty('dfp') || typeof window.pbjs.adServers.dfp.buildVideoUrl !== 'function') && (!window.pbjs.adServers.hasOwnProperty('gam') || typeof window.pbjs.adServers.gam.buildVideoUrl !== 'function'))){

            this.logger.error('Unable to register video auction. Prebid module dfpAdServerVideo is missing!');

            return;
        }

        // Add records to lookup table of divIds linked to auctions.
        // Dictionary is indexed by div IDs containing a list of auctionIds.
        for(var x in videoDivIds){

            var hasBids     = true;
            var adElementId = videoDivIds[x];

            if(!this.__auctionDictionaryByAdElementId.hasOwnProperty(adElementId) || this.__auctionDictionaryByAdElementId[adElementId].length === 0){

                this.__auctionDictionaryByAdElementId[adElementId] = [];
            }
            else{

                // TODO: When time permits see about simplifying these lines.
                var length            = this.__auctionDictionaryByAdElementId[adElementId].length;
                var previousAuctionId = (length > 1) ? this.__auctionDictionaryByAdElementId[adElementId][length - 2] : null;

                if(previousAuctionId){

                    // If a previous auction took place copy over unused bids.
                    var previouslyUnusedPrebidBids = this.auctions[previousAuctionId].getUnusedBids(this.BIDDING_LIBRARY_PREBID);
                    var previouslyUnusedAmazonBids = this.auctions[previousAuctionId].getUnusedBids(this.BIDDING_LIBRARY_AMAZON);

                    window.adsNinjaHeaderBiddingManager.log(`video auction: previously Unused Bids:`, {
                        previouslyUnusedPrebidBids,
                        previouslyUnusedAmazonBids,
                    });

                    if(previouslyUnusedPrebidBids && Object.keys(previouslyUnusedPrebidBids).length > 0){

                        auction.setBidsPrebid(previouslyUnusedPrebidBids, true);

                        window.adsNinjaHeaderBiddingManager.log(`video auction: auction after adding previously Unused Prebid Bids:`, {
                            auction,
                        });
                    }

                    if(previouslyUnusedAmazonBids && Object.keys(previouslyUnusedAmazonBids).length > 0){

                        auction.setBidsAmazon(previouslyUnusedAmazonBids, true);

                        window.adsNinjaHeaderBiddingManager.log(`video auction: auction after adding previously Unused Amazon Bids:`, {
                            auction,
                        });
                    }

                    if(isNoBidAuction){

                        auction.setPrebidAdUnits(this.auctions[previousAuctionId].getPrebidAdUnits());
                        hasBids                                   = false;
                        this.__videoAuctionsDisabled[adElementId] = adElementId;
                    }
                }
            }

            var completionCallback      = auction.getCompletionCallback(adElementId);
            var placement               = auction.getVideoPlacement();
            var isInflateBidPoolAuction = auction.getInflateBidPool();

            if(isInflateBidPoolAuction){

                var ad = this.getAdsData(adElementId);

                if(ad){

                    var adUnitName = ad.getName();

                    this.__requestsNotSentToGAMCounter.increment(adUnitName, 'video', true);
                }
            }
            if(completionCallback && typeof completionCallback === 'function' && hasBids && !isInflateBidPoolAuction){

                completionCallback(this.__buildIUrlVideo(adElementId, placement));
            }
            else if(completionCallback && typeof completionCallback === 'function'){

                // Don't return a video ad URL, thus avoid marking bids as sent, when using remaining bids.
                completionCallback('');
            }
        }
    },

    //
    // Returns video player configurations.
    getVideoPlayerConfigurations: function(){

        var result                          = [];
        var ads    = this.__filterAdsDataByManagedVideo(this.__adsData);
        var priorityAds                     = this.__filterAdsDataByManagedVideo(false);
        var nonPriorityAds                  = this.__filterAdsDataByManagedVideo(true);
        var ads                             = priorityAds.concat(nonPriorityAds);        // Sort, put featured video players last.
        var alreadyhasAnAutoplayVideoOnPage = false;

        for(var x in ads){

            var playlist          = ads[x].getVideoList() || this.__videoList;
            var videoOptions      = ads[x].getVideoSettings();
            var floatingOptions   = ads[x].getFloatingOptions();
            var videoPlayerConfig = {
                elementId: ads[x]['adElementId'],
                allowAutoplay: videoOptions['allowAutoplay'],
                autoplay: ((!floatingOptions && videoOptions['allowAutoplay']) || ((videoOptions['allowAutoplay'] && !alreadyhasAnAutoplayVideoOnPage) || (videoOptions['allowAutoplay'] && ads[x].zoneName === 'Instream-Feature'))),
                soundOn: videoOptions['soundOn'],
                showTitle: videoOptions['showTitle'] || false,
                allowAds: true,
                showOverlays: ads[x].hasSupportForVideoInstream(),
                delayAfterAdSkippedInMilliseconds: (videoOptions && videoOptions.hasOwnProperty('shouldDelayAfterAdSkipped') && videoOptions['shouldDelayAfterAdSkipped']) ? videoOptions['delayAfterAdSkippedInMilliseconds'] : null,
                delayAfterAdClosedInMilliseconds: (floatingOptions && this.getAdBehaviourValue('refloatOutstream') && floatingOptions.hasOwnProperty('refloatDelayInMilliseconds')) ? floatingOptions['refloatDelayInMilliseconds'] : null, 
                useLargeSoundToggleButton: videoOptions['useLargeSoundToggleButton'] || false,
                videoType: (videoOptions.hasOwnProperty('context') && videoOptions['context'].hasOwnProperty('name')) ? videoOptions['context']['name'] : null, 
                showClickThroughButton: false, // videoOptions['showClickThroughButton'] || false,
                changingVideoDetails: videoOptions['changingVideoDetails'] || false,
                externalFloatControl: (!!floatingOptions),
            }

            if(this.__brandsServingVideosOutsideOfGAM.indexOf(this.getBrandName()) !== -1){

                videoPlayerConfig.renderAdWithReponseOverTag = true;
            }

            if(Array.isArray(playlist) && playlist.length > 0 && typeof playlist[0] === 'object' && Object.keys(playlist[0]).length !== 0){

                videoPlayerConfig['playlist'] = playlist;
            }
            else{

                // TODO: Here for backwards compatibility. Can be removed at some point.
                videoPlayerConfig['playlistVideoUrls'] = playlist;
            }

            if(videoOptions.hasOwnProperty('context') && videoOptions['context'].hasOwnProperty('name') && ('instream' === videoOptions['context']['name'] || 'accompanying' === videoOptions['context']['name'])){

                videoPlayerConfig['autoNavTimeInMillisecondsNextVideoPrompt']     = 35000;
                videoPlayerConfig['autoNavTimeInMillisecondsNextVideoTransition'] = 10000;
                videoPlayerConfig['allowAutoplayWhenInView']                      = false;
                videoPlayerConfig['maxPrerollAdCount']                            = 1;
                videoPlayerConfig['allowAutoPlaylistNavigation']                  = false;
                videoPlayerConfig['adSchedule']                                   = this.getAdBehaviourValue('videoAdsConfigInstream') || null;

                if(this.USING_SOUND_COOKIE && !this.isMobile()){ 

                    videoPlayerConfig['soundOn'] = this.isMuted(videoOptions['soundOn']);
                }
            }
            else if(videoOptions.hasOwnProperty('context') && videoOptions['context'].hasOwnProperty('name') && 'outstream' === videoOptions['context']['name']){

                videoPlayerConfig['allowAutoplayWhenInView']            = false;
                videoPlayerConfig['allowAutoPlaylistNavigation']        = false;
                videoPlayerConfig['requestDelayNoAdFillInMilliseconds'] = this.getAdBehaviourValue('requestDelayNoAdFillOutstream') || 2000;
                videoPlayerConfig['requestDelayAdErrorInMilliseconds']  = this.getAdBehaviourValue('requestDelayAdErrorOutstream') || 5000;

                if(videoOptions.hasOwnProperty('includeDefaultPlaylist') && !videoOptions['includeDefaultPlaylist']){

                    delete videoPlayerConfig['playlist'];
                    delete videoPlayerConfig['playlistVideoUrls'];
                }

                if(ads[x].isFloatingModeAlways()){

                    ads[x].setUsingManualFloatControl(true);
                }
            }
            else if(videoOptions.hasOwnProperty('context') && videoOptions['context'].hasOwnProperty('name') && 'companion' === videoOptions['context']['name']){

                videoPlayerConfig['adSchedule'] = this.getAdBehaviourValue('videoAdsConfigCompanion') || null;
            }

            result.push(videoPlayerConfig);

            if(floatingOptions){

                alreadyhasAnAutoplayVideoOnPage = (alreadyhasAnAutoplayVideoOnPage) ? true : videoOptions['allowAutoplay'];     
            }
        }

        return result;
    },

    //
    // Adds to video player settings.
    addToVideoPlayerSettings: function(adElementId, settings){
      
        var ad                                                = this.getAdsData(adElementId);
        var videoOptions                                      = ad.getVideoSettings();
        var floatingOptions                                   = ad.getFloatingOptions();
        var alreadyhasAnAutoplayVideoOnPage                   = false; //TODO look into that later since it's always false now.

        if (settings.allowAutoplay !== undefined) {
            settings.allowAutoplay                            = settings.allowAutoplay;
            settings.autoplay                                 = settings.autoplay !== undefined ? settings.autoplay : ((settings.allowAutoplay && !alreadyhasAnAutoplayVideoOnPage) || (settings.allowAutoplay && ad.zoneName === 'Instream-Feature'));
        } else {
            settings.allowAutoplay                            = videoOptions['allowAutoplay'];
            settings.autoplay                                 = ((videoOptions['allowAutoplay'] && !alreadyhasAnAutoplayVideoOnPage) || (videoOptions['allowAutoplay'] && ad.zoneName === 'Instream-Feature'));
        }

        settings.aspectRatio                                  = settings.aspectRatio !== undefined ? settings.aspectRatio : '16:9';
        settings.soundOn                                      = settings.soundOn !== undefined ? settings.soundOn : videoOptions['soundOn'];
        settings.showTitle                                    = settings.showTitle !== undefined ? settings.showTitle : videoOptions['showTitle'] || false;
        settings.allowAds                                     = settings.allowAds !== undefined ? settings.allowAds : true;
        settings.showOverlays                                 = ad.hasSupportForVideoInstream();
        settings.delayAfterAdSkippedInMilliseconds            = (videoOptions && videoOptions.hasOwnProperty('shouldDelayAfterAdSkipped') && videoOptions['shouldDelayAfterAdSkipped']) ? videoOptions['delayAfterAdSkippedInMilliseconds'] : null;    
        settings.delayAfterAdClosedInMilliseconds             = (floatingOptions && this.getAdBehaviourValue('refloatOutstream') && floatingOptions.hasOwnProperty('refloatDelayInMilliseconds')) ? floatingOptions['refloatDelayInMilliseconds'] : null; 
        settings.useLargeSoundToggleButton                    = videoOptions['useLargeSoundToggleButton'] || false;
        settings.videoType                                    = (videoOptions.hasOwnProperty('context') && videoOptions['context'].hasOwnProperty('name')) ? videoOptions['context']['name'] : null; 
        settings.showClickThroughButton                       = false; // videoOptions['showClickThroughButton'] || false;
        settings.changingVideoDetails                         = videoOptions['changingVideoDetails'] || false;
        settings.autoNavTimeInMillisecondsNextVideoPrompt     = 35000;
        settings.autoNavTimeInMillisecondsNextVideoTransition = 10000;
        settings.allowAutoplayWhenInView                      = false;
        settings.maxPrerollAdCount                            = 1;
        settings.allowAutoPlaylistNavigation                  = false;
        settings.adSchedule                                   = this.getAdBehaviourValue('videoAdsConfigInstream') || null;

        if(this.__brandsServingVideosOutsideOfGAM.indexOf(this.getBrandName()) !== -1){

            settings.renderAdWithReponseOverTag = true;
        }

        return settings;
    },

    //
    // reads the muteStatus cookie and returns true if unmuted
    isMuted: function(defaultSoundOn = false) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.startsWith('muteStatus=')) {
                var value = cookie.substring('muteStatus='.length);
                return value === 'unmuted';
            }
        }
        return defaultSoundOn; // Default value if the cookie is not found
    },

    //
    // Determines if the user is inactive based on settings of an ad unit.
    __isUserConsideredInactiveForAd: function(ad){

        if(!ad.hasAdDataUserActivityOptions()){

            return false;
        }

        var userActivityOptions     = ad.getUserActivityOptions();
        var idType                  = userActivityOptions['type']['id'];
        var thresholdInSeconds      = userActivityOptions['thresholdInSeconds'];
        var thresholdInMilliseconds = thresholdInSeconds * 1000;
        var result                  = false;

        // switch(idType){

        //     case this.ID_USER_ACTIVITY_TYPE_LONGEST_STRETCH_OF_INACTIVITY:

        //         result = this.__userActivityMonitor.hasUserBeenInactiveForThreshold(thresholdInMilliseconds);

        //         break;

        //     case this.ID_USER_ACTIVITY_TYPE_LAST_RECORDED_ACTIVITY:

        //         // Have to negate this one.
        //         result = (!this.__userActivityMonitor.hasUserActivityBeenDetectedRecently(thresholdInMilliseconds));

        //         break;

        //     case this.ID_USER_ACTIVITY_TYPE_TOTAL_TIME_INACTIVE:

        //         result = this.__userActivityMonitor.hasTotalUserInactivityExceededThreshold(thresholdInMilliseconds);

        //         break;

        //     case this.ID_USER_ACTIVITY_TYPE_TOTAL_TIME_TRACKING:

        //         result = this.__userActivityMonitor.hasTotalTrackingTimeExceededThreshold(thresholdInMilliseconds);

        //         break;

        //     default:

        //         this.logger.warn('Unknown user activity type.', {
        //             type: userActivityOptions['type'],
        //         });

        //         break;
        // }

        return result;
    },

    //
    // Register event handlers for bid response event.
    registerEventHandlerBidResponsePrebid: function(){

      var self = this;


      window.pbjs.que.push(function(){
        if (["DualShockers"].includes(self.getBrandName())) {
          var ozoneBids = {};
          // HACK: To get around the validVideoBid checks of Prebid 9.35.0
          window.pbjs.onEvent('bidRequested', function(bidRequest){
            if (bidRequest.bidderCode === "ozone") {
              bidRequest.bids.forEach(function(bid) {
                if (bid.mediaTypes.video) {
                  bid.mediaTypes.video.useCacheKey = false;
                  ozoneBids[bid.bidId] = bid;
                }
              })
            }
          })
        }

        // This happens before bidResponse and before video bids are cached.
        window.pbjs.onEvent('bidAccepted', function(bid){

          // Ozone is an edge case and returns vastXML in the adm field for some reason.
          // We want to put it in the vastXml field here so that our video creative caching will work for Ozone.
          if (bid.bidderCode === "ozone" && bid.mediaType === "video") {
            if (["DualShockers"].includes(self.getBrandName())) {
              ozoneBids[bid.bidId].mediaTypes.video.useCacheKey = true;
            }
            bid.vastXml = bid.adm;
          }
        })

        window.pbjs.onEvent('bidResponse', function(bid){
          self.logger.debug('Prebid bidResponse event.', {
            data: bid,
          });

          self.adIdMap[`prebid_${bid.adId}`] = bid;

          // Add bids that come in after the auction timeout into the bid pool.
          var auction = window.adsNinjaHeaderBiddingManager.auctions[bid.auctionId];


          if (auction && auction.arePrebidBidsBack()) {
            var lateBid = {};
            lateBid[bid.adUnitCode] = {bids: [bid]};
            window.adsNinjaHeaderBiddingManager.addNewPrebidBidsToPools(lateBid);
            self.logger.debug('Adding late bid into pool.', {
              data: bid,
            });
          }
        });
      })
    },

    //
    // Register event handlers for bid won event.
    registerEventHandlerBidWonPrebid: function(){

        var self = this;

        window.pbjs.onEvent('bidWon', function(data){

            self.logger.debug('Prebid bidWon event.', {
                data: data,
            });

            var adUnitCodeGAMRequest = null;

            if(data.hasOwnProperty('adUnitCodeGAMRequest')){

                adUnitCodeGAMRequest = data.adUnitCodeGAMRequest;
            }

            self.markPoolPrebidBidAsUsed(data.auctionId, data.adId, data.adUnitCodeGAMRequest);

            var ad = self.getAdsData(data.adUnitCodeGAMRequest);

            // Handle high impact ads in sticky footer. Video players should move up.
            if(ad && 'sticky footer' === ad.zoneName && ad.isFloatingModeAlways() && ('kargo' === data.bidderCode || 'gumgum' === data.bidderCode)){

                self.__handleHighImpactAd(data.bidderCode);
            }
            else if(ad && 'sticky footer' === ad.zoneName && ad.isFloatingModeAlways()){

                // Set flag for high impact ad.
                self.floatingDelegate.setHighImpactAdShowing(false);
            }
        });
    },

    //
    // Handle high impact ads in sticky footer. Video players should move up.
    __handleHighImpactAd: function(bidder){
        
        if('kargo' !== bidder && 'gumgum' !== bidder){

            return;
        }

        this.logger.debug(bidder + ' winning bid detected. Moving video players up.');

        var isHighImpactAd = true;
        var highImpactTier = 1;

        if('gumgum' === bidder){

            highImpactTier = 2;
        } 
        // else{ // Making everything tier 1 for now.

        //     var kargoElements  = document.querySelectorAll('body > div[class^="kargo-ad-v"]');
    
        //     for(var i = 0; i < kargoElements.length; i++){
    
        //         var kargoElement = kargoElements[i];
        //         var format       = kargoElement.getAttribute('data-format');
        //         format           = format.toLocaleLowerCase();
    
                
        //         // if('desktophover' === format || 'responsivehover' === format || 'hover' === format){
    
        //         //     highImpactTier = 2;
    
        //         //     break;
        //         // }
        //         // else if('sidekick' === format){
    
        //         //     isHighImpactAd = false;
        //         //     highImpactTier = null;
    
        //         //     break;
        //         // }
        //     }
        // }

        // Set flag for high impact ad.
        this.floatingDelegate.setHighImpactAdShowing(isHighImpactAd, highImpactTier);

        var zone = window.adsNinja.zoneDelegate.findBaseZone('sticky footer', 'footer');
        var unit = zone.getCurrentUnit();

        if(this.sspsThatCouldHaveOwnCloseButton.hasOwnProperty(bidder) 
            && this.checkAdCapabilityByAdElementId(this.AD_CAPABILITY_CAN_REMOVE_FLOATING_CLOSE_BUTTON, unit.getOriginalAdElementId())
        ){

            // Find the container.
            var adZoneContainerElement = document.getElementById(`ad-zone-container-${unit.getAdElementId()}`);

            if(adZoneContainerElement){

                adZoneContainerElement.classList.add('an-close-btn-disallowed');
            }
        }
    },

    //
    // Returns event recording ID.
    getEventRecordingData: function(adElementId){

        return window.adsNinjaHeaderBiddingManager.__eventTrackingDictionary[adElementId] || null;
    },

    //
    // Return true an element is floating.
    isAdFloating: function(adElementId){

        return this.floatingDelegate.isAdFloating(this.getAdsData(adElementId));
    },

    //
    // Return true when eleemnt is floating or should always be floating.
    isAdFloatingOrAlwaysFloating: function(adElementId){

        var ad = this.getAdsData(adElementId);

        return (this.isAdFloating(adElementId) || (ad && ad.isFloatingModeAlways()));
    },

    //
    // Record refresh interval.
    addRefreshInterval: function(adElementId, interval){

        if(!this.__refreshIntervals.hasOwnProperty(adElementId)){

            this.__refreshIntervals[adElementId] = [];
        }

        this.__refreshIntervals[adElementId].push(interval);
    },

    //
    // Clear refresh intervals.
    __clearRefreshIntervals: function(adElementId){

        for(var i in this.__refreshIntervals[adElementId]){

            clearInterval(this.__refreshIntervals[adElementId][i]);
        }
    },

    //
    // Record refresh timeout.
    addRefreshTimeout: function(adElementId, timeout){

        if(!this.__refreshTimeouts.hasOwnProperty(adElementId)){

            this.__refreshTimeouts[adElementId] = [];
        }

        this.__refreshTimeouts[adElementId].push(timeout);
    },

    //
    // Clear refresh timeouts.
    __clearRefreshTimeouts: function(adElementId){

        for(var i in this.__refreshTimeouts[adElementId]){

            clearTimeout(this.__refreshTimeouts[adElementId][i]);
        }
    },

    //
    // Update amazon bid in the pool after ad is rendered.
    updateAmazonBid: function(slot){

      var self = this;

      var adElementId = slot.getSlotElementId();
      var targetingMap = slot.getTargetingMap();
      var amzniid = targetingMap && targetingMap.amzniid && targetingMap.amzniid[0];
      var amznbid = targetingMap && targetingMap.amznbid && targetingMap.amznbid[0];
      var ad = this.__adsData[adElementId];
      var bidPoolName = ad.getBidPoolName();
      var bidPool = this.bidPools[bidPoolName];
      var amazonBidSentToGAM = this.__amazonBidSentToGAM[adElementId];

      if (amzniid && amznbid) {
        var html = slot.getResponseInformation() ? slot.getHtml() : '';
        var amazonBannerWon = html.includes('apstag.renderImp') && html.includes(amzniid);
        var amazonBannerVideoWon = html.includes('amazon-adsystem') && html.includes(amzniid); // We use our own custom amazon video banner creatives.
        var amazonWon = amazonBannerWon || amazonBannerVideoWon;

        if (amazonWon) {
          bidPool.markPoolAmazonBidAsUsed(amznbid, amzniid);
        }
      }

      if(amazonBidSentToGAM) {

        this.log(`Amazon bid status check for adElement: ${adElementId}, Handling of GPT delayed 5 sec to wait for potential amazon won event`, {
          ad: ad,
          bidPoolName: bidPoolName,
        });

        var auctionId = amazonBidSentToGAM['auctionId'];
        var adId = amazonBidSentToGAM['adId'];

        if(!amazonBidSentToGAM.hasOwnProperty('status') || amazonBidSentToGAM.status !== 'rendered'){

          self.log(`Amazon bid status check for adElement: ${adElementId} Checking if the amazon bid did win or not!`, {
            ad: ad,
            bidPoolName: bidPoolName,
          });

          if(!amazonBidSentToGAM['valnetSentCurrently']){

            self.log(`Amazon bid status check for adElement: ${adElementId}, Error valnetSentCurrently is false where it should be true`, {
              ad: ad,
            });
          }else{

            self.log(`Amazon bid status check for adElement: ${adElementId}, Amazon did not win, putting it back in the pool!`, {
              ad: ad,
              bidPoolName: bidPoolName,
            });
          }

          bidPool.allowBidToBeReused(auctionId, adId, adElementId, this.BIDDING_LIBRARY_AMAZON);
        }
      }
    },

    //
    // Update prebid bid in the pool after ad is rendered.
    updatePrebidBid: function(adElementId){

      var self = this;

      var ad = this.__adsData[adElementId];
      var bidPoolName = ad.getBidPoolName();
      var bidPool = this.bidPools[bidPoolName];
      var prebidBidSentToGAM = this.__prebidBidSentToGAM[adElementId];
      var reuseTimeout = 5000;

      reuseTimeout = (ad && ad.isVideoRequestModeDisplay()) ? 0 : 5000; // TODO: Remove timeout completely after outstream is sorted.

      if(prebidBidSentToGAM) {

        this.log(`Prebid bid status check for adElement: ${adElementId}, Handling of GPT delayed 5 sec to wait for potential prebid won event`, {
          ad: ad,
          bidPoolName: bidPoolName,
        });
        setTimeout(function() {
          var auctionId = prebidBidSentToGAM['auctionId'];
          var adId = prebidBidSentToGAM['adId'];

          if(!prebidBidSentToGAM.hasOwnProperty('status') || prebidBidSentToGAM.status !== 'rendered'){

            self.log(`Prebid bid status check for adElement: ${adElementId} Checking if the prebid bid did win or not!`, {
              ad: ad,
              bidPoolName: bidPoolName,
            });

            if(!prebidBidSentToGAM['valnetSentCurrently']){

              self.log(`Prebid bid status check for adElement: ${adElementId}, Error valnetSentCurrently is false where it should be true`, {
                ad: ad,
              });
            }else{

              self.log(`Prebid bid status check for adElement: ${adElementId}, Prebid did not win, putting it back in the pool!`, {
                ad: ad,
                bidPoolName: bidPoolName,
              });
            }

            bidPool.allowBidToBeReused(auctionId, adId, adElementId, self.BIDDING_LIBRARY_PREBID);
          }
        }, reuseTimeout);
      }
    },

    markPoolPrebidBidAsUsed: function(auctionId, adId, adUnitCodeGAMRequest){

        if(!this.areBidPoolsEnabled()){

            return;
        }

        this.log(`Prebid bid status check for adElement: Won check`, {
            auctionId: auctionId,
            adId:adId,
            ads: this.__adsData
        });

/*
        for (var i in this.__adsData){

            if(this.__adsData[i]['prebidBidSentToGAM'] !== null && this.__adsData[i]['prebidBidSentToGAM']['adId'] === adId){

                ad = this.getAdsData(this.__adsData[i]['adElementId']);
                break;

            }
        }

        this.log(`Prebid bid status check for adElement: Won check`, {
            ad: ad,
        });

 */

        if(adUnitCodeGAMRequest !== null) {

            var ad = this.__adsData[adUnitCodeGAMRequest];
            var bidPoolName = ad.getBidPoolName();
            var adElementId = ad['adElementId'];

            this.log(`Prebid bid status check for adElement: ${adElementId}, Prebid bid Won, We need to mark it as used`, {
                ad: ad,
            });

            if (bidPoolName !== null) {

                if (!this.bidPools.hasOwnProperty(bidPoolName)) {

                    throw new Error(`Mark pool bid Used: There is no bid pool registered with the ID: ${bidPoolName}.`);

                }

                var bidPool = this.bidPools[bidPoolName];
                bidPool.markPrebidBidAsUsed(auctionId, adId, ad['adElementId']);
            }
        }
    },

    // //
    // // Add waypoints for ad AutoScroll feature.
    // __addAutoScrollWaypoints: function(waypointElementId, adZoneHeight){

    //     if(!window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints.hasOwnProperty(waypointElementId)){

    //         window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints[waypointElementId] = [];
    //     }

    //     var waypointElement = document.getElementById(waypointElementId);

    //     var topWaypoint = new window.Waypoint({
    //         element: waypointElement,
    //         handler: function(direction){

    //             switch(direction){

    //                 case 'down':

    //                     window.adsNinjaHeaderBiddingManager.__addScrollAnimation(waypointElementId, 'down');
    //                     break;
    //             }
    //         },
    //         offset: function(){

    //             return (window.innerHeight / 2);
    //         },
    //     });

    //     window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints[waypointElementId].push(topWaypoint);

    //     var bottomWaypoint = new window.Waypoint({
    //         element: waypointElement,
    //         handler: function(direction){

    //             switch(direction){

    //                 case 'up':

    //                     window.adsNinjaHeaderBiddingManager.__addScrollAnimation(waypointElementId, 'up');
    //                     break;
    //             }
    //         },
    //         offset: function(){

    //             return (window.innerHeight / 2) - adZoneHeight;
    //         },
    //     });

    //     window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints[waypointElementId].push(bottomWaypoint);
    // },

    //
    // Adding scroll animation for ad unit with larger ads than the container.
    __addScrollAnimation: function(adElementId, context){

        var ad = this.getAdsData(adElementId);

        if(!ad){
            
            this.logger.warn('Unable to toggle floating for ad zone: ad does not exist!', {
                adElementId: adElementId,
            });
            return;
        }

        var adZoneElement       = ad.getAdZoneElement();
        var adZoneInlineElement = ad.getAdZoneInlineElement();

        if(!adZoneElement || !adZoneInlineElement){

            this.logger.warn('Unable to toggle floating for ad zone: one or more elements does not exist!', {
                adElementId: adElementId,
                elements: [
                    'adZoneContainerElement',
                    'adZoneSizeContainerElement',
                    'adZoneElement',
                ],
            });
            return;
        }

        if(this.removeAutoScrollIfNotNeeded(adElementId)){

            return;
        }

        adZoneElement.classList.add('adsninja-ad-zone-use-autoscroll');

        switch(context){

            case 'up':

                adZoneElement.classList.remove('scroll-down');
                adZoneElement.classList.add('scroll-up');

                adZoneInlineElement.style.top = '0px';

                break;

            case 'down':

                adZoneElement.classList.remove('scroll-up');
                adZoneElement.classList.add('scroll-down');

                var topProperty = adZoneElement.clientHeight - adZoneInlineElement.clientHeight;
                topProperty     = `${topProperty}px`;

                adZoneInlineElement.style.top = topProperty;

                break;
        }
    },
    
    //
    // Delete floating waypoint if exists.
    deleteAutoScrollWaypoints: function(adElementId){

        if(!window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints.hasOwnProperty(adElementId)){

            return;
        }

        for(var x in window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints[adElementId]){

            window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints[adElementId][x].destroy();
        }

        delete window.adsNinjaHeaderBiddingManager.__autoScrollWaypoints[adElementId];
    },

    // //
    // // Remove AutoScroll if not needed for an ad.
    removeAutoScrollIfNotNeeded: function(adElementId){

    //     var adZoneContainerElementId = `ad-zone-container-${adElementId}`;
    //     var adZoneContainerElement   = document.getElementById(adZoneContainerElementId);

    //     if(!adZoneContainerElement){

    //         this.log('Unable to handle scroll animation: container element does not exist!', {
    //             adElementId: adElementId,
    //             adZoneContainerElementId: adZoneContainerElementId,
    //         });
    //         return false;
    //     }

    //     var adZoneElement = adZoneContainerElement.getElementsByClassName('ad-zone')[0];

    //     if(!adZoneElement){

    //         this.log('Unable to handle scroll animation: element does not exist in container!', {
    //             adElementId: adElementId,
    //             adZoneContainerElementId: adZoneContainerElementId,
    //         });
    //         return false;
    //     }

    //     var adZoneInlineElement = adZoneElement.getElementsByClassName('ad-zone-inline')[0];

    //     if(!adZoneInlineElement){

    //         this.log('Unable to handle scroll animation: inline element does not exist in element!', {
    //             adElementId: adElementId,
    //             adZoneContainerElementId: adZoneContainerElementId,
    //         });
    //         return false;
    //     }

    //     var adData       = window.adsNinjaHeaderBiddingManager.getAdsData(adElementId);
    //     var adDimensions = adData.getAdDimensions();
    //     var adUnitHeight = adDimensions.heightNumeric || null;

    //     if(adData.getUseAutoScroll() && adUnitHeight && adZoneInlineElement.clientHeight <= adZoneElement.clientHeight){

    //         this.deleteAutoScrollWaypoints(adElementId);

    //         adZoneElement.classList.remove('adsninja-ad-zone-use-autoscroll');
    //         adZoneElement.classList.remove('an-overflow-hidden');
    //         adZoneElement.classList.remove('scroll-down');
    //         adZoneElement.classList.remove('scroll-up');
    //         adZoneElement.style.minHeight = `${adUnitHeight}px`;
    //         adZoneElement.style.height    = '';
    //         adZoneInlineElement.style.top = '';

    //         return true;
    //     }

        return false;
    },

    //
    // Handle ad is complete.
    handleAdIsComplete: function(adElementId){

        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);
        var requestResult          = this.floatingManager.requestToDefloat(
            adElementId, 
            floatingInfoForRequest.requestor
        );

        return requestResult;
    },

    //
    // Handle ad is complete helper.
    handleAdIsCompleteHelper: function(adElementId, context = null){
        
        var returnResult = this.__handleAdIsComplete(adElementId);
        
        if(returnResult && 'suspend' === context){

            var controlResult = window.adsNinja.pauseIfVideo(adElementId);

            if(!controlResult){

                this.logger.warn('Failed to pause video ad after defloating. This may result in a broken UI. Please check the browser console for more information.');
            }
        }

        return returnResult;
    },

    //
    // Handle ad is complete.
    __handleAdIsComplete: function(adElementId){

        var ad = this.__adsData[adElementId];

        if(!ad){

            this.logger.warn(`Unable to find ad unit with ad element id: ${adElementId}.`);
            return false;
        }

        var floatingOptions = ad.getFloatingOptions();

        // Check status of floating and if floating can be re-enabled.
        if(!floatingOptions || typeof floatingOptions !== 'object' || Object.keys(floatingOptions).length === 0){

           this.logger.warn(`Unable to find floating options for ad unit with ad element id: ${adElementId}.`);
            return false;
        }

        var adZoneSizeContainerElement = ad.getAdZoneSizeContainerElement();
        var adZoneInlineElement        = ad.getAdZoneInlineElement();
        var adZoneElement              = ad.getAdZoneElement();

        if(!adZoneSizeContainerElement || !adZoneInlineElement || !adZoneElement){

            this.logger.warn(`Unable to find one or more elements.`, {
                adElementId: adElementId,
                adZoneElement: adZoneElement,
                adZoneInlineElement: adZoneInlineElement,
                adZoneSizeContainerElement: adZoneSizeContainerElement,
            });
            return false;
        }

        // Disable floating waypoint if exists.
        this.disableFloatingAdWaypoints(adElementId);

        var heightProperty = 'minHeight';

        var heightRegular    = adZoneElement.getAttribute('data-height-regular');
        var widthRegular     = adZoneElement.getAttribute('data-width-regular');
        var positionFloating = adZoneElement.getAttribute('data-position');

        adZoneElement.classList.remove('ad-zone-floating');
        adZoneElement.classList.remove(`an-floating-pos-${positionFloating}`);
        adZoneElement.setAttribute('data-is-floating', 'false');

        // if(adZoneInlineElement.children.length > 0){

        //     // adZoneInlineElement.children[1].style.display = 'inherit';
        // }

        adZoneInlineElement.style                     = '';
        adZoneSizeContainerElement.style              = '';
        adZoneElement.style                           = 'text-align: center;';
        adZoneElement.style[heightProperty]           = heightRegular;
        adZoneElement.style.width                     = widthRegular;

        var heightRegularValstream = ('auto' === heightRegular) ? 'inherit' : heightRegular;
        var widthRegularValstream  = ('auto' === widthRegular) ? 'inherit' : widthRegular;

        this.handleFloatingDisengagedVideoPlayer(adElementId, heightRegularValstream, widthRegularValstream);

        // Re-disable close button if needed.
        var adCloseButtonResult = this.hideCloseButton(adElementId);
        var useCloseButton      = floatingOptions['useCloseButton'];

        if(!adCloseButtonResult && useCloseButton){

            this.logger.warn(`Unable to find close button element for floating ad.`, {
                adElementId: adElementId,
            });
        }

        return true;
    },

    //
    // Handle ad is ready to play.
    handleAdIsReadyToPlay: function(adElementId){

        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);
        var requestResult          = this.floatingManager.requestToFloat(
            adElementId, 
            floatingInfoForRequest.requestor,
            floatingInfoForRequest.adType, 
            floatingInfoForRequest.position, 
            floatingInfoForRequest.floatType, 
            this.handleAdIsReadyToPlayHelper.bind(this, adElementId),
            this.handleAdIsCompleteHelper.bind(this, adElementId)
        );

        return requestResult;
    },

    //
    // Handle ad is ready to play.
    handleAdIsReadyToPlayHelper: function(adElementId, context = null){

        var returnResult = this.__handleAdIsReadyToPlay(adElementId);

        if(returnResult && 'resume' === context){

            var controlResult = window.adsNinja.playIfVideo(adElementId);

            if(!controlResult){

                this.logger.warn('Failed to play video ad after floating. This may result in a broken UI. Please check the browser console for more information.');
            }
        }

        return returnResult;
    },

    //
    // Handle ad is ready to play.
    __handleAdIsReadyToPlay: function(adElementId){

        var ad = this.__adsData[adElementId];

        if(!ad){

            this.logger.warn(`Unable to find ad unit with ad element id: ${adElementId}.`);
            return false;
        }

        var floatingOptions = ad.getFloatingOptions();

        // Check status of floating and if floating can be re-enabled.
        if(!floatingOptions || typeof floatingOptions !== 'object' || Object.keys(floatingOptions).length === 0){

           this.logger.warn(`Unable to find floating options for ad unit with ad element id: ${adElementId}.`);
            return false;
        }

        var adZoneSizeContainerElement = ad.getAdZoneSizeContainerElement();
        var adZoneInlineElement        = ad.getAdZoneInlineElement();
        var adZoneElement              = ad.getAdZoneElement();
        var heightRegular              = adZoneElement.getAttribute('data-height-regular');
        var widthRegular               = adZoneElement.getAttribute('data-width-regular');
        var heightFloating             = adZoneElement.getAttribute('data-height-floating');
        var widthFloating              = adZoneElement.getAttribute('data-width-floating');
        var positionFloating           = adZoneElement.getAttribute('data-position');
        var floatingPriority           = ad.getFloatingPriority();

        if(!adZoneSizeContainerElement || !adZoneInlineElement || !adZoneElement){

            this.logger.warn(`Unable to find one or more elements.`, {
                adElementId: adElementId,
                adZoneElement: adZoneElement,
                adZoneInlineElement: adZoneInlineElement,
                adZoneSizeContainerElement: adZoneSizeContainerElement,
            });
            return false;
        }
        
        if('false' === adZoneElement.getAttribute('data-floating-allowed')){

            return false;
        }

        // Re-enable floating.
        this.enableFloatingAdWaypoints(adElementId);

        var heightProperty = 'height';

        adZoneElement.classList.add('ad-zone-floating');
        adZoneElement.classList.add(`an-floating-pos-${positionFloating}`);
        adZoneElement.setAttribute('data-is-floating', 'true');

        // adZoneInlineElement.children[0].style.display    = 'inline-block;';
        adZoneInlineElement.style                        = '';
        adZoneInlineElement.style                        = 'position: relative; display: inline-block;';
        adZoneElement.style                              = '';
        adZoneElement.style                              = 'box-shadow: 0px 0px 9px rgb(0 0 0 / 55%); text-align: center; margin: 0; padding: 0; position: fixed; display: block;border-radius: 10px;'; // TODO: display: flex; align-items: flex-end; need this to when player is not floating.
        adZoneElement.style.zIndex                       = floatingPriority;
        adZoneElement.style[heightProperty]              = heightFloating;
        adZoneElement.style.width                        = widthFloating;
        adZoneSizeContainerElement.style[heightProperty] = heightRegular;
        adZoneSizeContainerElement.style.width           = widthRegular;
        var closeButtonText                              = '&#x2715';
        var closeButtonStyle                             = `width: 16px; height: 16px; font-family: arial,helvetica,clean,sans-serif; font-size: 11px; color: white; font-weight: 700; text-transform: uppercase; z-index: ${floatingPriority}; position: absolute; top: 0; right: -16px; background: none; background-color: dimgrey; padding: 2px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; text-align: center; line-height: normal;`;

        if ('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){
            adZoneElement.style                 = 'text-align: center; margin: 0; padding: 0; position: fixed; display: block;'; 
        }

        switch(positionFloating){

            case 'bottom-right':

                if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){

                    adZoneElement.style.right           = '15px';
                    adZoneElement.style.bottom          = (ad && ad.isVideoRequestModeDisplay()) ? '38px' : '55px';
                    closeButtonStyle                    = `width: 23px; height: 23px; font-family: arial,helvetica,clean,sans-serif; font-size: 16px; color: white;  text-transform: uppercase; background: none;  outline: none; border: none; border-radius: 20px; cursor: pointer; margin: 0 0 0px; line-height: normal;position: absolute;top: 0px;right: 0px;text-shadow: 0px 0px 4px black;`;
                    adZoneElement.style[heightProperty] = `${parseInt(heightFloating)}px`; // Height of container with close button.
                }
                else{

                    adZoneElement.style.right           = (ad && ad.isVideoRequestModeDisplay()) ? '-18px' : '10px';
                    adZoneElement.style.bottom          = (ad && ad.isVideoRequestModeDisplay()) ? '-44px' : '11px';
                    closeButtonText                     = '&#x2715';
                    closeButtonStyle                    = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 40px; height: 35px; font-family: arial,helvetica,clean,sans-serif; position: absolute; font-size: 18px; top: 0px; left: 0px; color: white; font-weight: 700; text-align: center; text-transform: uppercase; z-index: ${floatingPriority}; background: none; positiion: absolute; padding: 2px 2px 3px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; line-height: normal;`;
                    // adZoneElement.style.backgroundColor = 'dimgrey';
                    adZoneElement.style[heightProperty] = `${parseInt(heightFloating)}px`; // Height of container with close button.
                }

                break;

            case 'bottom-left':

                if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){
                    adZoneElement.style.left            = '15px';
                    adZoneElement.style.bottom          = (ad && ad.isVideoRequestModeDisplay()) ? '38px' : '55px';
                    closeButtonStyle                    = `width: 23px; height: 23px; font-family: arial,helvetica,clean,sans-serif; font-size: 16px; color: white;  text-transform: uppercase; background: none;  outline: none; border: none; border-radius: 20px; cursor: pointer; margin: 0 0 0px; line-height: normal;position: absolute;top: 0px;left: 0px;text-shadow: 0px 0px 4px black;`;
                    adZoneElement.style[heightProperty] = `${parseInt(heightFloating) + 20}px`; // Height of container with close button.
                }
                else{

                    adZoneElement.style.left            = (ad && ad.isVideoRequestModeDisplay()) ? '-18px' : '10px';
                    adZoneElement.style.bottom          = (ad && ad.isVideoRequestModeDisplay()) ? '-44px' : '11px';
                    closeButtonText                     = '&#x2715';
                    closeButtonStyle                    = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 40px; height: 35px; font-family: arial,helvetica,clean,sans-serif; position: absolute; font-size: 18px; top: 0px; left: 0px; color: white; font-weight: 700; text-align: center; text-transform: uppercase; z-index: ${floatingPriority}; background: none; positiion: absolute; padding: 2px; outline: none; border: none; border-radius: 20px; cursor: pointer; margin: 0; line-height: normal;`;
                    // adZoneElement.style.backgroundColor = 'dimgrey';
                    adZoneElement.style[heightProperty] = `${parseInt(heightFloating)}px`; // Height of container with close button.
                }

                break;

            case 'bottom-middle':
                if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){
                    closeButtonStyle                       = `text-shadow: rgb(55 55 55) 0px 0px 4px;width: 30px; height: 30px; font-family: arial,helvetica,clean,sans-serif; font-size: 30px; color: white; font-weight: 700; text-transform: uppercase; z-index: ${floatingPriority}; position: absolute; top: 6px; right: -38px; background: none; background-color: none; padding: 0px; outline: none; border: none; border-radius: 0; cursor: pointer; margin: 0; text-align: center; line-height: normal;`;
                }
                adZoneElement.style.width   = '100%';
                adZoneElement.style.bottom  = '0';
                adZoneElement.style.left    = '0';

                break;

            case 'top-middle':

                adZoneElement.style.width   = '100%';
                adZoneElement.style.top     = '54px';
                adZoneElement.style.left    = '0';

                if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){

                    adZoneElement.style.padding = '.25rem 0';
                }

                break;

            case 'top-left':

                adZoneElement.style.width   = floatingOptions.widthFloating + 90 + floatingOptions.widthFloatingPostfix;
                adZoneElement.style.top     = '0';
                adZoneElement.style.left    = '0';

                if('mobile' === window.adsNinjaHeaderBiddingManager.getDeviceType()){

                    adZoneElement.style.padding = '.25rem 0';
                }

                break;
        }

        this.handleFloatingEngagedVideoPlayer(adElementId, heightFloating, widthFloating);

        // Re-enable close button if needed.
        var adCloseButtonResult = this.showCloseButton(adElementId, {
            zIndex: floatingPriority,
            text: closeButtonText,
            isUsingFakeAds: this.__isUsingFakeAds(),
            style: closeButtonStyle,
        });        

        var useCloseButton = floatingOptions['useCloseButton'];

        if(!adCloseButtonResult && useCloseButton){

            this.logger.warn(`Unable to find close button element for floating ad.`, {
                adElementId: adElementId,
            });
        }

        return true;
    },

    //
    // Toggles the close button to the desired state.
    toggleCloseButton: function(adElementId, context, style = null){

        var ad = this.__adsData[adElementId];

        if(!ad){

            this.logger.warn(`Unable to find ad unit with ad element id: ${adElementId}.`);
            return false;
        }

        var adZoneInlineElement = ad.getAdZoneInlineElement();

        if(!adZoneInlineElement){

            this.logger.warn(`Unable to find element.`, {
                adElementId: adElementId,
                element: 'adZoneInlineElement',
            });
            return false;
        }

        // Re-enable close button if needed.
        var adCloseButtonElement = adZoneInlineElement.getElementsByClassName('close-ad-zone')[0];

        if(adCloseButtonElement && null !== style){

            adCloseButtonElement.style = style;
        }

        if(adCloseButtonElement && 'show' === context){

            adCloseButtonElement.classList.add('an-close-btn-visible');
            return true;
        }
        else if(adCloseButtonElement && 'hide' === context){

            adCloseButtonElement.classList.remove('an-close-btn-visible');
            return true;
        }
        else if(!adCloseButtonElement){

//            this.logger.warn(`Unable to find close button element.`, {
//                adElementId: adElementId,
//            });

            return false;
        }
    },

    //
    // Hide close button.
    hideCloseButton: function(adElementId){

        return this.floatingDelegate.hideCloseButton(this.__adsData[adElementId]);
    },

    //
    // Show close button.
    showCloseButton: function(adElementId, options){

        return this.floatingDelegate.showCloseButton(this.__adsData[adElementId], options);
    },

    //
    // Increment counter.
    incrementRefloatCount: function(adElementId){

        this.floatingDelegate.incrementRefloatCount(adElementId);
    },

    //
    // Determine if an ad can refloat.
    canRefloat: function(adElementId, type){

        return this.floatingDelegate.canRefloat(adElementId, type);
    },

    //
    // Are bid pools enabled.
    areBidPoolsEnabled: function(){
        
        var bidManagementEnabled = this.getAdBehaviourValue('bidManagementEnabled');

        return (typeof bidManagementEnabled === 'boolean') ? bidManagementEnabled : true;
    },

    //
    // Returns requests cap outstream.
    getRequestsCapOutstream: function(){
        
        return this.getAdBehaviourValue('requestsCapOutstream') || this.MAX_NUMBER_OF_NO_NEW_BID_AUCTIONS;
    },

    __setConnectionConfig: function(data){

        if (!data['connectionType']) { //connectionType is not set
            this.__isPrebidDisabled = false;
            this.__isAdsDisabled    = false;
            return;
        }

        let connectionConfig = {};
        //if connectionConfig is not set or the connectionType index doesnt exist
        if (!data['connectionConfig'] || !data['connectionConfig'][data['connectionType']]) {
            connectionConfig['prebidDisabled'] = false;
            connectionConfig['adsDisabled'] = false;
            //connectionType = fast -> would come here and use siteConfig
            //values from siteConfig
            connectionConfig['failSafeTimeout'] = data['failSafeTimeout'] || 1500;
            connectionConfig['prebidAuctionTimeout'] = data['prebidTimeout'] || 1000;
            connectionConfig['amazonAuctionTimeout'] = data['amazonTimeout'] || 1000;
        } else {
            connectionConfig = data['connectionConfig'][data['connectionType']];
        }
        this.connectionConfig = connectionConfig;

        this.__isPrebidDisabled = connectionConfig['prebidDisabled'] || false;
        this.__isAdsDisabled    = connectionConfig['adsDisabled'] || false;
        this.__failsafeTimeout  = (connectionConfig['failSafeTimeout'] || 1500);
        this.__prebidTimeout    = (connectionConfig['prebidAuctionTimeout'] || 1000);
        this.__amazonTimeout    = (connectionConfig['amazonAuctionTimeout'] || 1000);

    },

    //
    // Sets ad behaviours.
    __setAdBehaviours: function(data){

        this.adBehaviours         = data;
        var bidManagementBidPools = this.getAdBehaviourValue('bidManagementBidPools');

        if(!bidManagementBidPools || !Array.isArray(bidManagementBidPools) || !bidManagementBidPools.length > 0){

            return;
        }

        for(var x in bidManagementBidPools){

            for(var y in bidManagementBidPools[x]){
                
                var zone                                        = bidManagementBidPools[x][y];
                this.__namesForBidPoolsByZoneName[zone['name']] = `bidPool${x}`;
            }
        }
    },

    __setBoostingUrlData: function(boostedUrlData){

        if(boostedUrlData){
            this.__boostingUrlData = boostedUrlData;
        }

    },

    __setBoostingModes: function(boostedUrlData){

        if(boostedUrlData && boostedUrlData['boostingModes'] && Array.isArray(boostedUrlData['boostingModes'])){

            for(var x in boostedUrlData['boostingModes']){

                this.__boostingModes.push(boostedUrlData['boostingModes'][x]['name']);
            }
        }
    },

    __isFloorBoostingEnabled: function(){

        if(this.__boostingUrlData && this.__boostingUrlData['boostNow'] && this.__boostingModes.indexOf('floor') !== -1){

            this.log(`Floor boosting enabled`, {
                boostingData: this.__boostingUrlData,
            });

            return true;
        }

        return false;

    },


    __isTimeOutBoostingEnabled: function(){


        if(this.__boostingUrlData && this.__boostingUrlData['boostNow'] && this.__boostingModes.indexOf('timeout') !== -1){

            this.log(`timeout boosting enabled`, {

                boostingData: this.__boostingUrlData,
            });

            return true;   
        }

        return false;

    },

    __isAdsDensitytBoostingEnabled: function(){

        if(this.__boostingUrlData && this.__boostingUrlData['boostNow'] && this.__boostingModes.indexOf('adsDensity') !== -1){

            this.log(`adsDensity boosting enabled`, {

                boostingData: this.__boostingUrlData,
            });

            return true;

        }

        return false;

    },


    setNoFillCount: function(adElementId){

        var ad = this.__adsData[adElementId];
        var originalElementId = ad.getOriginalAdElementId();

        this.__noFillCountByOrignalAd[originalElementId] = 0;
    
    },

    //
    // Returns ad behaviour value.
    getAdBehaviourValue: function(behaviour, defaultValue = null){
        
        if(!this.adBehaviours || typeof this.adBehaviours !== 'object' || Object.keys(this.adBehaviours).length === 0){

            return null;
        }

        // High value options.
        if(this.__boostingUrlData && this.__boostingUrlData['boostNow']){

            var value = this.__getHighValueAdBehaviourValue(behaviour);

            if(null !== value){

                return value;
            }
        }

        var parent = (this.adBehaviours && this.adBehaviours.hasOwnProperty('parent')) ? this.adBehaviours.parent : null;

        if(this.adBehaviours && this.adBehaviours.hasOwnProperty(behaviour) && null !== this.adBehaviours[behaviour]){

            return this.adBehaviours[behaviour];
        }
        else if(parent && parent.hasOwnProperty(behaviour) && null !== parent[behaviour]){

            return parent[behaviour];
        }

        return defaultValue;
    },

    //
    // Returns ad behaviour value.
    __getHighValueAdBehaviourValue: function(behaviour){
        
        if(!this.adBehaviours || typeof this.adBehaviours !== 'object' || Object.keys(this.adBehaviours).length === 0){

            return null;
        }

        var highValueSegmentOptions       = (this.adBehaviours.hasOwnProperty('highValueSegmentOptions')) ? this.adBehaviours.highValueSegmentOptions : null;
        var parent                        = (this.adBehaviours.hasOwnProperty('parent')) ? this.adBehaviours.parent : null;
        var parenthighValueSegmentOptions = (parent && parent.hasOwnProperty('highValueSegmentOptions')) ? parent.highValueSegmentOptions : null;

        if(highValueSegmentOptions && highValueSegmentOptions.hasOwnProperty(behaviour) && null !== highValueSegmentOptions[behaviour]){

            return highValueSegmentOptions[behaviour];
        } 
        else if(parenthighValueSegmentOptions && parenthighValueSegmentOptions.hasOwnProperty(behaviour) && null !== parenthighValueSegmentOptions[behaviour]){

            return parenthighValueSegmentOptions[behaviour];
        }

        return null;
    },

    //
    // Handle ad close button click.
    handleAdCloseButtonClick: function(event, ad){

        if(!ad || typeof ad !== 'object' || Object.keys(ad).length === 0){

            return;
        }

        var adElementId   = ad.getAdElementId();
        var adZoneElement = ad.getAdZoneElement();

        if ('sticky footer' === ad.zoneName) { 
            document.body.classList.add('an-sticky-footer-out');
            document.body.classList.remove('an-high-impact-showing');
            document.body.classList.remove('an-not-high-impact-showing');
        }

        if(!adZoneElement){

            this.logger.warn(`Unable to find element on page.`, {
                adElementId: adElementId,
                element: 'adZoneElement',
            })
            return;
        }

        // Check if click to float is enabled.
        if(ad.isClickToFloat()){

            this.floatingManager.requestToDefloat(
                adElementId, 
                'user',
                true
            );

            return;
        }
        
        adZoneElement.setAttribute('data-floating-allowed', 'false');

        var refreshingAdZone = this.refreshingAdZones[adElementId];

        // Disable waypoints.
        this.floatingDelegate.disableWaypoints(adElementId);
        
        if(refreshingAdZone){

            // Set attributes.
            refreshingAdZone.setNoFloatingAllowed();
            refreshingAdZone.setNoRefreshingAllowed();
            // Disable pixel refresher.
            refreshingAdZone.disablePixelRefresher();   
            // Remove scroll timer refresher.
            // This should always be removed and added back when needed.
            refreshingAdZone.removeScrollTimerRefresher(); 
        }

        var adElementId = ad.getAdElementId();
        var type        = (ad.hasSupportForVideoOutstream()) ? 'outstream' : 'other'; // TODO: Change when more types of refloats are allowed.
        var canRefloat  = this.floatingDelegate.canRefloat(adElementId, type);

        this.handleFloatingDisengaged(adElementId);
        this.handleFloatingDisallowedVideoPlayer(adElementId);
        
        if(canRefloat && !ad.usesVideoPlayerValstream()){

            var self           = this;
            var refloatTimeout = function(){

                self.incrementRefloatCount();
                
                if(refreshingAdZone){

                    refreshingAdZone.setNoFloatingAllowed();
                    refreshingAdZone.setNoRefreshingAllowed();
                    refreshingAdZone.enablePixelRefresher();   // Eneable pixel refresher.
                    
                    // Add back scroll timer refresher.
                    self.refreshAdElement(adElementId, 'force'); 
                }
                else{

                    self.floatingDelegate.enableWaypoints(adElementId);
                }
            };

            var floatingOptions = ad.getFloatingOptions();

            if(floatingOptions && typeof floatingOptions === 'object' && floatingOptions.hasOwnProperty('refloatDelayInMilliseconds') && floatingOptions['refloatDelayInMilliseconds']){
                
                setTimeout(refloatTimeout, floatingOptions['refloatDelayInMilliseconds']);
            }
            else{

                refloatTimeout();
            }
        }
        else if(!canRefloat && ad.canNotUseSpace() && refreshingAdZone && !ad.usesVideoPlayerValstream()){

            // Only remove everything if not using space.
            // Remove GPT reference.
            var result = refreshingAdZone.removeGptReference();

            this.logger.debug('Destroyed ad slot.', {
                didDestroy: result,
                adElementId: adElementId,
            });

            // Delete refresh container element.
            refreshingAdZone.removeRefreshContainerElementAds();
        }

        if(canRefloat){

            adZoneElement.setAttribute('data-floating-allowed', 'true');
        }

        this.logger.debug('User closed floating ad zone.', {
            adElementId: adElementId,
            floatingType: adZoneElement.getAttribute('data-floating-mode'),
            dynamicInjectionRefreshAdZoneContainerElementId: (refreshingAdZone) ? refreshingAdZone.getRefreshContainerElementId() : null,
        });
    },

    //
    // Add classes to body.
    __addClassesToBody: function(){
        
        var deviceType  = this.getDeviceType();
        var osFamily    = this.getOsFamily();
        var adModeClass = 'an-mode-a-unknown';

        switch(this.__modeAds){

            case this.MODE_ADS_REGULAR:

                adModeClass = 'an-mode-a-regular';

                break;
                
            case this.MODE_ADS_NONE:
                
                adModeClass = 'an-mode-a-none';
                
                break;
            case this.MODE_ADS_FAKE:
                
                adModeClass = 'an-mode-a-fake';
                
                break;
        }

        document.body.classList.add(`an-device-${deviceType}`, `an-os-family-${osFamily}`, adModeClass);
    },

    //
    // Get has loaded infinite article.
    getHasLoadedInfiniteArticle: function(){

        return this.__hasLoadedInfiniteArticle;
    },
    
    sendVideoPixelEvent: function(identifier, type, clientData, message = null, value = null, data = null){

        if(window.an_sn && window.an_sn.__sn !==null){
    
            window.an_sn.queue.push(function(){

                window.an_sn.__sn.sendVideoPl(identifier, type, clientData, message = null, value = null, data);
            });
        } else if(window.an_sentinel && window.an_sentinel.__sentinel !==null){

            window.an_sentinel.queue.push(function(){

                window.an_sentinel.__sentinel.sendVideoPixel(identifier, type, clientData, message = null, value = null, data);
            });
        }
        else{
            
            window.an_sn       = window.an_sn || {};
            window.an_sn.queue = window.an_sn.queue || [];
    
            window.an_sn.queue.push(function(){
    
                window.an_sn.__sn.sendVideoPl(identifier, type, clientData, message = null, value = null, data);
            });
        }
    },

    //
    // Combine all video DIVs into one array (Optimera)
    optimeraCombineScores: function() {
        let all = [];
        let seenDex = {};
        for (const [key, value] of Object.entries(window.oVs)) {
            if(!value.length){ 
                continue; 
            }
            for(var i=0; i<value.length; ++i){
                if(!seenDex[value[i]]){
                    seenDex[value[i]]=true;
                    all.push(value[i]);
                }
            }
        }
        return all;
    },

    //
    // Add global targeting.
    __addGlobalTargeting: function(){

        var self = this;

        window.googletag.cmd.push(function(){
            // Set global targeting.
            window.googletag.pubads().setTargeting('loginToContinue', self.getIsLoginToContinue());
            window.googletag.pubads().setTargeting('ad_block_converted', self.isAdBlockConverted());
        });
    },

    //
    // Register GAM ad event listeners.
    __registerGAMAdEventListeners: function(){
        
        var self = this;
        var hasSlotBeenRequested = false;
        var hasSlotBeenRendered = false;

        setTimeout(function(){
            if(!hasSlotBeenRequested){
                if(window.websiteSentinel){
                    window.websiteSentinel.sendEvent('ads_behaviour', 'no_ads_request', 1);
                }
            }
            if(!hasSlotBeenRendered){
                if(window.websiteSentinel){
                    window.websiteSentinel.sendEvent('ads_behaviour', 'no_ads_rendered', 1);
                }
            }
        }, 10000);

        window.googletag.cmd.push(function(){

            window.googletag.pubads().addEventListener('slotResponseReceived', function(event){
                self.addBiddingProcessTracking('ad_render', 'start', event.slot.getSlotElementId());
                self.addBiddingProcessTracking('gam_auction_response', 'end', event.slot.getSlotElementId());
                
                self.logAdUnitEvent(event.slot.getSlotElementId(), '2. GAM Slot Response Received');
            });

            window.googletag.pubads().addEventListener('slotRenderEnded', function(){
                hasSlotBeenRendered = true;
            });
            
            window.googletag.pubads().addEventListener('slotRequested', function(event){
                hasSlotBeenRequested = true;
                self.addBiddingProcessTracking('gam_auction_response', 'start', event.slot.getSlotElementId());
                
                let prebid_bid_response_end = window.adsNinjaHeaderBiddingManager.getBiddingProccessTracking('prebid_bid_response', 'end');
                let amazon_bid_response_end = window.adsNinjaHeaderBiddingManager.getBiddingProccessTracking('amazon_bid_response', 'end');
                let time = prebid_bid_response_end
                if (prebid_bid_response_end === null || prebid_bid_response_end < amazon_bid_response_end) {
                    time = amazon_bid_response_end;
                }

                //check document hidden delay 
                let documentHiddenBeforeRefresh = window.adsNinjaHeaderBiddingManager.getBiddingProccessTracking('documentHiddenBeforeRefresh', 'start');
                if (documentHiddenBeforeRefresh !== null) {
                    let current_time = performance.now();
                    let delay = current_time - documentHiddenBeforeRefresh;
                    self.addBiddingProcessTracking('gam_auction_request', 'delay', event.slot.getSlotElementId(), null, delay);
                }

                self.addBiddingProcessTracking('gam_auction_request', 'start', event.slot.getSlotElementId(), null, time);
                self.addBiddingProcessTracking('gam_auction_request', 'end', event.slot.getSlotElementId());

                self.logAdUnitEvent(event.slot.getSlotElementId(), '1. GAM Slot Requested');
            });
        });
    },

    getBiddingProccessTracking: function(eventName, key) {

        return ((this.biddingProccessTrackingData[eventName] !== undefined && typeof this.biddingProccessTrackingData[eventName][key] !== 'undefined') ? this.biddingProccessTrackingData[eventName][key] : null);
    },

    addBiddingProcessTracking: function(event, key, adElementId = null, auctionId = null, time = null) {
        if (this.getBrandName() === 'TheGamer') {
            if (auctionId == null) {
                if (adElementId == null) {
                    return;
                }
                auctionId = this.__getLatestAuctionId(adElementId);
            }

            if (auctionId !== 'onPageLoad') {
                return;
            }

            let eventName = event;
            if (adElementId !== null) {
                eventName = event + '_' + adElementId;
            }            

            this.biddingProccessTrackingData[eventName] = this.biddingProccessTrackingData[eventName] || {};

            if (adElementId !== null) {
                this.biddingProccessTrackingData[eventName]['adElementId'] = adElementId;
            }

            if (time === null) {
                time = performance.now();
            }

            this.biddingProccessTrackingData[eventName][key] = time;

            if (key === 'end') {
                this.sendBiddingProccessEventToGA(event, adElementId);
            }
        }
    },

    sendBiddingProccessEventToGA: function(event, adElementId) {
        if (this.getBrandName() === 'TheGamer') {
            let intervalId = setInterval(() => {
                let eventName = event;
                if (adElementId !== null) {
                    eventName = event + '_' + adElementId;
                }

                if (this.getBiddingProccessTracking(eventName, 'start') === null || this.getBiddingProccessTracking(eventName, 'end') ===  null) {
                    //only send when both are set 
                    return;
                }

                let time = this.biddingProccessTrackingData[eventName]['end'] - this.biddingProccessTrackingData[eventName]['start'];
                let parameters = this.biddingProccessTrackingData[eventName];

                if (this.biddingProccessTrackingData[eventName]['delay']) {
                    time = time - this.biddingProccessTrackingData[eventName]['delay'];
                }

                parameters['ad_step_fired_time'] = time.toFixed() + 'ms';
                parameters['ad_step_fired_timestamp'] = Date.now();

                this.sendGAEvent(event, parameters);
                clearInterval(intervalId);
            }, 500);
        }
    },

    //send a event to GA
    sendGAEvent: function(eventName, parameters){
        // window.gtag('event', eventName, parameters);
    },

    //
    // Log ad unit event.
    logAdUnitEvent(adElementId, event){
        
        var ad = this.getAdsData(adElementId);

        // Check if ad exists.
        if(!ad){

            return;
        }

        // Get latest auction ID.
        var auctionId = this.__getLatestAuctionId(adElementId);

        // Only log if auction ID is "onPageLoad".
        if(!auctionId || 'onPageLoad' !== auctionId){

            return;
        }

        this.auctions[auctionId].logAdUnitEvent(adElementId, event, Date.now());
    },

    //
    // Get ad unit slot details.
    getAdUnitSlotDetails: function(headerBiddingLibrary, adUnitCode){

        if(!this.__adUnitSlotDetails.hasOwnProperty(headerBiddingLibrary) || !this.__adUnitSlotDetails[headerBiddingLibrary]){

            return null;
        }

        return this.__adUnitSlotDetails[headerBiddingLibrary][adUnitCode] || null;
    },

    //
    // Blacklist video creative id.
    blacklistVideoCreative: function(creativeId){
        if (creativeId) {

            this.__videoCreativeBlacklist.push(String(creativeId));
        }
    },

    //
    // Blacklist video bidder.
    blacklistVideoBidder: function(bidder){
        if (bidder) {

            this.__videoBidderBlacklist.push(String(bidder));
        }
    },

    //
    // Get an amazon bid from the apstag state.
    getAmazonBidFromState: function(amzniid) {
      var amazonBid;
      try {
        if (window?.apstag?.debug) {
          var state = window.apstag.debug('getState');
          Object.keys(state.slotBids).find((slotId) => {
            var bid = state.slotBids[slotId].find((bid) => bid.bidConfig.amzniid === amzniid);
            if (bid) {
              amazonBid = bid;
              return true;
            }
            return false;
          })
        }
      } catch(e) {/* ignore */}
      return amazonBid;
    },

    //
    // Is allowed to float.
    isAllowedToFloat: function(adElementId){

        var refreshingAdZone = this.refreshingAdZones[adElementId];
        
        if(!refreshingAdZone){

            return true;
        }

        var refreshContainerElement = refreshingAdZone.getRefreshContainerElement();

        if(!refreshContainerElement){

            return true;
        }

        return ('true' === refreshContainerElement.getAttribute('data-floating-allowed'));
    },

    //
    // Get floating info for request.
    getFloatingInfoForRequest: function(adElementId){

        var zone         = window.adsNinja.zoneDelegate.getByElementId(adElementId);
        var ad           = this.getAdsData(adElementId);
        var returnResult = {
            elementId: adElementId,
            originalElementId: (zone) ? zone.getOriginalUnitElementId() : adElementId,
            adType: null,
            position: null,
            floatType: null,
            requestor: 'system',
        };

        if(!ad){

            return returnResult;
        }

        var floatingOptions    = ad.getFloatingOptions();        
        var videoOptions       = ad.getVideoSettings();      // TODO: We need an ad unit type.
        returnResult.adType    = (!videoOptions) ? window.AdsNinjaFloatingManager.prototype.AD_TYPE_BANNER : window.AdsNinjaFloatingManager.prototype.AD_TYPE_VIDEO;
        returnResult.requestor = (videoOptions && videoOptions.hasOwnProperty('context') && videoOptions.context.hasOwnProperty('name') && ('instream' === videoOptions['context']['name'] || 'accompanying' === videoOptions['context']['name'])) ? 'user' : 'system';
        returnResult.position  = (floatingOptions && floatingOptions['position']) ? floatingOptions['position'] : null;
        returnResult.floatType = (floatingOptions && floatingOptions['floatingMode']) ? floatingOptions['floatingMode'] : null;

        return returnResult;
    },

    //
    // Float request callback.
    requestFloatCallback: function(adElementId, context = null){

        this.initFloatingIfNotAleadyInitialized(adElementId);

        var returnResult = this.toggleFloatingAdZone(adElementId, true);

        if(returnResult && 'resume' === context){

            var controlResult = window.adsNinja.playIfVideo(adElementId);

            if(!controlResult){

                this.logger.warn('Failed to play video ad after floating. This may result in a broken UI. Please check the browser console for more information.');
            }
        }

        return returnResult;
    },

    //
    // Defloat request callback.
    requestDefloatCallback: function(adElementId, context = null){

        var returnResult = this.toggleFloatingAdZone(adElementId, false);

        if(returnResult && 'suspend' === context){

            var controlResult = window.adsNinja.pauseIfVideo(adElementId);

            if(!controlResult){

                this.logger.warn('Failed to pause video ad after defloating. This may result in a broken UI. Please check the browser console for more information.');
            }
        }

        return returnResult;
    },

    //
    // Get outstream video player elements.
    getOutstreamVideoPlayerElements: function(){
          
        var returnResult = [];

        if(!this.__adsData || typeof this.__adsData !== 'object' || Object.keys(this.__adsData).length === 0){

            return returnResult;
        }

        for(var adElementId in this.__adsData){

            if((this.__adsData[adElementId].hasSupportForVideoOutstream() && this.__adsData[adElementId].isFloatingModeAlways()) || this.__adsData[adElementId].hasSupportForVideoCompanion()){

                returnResult.push(adElementId);
            }
        }

        return returnResult;
    },

    //
    // Initialize floating if not already initialized.
    initFloatingIfNotAleadyInitialized: function(adElementId){

        if(!this.floatingInitializers || !this.floatingInitializers.hasOwnProperty(adElementId) || !this.floatingInitializers[adElementId] || typeof this.floatingInitializers[adElementId] !== 'function'){

            return;
        }

        this.floatingInitializers[adElementId]();
        delete this.floatingInitializers[adElementId];
    },

    //
    // Eneable floating if allowed.
    enableFloating: function(adElementId){

        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);

        if(!floatingInfoForRequest.adType){

            return false;
        }

        this.floatingManager.enableElement(adElementId, 'user', floatingInfoForRequest.adType, floatingInfoForRequest.position, floatingInfoForRequest.floatType);

        return true;
    },

    //
    // Disable floating if allowed.
    determineCustomAdUnitCode: function(adElementId){

        var ad = this.getAdsData(adElementId);

        if(!ad || !ad.hasOwnProperty('zoneName') || !ad.zoneName || !ad.hasOwnProperty('zoneGroupName') || !ad.zoneGroupName){

            return null;
        }
        
        var key = ad.zoneGroupName + ':' + ad.zoneName;

        return key.replaceAll(' ', '_');
    },

    getMobileOperatingSystem: function() {

        if(typeof navigator !== 'object') return 'unknown'; 

        var userAgent = navigator.userAgent || window.opera;
    
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
    
        if (/android/i.test(userAgent)) {
            return "Android";
        }
    
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
    
        return "unknown";
    },

    getNetworkCodeFromGAMPath: function(gamPath) {

        if(!gamPath || typeof gamPath !== 'string') return null;

        var pattern = /\d+/g;

        var networkCodes = gamPath.match(pattern);

        if(!networkCodes || networkCodes.length === 0) return null;

        return networkCodes[0];
    },

    /**
     * Determines if GAM won.
     * 
     * @param {Object} ad 
     * @param {number} creativeId 
     * @returns {boolean}
     */
    handleGAMWon: function(ad, creativeId){

        if(!ad || !creativeId){

            this.logger.warn('Unable to determine if GAM won. No ad or creative id provided.');
            return false;
        }

        if(!ad.zoneName || 'sticky footer' !== ad.zoneName || -1 === [138539163199, 138538525184, 138538573281, 138538573182].indexOf(creativeId)){

            return false;
        }

        this.__handleHighImpactAd('kargo');

        return true;
    },

    isPrimeGeo: function(geo){

        if(!geo || typeof geo !== 'string'){

            geo = this.getGeo();
        }

        return (this.__primeGeos.hasOwnProperty(geo));
    },

    /**
     * Handle floating out of view.
     * 
     * @param {string} adElementId 
     * @returns 
     */
    __handleFloatingOutOfView: function(adElementId){

        var zone = window.adsNinja.zoneDelegate.getByElementId(adElementId);

        if(!zone || 'sticky header' !== zone.getName() || !zone.canFloat() || zone.isInView()){

            return;
        }

        var floatingInfoForRequest = this.getFloatingInfoForRequest(adElementId);

        this.floatingManager.requestToFloat(
            adElementId, 
            floatingInfoForRequest.requestor,
            floatingInfoForRequest.adType, 
            floatingInfoForRequest.position, 
            floatingInfoForRequest.floatType, 
            this.requestFloatCallback.bind(this, adElementId),
            this.requestDefloatCallback.bind(this, adElementId)
        );
    },
    __resolvePrebidVastCache: async function(vastUrl, vastXml, adElementId, logger) {
        if (vastUrl && vastUrl.startsWith('blob:')) {
            try {
                var response = await fetch(vastUrl);
                var blobContent = await response.text();
                vastXml = blobContent;
                vastUrl = 'data://text/xml;base64,' + btoa(blobContent);
            } catch (e) {
                logger.warn('Failed to resolve blob URL for in-banner video', {
                    adElementId: adElementId,
                    error: e,
                });
            }
        } else if (!vastUrl && vastXml) {
            vastUrl = 'data://text/xml;base64,' + btoa(vastXml);
        }

        return { vastUrl, vastXml };
    },

    /**
     * Start refresh timers.
     * 
     * @param {array} divIds - The div IDs.
     */
    __startRefreshTimers: function(divIds){

        if(!divIds || typeof divIds !== 'object' || Object.keys(divIds).length === 0){

            return;
        }

        for(const adElementId of divIds){

            var refreshingAdZone = this.refreshingAdZones[adElementId];

            if(!refreshingAdZone || !refreshingAdZone.hasTimerRefresh()){

                continue;
            }
    
            this.initAdZoneEventsLogEntryIfNeeded(adElementId);

            var minimumTimeBuffer = refreshingAdZone.getMinimumTimeBuffer();

            if(minimumTimeBuffer){

                // Needs to be expressed in milliseconds.
                minimumTimeBuffer = Number(minimumTimeBuffer) * 1000;

                var minTimer = setTimeout(function(){

                    window.adsNinjaHeaderBiddingManager.handleAdZoneMinimumTimerCompleteEvent(adElementId);
                }, minimumTimeBuffer);

                this.addRefreshTimeout(adElementId, minTimer);
            }

            var timeBuffer = refreshingAdZone.getTimeBuffer();

            if(timeBuffer){

                // Needs to be expressed in milliseconds.
                timeBuffer = Number(timeBuffer) * 1000;

                var refreshTimer = setTimeout(function(){

                    // TODO: Fix get current refresh count.
                    window.adsNinjaHeaderBiddingManager.handleAdZoneTimerCompleteEvent(adElementId);
                }, timeBuffer);

                this.addRefreshTimeout(adElementId, refreshTimer);
            }

            this.adZoneEventsLog[adElementId]['haveTimersStarted'] = true;
        }
    },
};
